{
 "version": 1,
 "levels": [
  {
   "level": 1,
   "name": "Niveau 1",
   "cefr": "A1–A2",
   "descRu": "Короткие простые фразы"
  },
  {
   "level": 2,
   "name": "Niveau 2",
   "cefr": "A2–B1",
   "descRu": "Бытовые предложения подлиннее"
  },
  {
   "level": 3,
   "name": "Niveau 3",
   "cefr": "B1",
   "descRu": "Сложные предложения, инверсия"
  },
  {
   "level": 4,
   "name": "Niveau 4",
   "cefr": "B2–C1",
   "descRu": "Формальный и абстрактный язык"
  }
 ],
 "exercises": [
  {
   "id": "l1-001",
   "level": 1,
   "text": "Ik ___ gisteren thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера остался дома."
  },
  {
   "id": "l1-002",
   "level": 1,
   "text": "Hij ___ de hele avond tv gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Он ___ весь вечер смотрел телевизор."
  },
  {
   "id": "l1-003",
   "level": 1,
   "text": "Wij ___ naar Amsterdam gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Амстердам."
  },
  {
   "id": "l1-004",
   "level": 1,
   "text": "Zij ___ een nieuwe fiets gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новый велосипед."
  },
  {
   "id": "l1-005",
   "level": 1,
   "text": "Ik ___ gisteren veel gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Я ___ вчера много плавал."
  },
  {
   "id": "l1-006",
   "level": 1,
   "text": "Hij ___ om acht uur naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ в восемь часов пошёл в школу."
  },
  {
   "id": "l1-007",
   "level": 1,
   "text": "Wij ___ lekker gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вкусно поели."
  },
  {
   "id": "l1-008",
   "level": 1,
   "text": "Zij ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать."
  },
  {
   "id": "l1-009",
   "level": 1,
   "text": "Ik ___ mijn huiswerk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ сделал домашнее задание."
  },
  {
   "id": "l1-010",
   "level": 1,
   "text": "Jullie ___ gisteren thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ вчера остались дома."
  },
  {
   "id": "l1-011",
   "level": 1,
   "text": "Hij ___ naar de winkel gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл в магазин пешком."
  },
  {
   "id": "l1-012",
   "level": 1,
   "text": "Wij ___ een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ посмотрели фильм."
  },
  {
   "id": "l1-013",
   "level": 1,
   "text": "Ik ___ om zeven uur opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ встал в семь часов."
  },
  {
   "id": "l1-014",
   "level": 1,
   "text": "Zij ___ een kop koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Она ___ выпила чашку кофе."
  },
  {
   "id": "l1-015",
   "level": 1,
   "text": "Hij ___ naar Rotterdam gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Роттердам."
  },
  {
   "id": "l1-016",
   "level": 1,
   "text": "Wij ___ veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ сделали много фотографий."
  },
  {
   "id": "l1-017",
   "level": 1,
   "text": "Ik ___ de hele dag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Я ___ работал весь день."
  },
  {
   "id": "l1-018",
   "level": 1,
   "text": "Zij ___ laat aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала поздно."
  },
  {
   "id": "l1-019",
   "level": 1,
   "text": "Jullie ___ een pizza gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ съели пиццу."
  },
  {
   "id": "l1-020",
   "level": 1,
   "text": "Hij ___ naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал домой на велосипеде."
  },
  {
   "id": "l1-021",
   "level": 1,
   "text": "Ik ___ gisteren een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера прочитал книгу."
  },
  {
   "id": "l1-022",
   "level": 1,
   "text": "Wij ___ naar het park gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в парк."
  },
  {
   "id": "l1-023",
   "level": 1,
   "text": "Zij ___ veel Nederlands geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Она ___ многому научилась по-голландски."
  },
  {
   "id": "l1-024",
   "level": 1,
   "text": "Hij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ уехал рано."
  },
  {
   "id": "l1-025",
   "level": 1,
   "text": "Ik ___ mijn kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ убрал свою комнату."
  },
  {
   "id": "l1-026",
   "level": 1,
   "text": "Jullie ___ naar school gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в школу на велосипеде."
  },
  {
   "id": "l1-027",
   "level": 1,
   "text": "Zij ___ een mooie foto gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ сделала красивую фотографию."
  },
  {
   "id": "l1-028",
   "level": 1,
   "text": "Hij ___ de hele dag thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ оставался дома весь день."
  },
  {
   "id": "l1-029",
   "level": 1,
   "text": "Wij ___ een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили долгую прогулку."
  },
  {
   "id": "l1-030",
   "level": 1,
   "text": "Ik ___ om tien uur thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ пришёл домой в десять часов."
  },
  {
   "id": "l1-031",
   "level": 1,
   "text": "Hij ___ een brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Он ___ написал письмо."
  },
  {
   "id": "l1-032",
   "level": 1,
   "text": "Zij ___ naar China gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в Китай."
  },
  {
   "id": "l1-033",
   "level": 1,
   "text": "Ik ___ veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Я ___ выпил много воды."
  },
  {
   "id": "l1-034",
   "level": 1,
   "text": "Wij ___ gisteren laat begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ вчера начали поздно."
  },
  {
   "id": "l1-035",
   "level": 1,
   "text": "Jullie ___ een nieuwe auto gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Вы ___ купили новую машину."
  },
  {
   "id": "l1-036",
   "level": 1,
   "text": "Hij ___ naar de dokter gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл к врачу."
  },
  {
   "id": "l1-037",
   "level": 1,
   "text": "Ik ___ mijn vriend gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ позвонил своему другу."
  },
  {
   "id": "l1-038",
   "level": 1,
   "text": "Zij ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Она ___ ждала час."
  },
  {
   "id": "l1-039",
   "level": 1,
   "text": "Wij ___ met de trein naar Utrecht gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Утрехт на поезде."
  },
  {
   "id": "l1-040",
   "level": 1,
   "text": "Hij ___ een boterham gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ съел бутерброд."
  },
  {
   "id": "l1-041",
   "level": 1,
   "text": "Ik ___ gisteren vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Я ___ вчера рано проснулся."
  },
  {
   "id": "l1-042",
   "level": 1,
   "text": "Zij ___ veel muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geluisterd",
   "rule": "default-hebben",
   "translationRu": "Она ___ слушала много музыки."
  },
  {
   "id": "l1-043",
   "level": 1,
   "text": "Wij ___ naar het strand gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали на пляж."
  },
  {
   "id": "l1-044",
   "level": 1,
   "text": "Hij ___ zijn tas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свою сумку."
  },
  {
   "id": "l1-045",
   "level": 1,
   "text": "Jullie ___ lang in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Вы ___ долго сидели в саду."
  },
  {
   "id": "l1-046",
   "level": 1,
   "text": "Ik ___ naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в супермаркет."
  },
  {
   "id": "l1-047",
   "level": 1,
   "text": "Zij ___ een taart gebakken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebakken",
   "rule": "transitief",
   "translationRu": "Она ___ испекла торт."
  },
  {
   "id": "l1-048",
   "level": 1,
   "text": "Hij ___ snel naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ быстро пошёл домой."
  },
  {
   "id": "l1-049",
   "level": 1,
   "text": "Wij ___ veel plezier gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "default-hebben",
   "translationRu": "Мы ___ получили много удовольствия."
  },
  {
   "id": "l1-050",
   "level": 1,
   "text": "Ik ___ de deur gesloten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesloten",
   "rule": "transitief",
   "translationRu": "Я ___ закрыл дверь."
  },
  {
   "id": "l1-051",
   "level": 1,
   "text": "Hij ___ naar Frankrijk gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ улетел во Францию."
  },
  {
   "id": "l1-052",
   "level": 1,
   "text": "Zij ___ een nieuwe jurk gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новое платье."
  },
  {
   "id": "l1-053",
   "level": 1,
   "text": "Ik ___ gisteren ziek geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера был болен."
  },
  {
   "id": "l1-054",
   "level": 1,
   "text": "Wij ___ samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вместе выпили кофе."
  },
  {
   "id": "l1-055",
   "level": 1,
   "text": "Jullie ___ vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ рано пошли домой."
  },
  {
   "id": "l1-056",
   "level": 1,
   "text": "Hij ___ zijn sleutel gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл свой ключ."
  },
  {
   "id": "l1-057",
   "level": 1,
   "text": "Ik ___ de bus genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Я ___ поехал на автобусе."
  },
  {
   "id": "l1-058",
   "level": 1,
   "text": "Zij ___ op de bank gaan zitten.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "zitten",
   "rule": "groeps-inf",
   "translationRu": "Она ___ пошла сесть на скамейку."
  },
  {
   "id": "l1-059",
   "level": 1,
   "text": "Wij ___ een mooie vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-060",
   "level": 1,
   "text": "Hij ___ de hele nacht geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ проспал всю ночь."
  },
  {
   "id": "l1-061",
   "level": 1,
   "text": "Ik ___ gisteren naar de bioscoop gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ходил в кино."
  },
  {
   "id": "l1-062",
   "level": 1,
   "text": "Zij ___ een interessant boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Она ___ прочитала интересную книгу."
  },
  {
   "id": "l1-063",
   "level": 1,
   "text": "Wij ___ om zes uur thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ пришли домой в шесть часов."
  },
  {
   "id": "l1-064",
   "level": 1,
   "text": "Hij ___ zijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ убрал свою комнату."
  },
  {
   "id": "l1-065",
   "level": 1,
   "text": "Jullie ___ naar het museum geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ сходили в музей."
  },
  {
   "id": "l1-066",
   "level": 1,
   "text": "Ik ___ veel Nederlands gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken",
   "rule": "default-hebben",
   "translationRu": "Я ___ много говорил по-голландски."
  },
  {
   "id": "l1-067",
   "level": 1,
   "text": "Zij ___ naar een andere stad verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другой город."
  },
  {
   "id": "l1-068",
   "level": 1,
   "text": "Hij ___ zijn telefoon verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял свой телефон."
  },
  {
   "id": "l1-069",
   "level": 1,
   "text": "Wij ___ een lekkere lunch gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ вкусно поели на обед."
  },
  {
   "id": "l1-070",
   "level": 1,
   "text": "Ik ___ de hele middag thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ оставался дома весь день."
  },
  {
   "id": "l1-071",
   "level": 1,
   "text": "Zij ___ naar Spanje gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в Испанию."
  },
  {
   "id": "l1-072",
   "level": 1,
   "text": "Hij ___ een mooie tekening gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал красивый рисунок."
  },
  {
   "id": "l1-073",
   "level": 1,
   "text": "Ik ___ mijn moeder geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог маме."
  },
  {
   "id": "l1-074",
   "level": 1,
   "text": "Wij ___ vroeg begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ начали рано."
  },
  {
   "id": "l1-075",
   "level": 1,
   "text": "Jullie ___ naar het station gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли на станцию пешком."
  },
  {
   "id": "l1-076",
   "level": 1,
   "text": "Zij ___ een cadeau gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ получила подарок."
  },
  {
   "id": "l1-077",
   "level": 1,
   "text": "Hij ___ in Nederland geboren.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geboren",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ родился в Нидерландах."
  },
  {
   "id": "l1-078",
   "level": 1,
   "text": "Ik ___ gisteren veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ вчера многому научился."
  },
  {
   "id": "l1-079",
   "level": 1,
   "text": "Wij ___ naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вышли наружу."
  },
  {
   "id": "l1-080",
   "level": 1,
   "text": "Zij ___ haar jas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ забыла своё пальто."
  },
  {
   "id": "l1-081",
   "level": 1,
   "text": "Hij ___ een uur gefietst.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-duur",
   "translationRu": "Он ___ час ездил на велосипеде."
  },
  {
   "id": "l1-082",
   "level": 1,
   "text": "Ik ___ naar mijn werk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Я ___ поехал на работу."
  },
  {
   "id": "l1-083",
   "level": 1,
   "text": "Wij ___ veel gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Мы ___ много поели."
  },
  {
   "id": "l1-084",
   "level": 1,
   "text": "Zij ___ om twaalf uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала в двенадцать часов."
  },
  {
   "id": "l1-085",
   "level": 1,
   "text": "Jullie ___ een leuke dag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Вы ___ хорошо провели день."
  },
  {
   "id": "l1-086",
   "level": 1,
   "text": "Hij ___ een glas melk gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Он ___ выпил стакан молока."
  },
  {
   "id": "l1-087",
   "level": 1,
   "text": "Ik ___ naar mijn vriendin gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл к подруге."
  },
  {
   "id": "l1-088",
   "level": 1,
   "text": "Wij ___ thuisgebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgebleven",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ остались дома."
  },
  {
   "id": "l1-089",
   "level": 1,
   "text": "Zij ___ een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла новую работу."
  },
  {
   "id": "l1-090",
   "level": 1,
   "text": "Hij ___ vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Он ___ рано проснулся."
  },
  {
   "id": "l1-091",
   "level": 1,
   "text": "Ik ___ gisteren naar Zwolle gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера поехал в Зволле."
  },
  {
   "id": "l1-092",
   "level": 1,
   "text": "Zij ___ veel gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Она ___ много плавала."
  },
  {
   "id": "l1-093",
   "level": 1,
   "text": "Wij ___ in China geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ побывали в Китае."
  },
  {
   "id": "l1-094",
   "level": 1,
   "text": "Hij ___ veel gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedaan",
   "rule": "default-hebben",
   "translationRu": "Он ___ много сделал."
  },
  {
   "id": "l1-095",
   "level": 1,
   "text": "Jullie ___ naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в супермаркет."
  },
  {
   "id": "l1-096",
   "level": 1,
   "text": "Ik ___ een lange brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ написал длинное письмо."
  },
  {
   "id": "l1-097",
   "level": 1,
   "text": "Zij ___ laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ поздно пришла домой."
  },
  {
   "id": "l1-098",
   "level": 1,
   "text": "Wij ___ een mooie wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили красивую прогулку."
  },
  {
   "id": "l1-099",
   "level": 1,
   "text": "Hij ___ naar Duitsland gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Германию."
  },
  {
   "id": "l1-100",
   "level": 1,
   "text": "Ik ___ gisteren de hele dag gewerkt",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера работал весь день."
  },
  {
   "id": "l1-101",
   "level": 1,
   "text": "Ik ___ vanochtend vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ сегодня утром рано встал."
  },
  {
   "id": "l1-102",
   "level": 1,
   "text": "Hij ___ zijn ontbijt gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ позавтракал."
  },
  {
   "id": "l1-103",
   "level": 1,
   "text": "Wij ___ naar het station gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли на станцию."
  },
  {
   "id": "l1-104",
   "level": 1,
   "text": "Zij ___ een e-mail gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Она ___ отправила электронное письмо."
  },
  {
   "id": "l1-105",
   "level": 1,
   "text": "Ik ___ de hele middag thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ оставался дома весь день."
  },
  {
   "id": "l1-106",
   "level": 1,
   "text": "Hij ___ naar zijn werk gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал на работу на велосипеде."
  },
  {
   "id": "l1-107",
   "level": 1,
   "text": "Wij ___ een kop thee gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Мы ___ выпили чашку чая."
  },
  {
   "id": "l1-108",
   "level": 1,
   "text": "Zij ___ om negen uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала в девять часов."
  },
  {
   "id": "l1-109",
   "level": 1,
   "text": "Ik ___ mijn tanden gepoetst.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gepoetst",
   "rule": "transitief",
   "translationRu": "Я ___ почистил зубы."
  },
  {
   "id": "l1-110",
   "level": 1,
   "text": "Jullie ___ naar België gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Бельгию."
  },
  {
   "id": "l1-111",
   "level": 1,
   "text": "Hij ___ een krant gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал газету."
  },
  {
   "id": "l1-112",
   "level": 1,
   "text": "Wij ___ in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ сидели в саду."
  },
  {
   "id": "l1-113",
   "level": 1,
   "text": "Zij ___ naar de winkel gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в магазин пешком."
  },
  {
   "id": "l1-114",
   "level": 1,
   "text": "Ik ___ mijn kamer geschilderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschilderd",
   "rule": "transitief",
   "translationRu": "Я ___ покрасил свою комнату."
  },
  {
   "id": "l1-115",
   "level": 1,
   "text": "Hij ___ vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ рано пошёл домой."
  },
  {
   "id": "l1-116",
   "level": 1,
   "text": "Wij ___ een leuke film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ посмотрели хороший фильм."
  },
  {
   "id": "l1-117",
   "level": 1,
   "text": "Zij ___ haar vriend opgebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgebeld",
   "rule": "transitief",
   "translationRu": "Она ___ позвонила своему другу."
  },
  {
   "id": "l1-118",
   "level": 1,
   "text": "Ik ___ gisteren ziek geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера был болен."
  },
  {
   "id": "l1-119",
   "level": 1,
   "text": "Jullie ___ naar het strand gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли на пляж."
  },
  {
   "id": "l1-120",
   "level": 1,
   "text": "Hij ___ een appel gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ съел яблоко."
  },
  {
   "id": "l1-121",
   "level": 1,
   "text": "Wij ___ lang gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "default-hebben",
   "translationRu": "Мы ___ долго ждали."
  },
  {
   "id": "l1-122",
   "level": 1,
   "text": "Zij ___ naar Londen gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ улетела в Лондон."
  },
  {
   "id": "l1-123",
   "level": 1,
   "text": "Ik ___ mijn sleutel verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Я ___ потерял свой ключ."
  },
  {
   "id": "l1-124",
   "level": 1,
   "text": "Hij ___ de hele dag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ работал весь день."
  },
  {
   "id": "l1-125",
   "level": 1,
   "text": "Wij ___ om vijf uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ уехали в пять часов."
  },
  {
   "id": "l1-126",
   "level": 1,
   "text": "Zij ___ een mooie foto gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла красивую фотографию."
  },
  {
   "id": "l1-127",
   "level": 1,
   "text": "Ik ___ naar de bibliotheek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в библиотеку."
  },
  {
   "id": "l1-128",
   "level": 1,
   "text": "Hij ___ veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Он ___ выпил много воды."
  },
  {
   "id": "l1-129",
   "level": 1,
   "text": "Jullie ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ остались дома."
  },
  {
   "id": "l1-130",
   "level": 1,
   "text": "Wij ___ een taart gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ приготовили торт."
  },
  {
   "id": "l1-131",
   "level": 1,
   "text": "Zij ___ naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в школу."
  },
  {
   "id": "l1-132",
   "level": 1,
   "text": "Ik ___ een interessant boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ прочитал интересную книгу."
  },
  {
   "id": "l1-133",
   "level": 1,
   "text": "Hij ___ zijn fiets gewassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewassen",
   "rule": "transitief",
   "translationRu": "Он ___ помыл свой велосипед."
  },
  {
   "id": "l1-134",
   "level": 1,
   "text": "Wij ___ laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ поздно пришли домой."
  },
  {
   "id": "l1-135",
   "level": 1,
   "text": "Zij ___ met de bus gereisd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereisd",
   "rule": "beweging-duur",
   "translationRu": "Она ___ ехала на автобусе."
  },
  {
   "id": "l1-136",
   "level": 1,
   "text": "Ik ___ mijn moeder geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог маме."
  },
  {
   "id": "l1-137",
   "level": 1,
   "text": "Hij ___ naar de dokter geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ ходил к врачу."
  },
  {
   "id": "l1-138",
   "level": 1,
   "text": "Jullie ___ een groot huis gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Вы ___ купили большой дом."
  },
  {
   "id": "l1-139",
   "level": 1,
   "text": "Wij ___ in het park gewandeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ гуляли в парке."
  },
  {
   "id": "l1-140",
   "level": 1,
   "text": "Zij ___ vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Она ___ рано проснулась."
  },
  {
   "id": "l1-141",
   "level": 1,
   "text": "Ik ___ een brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ написал письмо."
  },
  {
   "id": "l1-142",
   "level": 1,
   "text": "Hij ___ naar Italië gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Италию."
  },
  {
   "id": "l1-143",
   "level": 1,
   "text": "Wij ___ samen gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Мы ___ поели вместе."
  },
  {
   "id": "l1-144",
   "level": 1,
   "text": "Zij ___ haar tas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ забыла свою сумку."
  },
  {
   "id": "l1-145",
   "level": 1,
   "text": "Ik ___ de hele nacht geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Я ___ проспал всю ночь."
  },
  {
   "id": "l1-146",
   "level": 1,
   "text": "Hij ___ naar Amsterdam gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Амстердам."
  },
  {
   "id": "l1-147",
   "level": 1,
   "text": "Jullie ___ veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gemaakt",
   "rule": "default-hebben",
   "translationRu": "Вы ___ сделали много фотографий."
  },
  {
   "id": "l1-148",
   "level": 1,
   "text": "Wij ___ thuisgebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgebleven",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ остались дома."
  },
  {
   "id": "l1-149",
   "level": 1,
   "text": "Zij ___ een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла новую работу."
  },
  {
   "id": "l1-150",
   "level": 1,
   "text": "Ik ___ naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вышел наружу."
  },
  {
   "id": "l1-151",
   "level": 1,
   "text": "Hij ___ een glas water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Он ___ выпил стакан воды."
  },
  {
   "id": "l1-152",
   "level": 1,
   "text": "Wij ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ ждали час."
  },
  {
   "id": "l1-153",
   "level": 1,
   "text": "Zij ___ naar Frankrijk verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала во Францию."
  },
  {
   "id": "l1-154",
   "level": 1,
   "text": "Ik ___ mijn huiswerk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ сделал домашнее задание."
  },
  {
   "id": "l1-155",
   "level": 1,
   "text": "Hij ___ zijn kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Он ___ убрал свою комнату."
  },
  {
   "id": "l1-156",
   "level": 1,
   "text": "Jullie ___ naar het museum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в музей."
  },
  {
   "id": "l1-157",
   "level": 1,
   "text": "Wij ___ een mooie dag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо провели день."
  },
  {
   "id": "l1-158",
   "level": 1,
   "text": "Zij ___ om zeven uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала в семь часов."
  },
  {
   "id": "l1-159",
   "level": 1,
   "text": "Ik ___ met de trein gereisd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereisd",
   "rule": "beweging-duur",
   "translationRu": "Я ___ ехал на поезде."
  },
  {
   "id": "l1-160",
   "level": 1,
   "text": "Hij ___ zijn telefoon thuis gelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelaten",
   "rule": "transitief",
   "translationRu": "Он ___ оставил свой телефон дома."
  },
  {
   "id": "l1-161",
   "level": 1,
   "text": "Wij ___ naar het centrum gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в центр пешком."
  },
  {
   "id": "l1-162",
   "level": 1,
   "text": "Zij ___ een lekkere soep gekookt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekookt",
   "rule": "transitief",
   "translationRu": "Она ___ приготовила вкусный суп."
  },
  {
   "id": "l1-163",
   "level": 1,
   "text": "Ik ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ рано пошёл спать."
  },
  {
   "id": "l1-164",
   "level": 1,
   "text": "Hij ___ veel muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geluisterd",
   "rule": "default-hebben",
   "translationRu": "Он ___ слушал много музыки."
  },
  {
   "id": "l1-165",
   "level": 1,
   "text": "Jullie ___ naar Duitsland gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Германию."
  },
  {
   "id": "l1-166",
   "level": 1,
   "text": "Wij ___ een nieuwe tafel gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый стол."
  },
  {
   "id": "l1-167",
   "level": 1,
   "text": "Zij ___ lang in de keuken gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Она ___ долго стояла на кухне."
  },
  {
   "id": "l1-168",
   "level": 1,
   "text": "Ik ___ gisteren veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ вчера многому научился."
  },
  {
   "id": "l1-169",
   "level": 1,
   "text": "Hij ___ naar zijn broer gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл к брату."
  },
  {
   "id": "l1-170",
   "level": 1,
   "text": "Wij ___ een mooie vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-171",
   "level": 1,
   "text": "Zij ___ laat opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ поздно встала."
  },
  {
   "id": "l1-172",
   "level": 1,
   "text": "Ik ___ mijn jas gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл своё пальто."
  },
  {
   "id": "l1-173",
   "level": 1,
   "text": "Hij ___ naar school gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в школу на велосипеде."
  },
  {
   "id": "l1-174",
   "level": 1,
   "text": "Jullie ___ een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Вы ___ посмотрели фильм."
  },
  {
   "id": "l1-175",
   "level": 1,
   "text": "Wij ___ samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вместе выпили кофе."
  },
  {
   "id": "l1-176",
   "level": 1,
   "text": "Zij ___ naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла домой пешком."
  },
  {
   "id": "l1-177",
   "level": 1,
   "text": "Ik ___ de deur geopend.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geopend",
   "rule": "transitief",
   "translationRu": "Я ___ открыл дверь."
  },
  {
   "id": "l1-178",
   "level": 1,
   "text": "Hij ___ zijn verjaardag gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Он ___ отпраздновал свой день рождения."
  },
  {
   "id": "l1-179",
   "level": 1,
   "text": "Wij ___ vroeg begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ начали рано."
  },
  {
   "id": "l1-180",
   "level": 1,
   "text": "Zij ___ naar de winkel gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в магазин."
  },
  {
   "id": "l1-181",
   "level": 1,
   "text": "Ik ___ een boterham gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Я ___ съел бутерброд."
  },
  {
   "id": "l1-182",
   "level": 1,
   "text": "Hij ___ zijn vriend geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Он ___ помог своему другу."
  },
  {
   "id": "l1-183",
   "level": 1,
   "text": "Jullie ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ остались дома."
  },
  {
   "id": "l1-184",
   "level": 1,
   "text": "Wij ___ naar Rotterdam gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Роттердам."
  },
  {
   "id": "l1-185",
   "level": 1,
   "text": "Zij ___ een cadeau gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила подарок."
  },
  {
   "id": "l1-186",
   "level": 1,
   "text": "Ik ___ de hele dag thuis gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Я ___ работал дома весь день."
  },
  {
   "id": "l1-187",
   "level": 1,
   "text": "Hij ___ naar buiten gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ вышел наружу."
  },
  {
   "id": "l1-188",
   "level": 1,
   "text": "Wij ___ veel plezier gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "default-hebben",
   "translationRu": "Мы ___ получили много удовольствия."
  },
  {
   "id": "l1-189",
   "level": 1,
   "text": "Zij ___ om elf uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала в одиннадцать часов."
  },
  {
   "id": "l1-190",
   "level": 1,
   "text": "Ik ___ mijn fiets gerepareerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gerepareerd",
   "rule": "transitief",
   "translationRu": "Я ___ починил свой велосипед."
  },
  {
   "id": "l1-191",
   "level": 1,
   "text": "Hij ___ naar Spanje gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ улетел в Испанию."
  },
  {
   "id": "l1-192",
   "level": 1,
   "text": "Jullie ___ een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Вы ___ совершили долгую прогулку."
  },
  {
   "id": "l1-193",
   "level": 1,
   "text": "Wij ___ vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ рано встали."
  },
  {
   "id": "l1-194",
   "level": 1,
   "text": "Zij ___ naar het ziekenhuis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в больницу."
  },
  {
   "id": "l1-195",
   "level": 1,
   "text": "Ik ___ een kop koffie gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ приготовил чашку кофе."
  },
  {
   "id": "l1-196",
   "level": 1,
   "text": "Hij ___ zijn sleutels meegenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "meegenomen",
   "rule": "transitief",
   "translationRu": "Он ___ взял свои ключи с собой."
  },
  {
   "id": "l1-197",
   "level": 1,
   "text": "Wij ___ thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ пришли домой."
  },
  {
   "id": "l1-198",
   "level": 1,
   "text": "Zij ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Она ___ прочитала книгу."
  },
  {
   "id": "l1-199",
   "level": 1,
   "text": "Ik ___ naar mijn werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл на работу."
  },
  {
   "id": "l1-200",
   "level": 1,
   "text": "Jullie ___ een lekkere lunch gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ вкусно поели на обед."
  },
  {
   "id": "l1-201",
   "level": 1,
   "text": "Hij ___ gisteren naar Utrecht gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ вчера поехал в Утрехт."
  },
  {
   "id": "l1-202",
   "level": 1,
   "text": "Ik ___ mijn kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ убрал свою комнату."
  },
  {
   "id": "l1-203",
   "level": 1,
   "text": "Wij ___ een uur gewandeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ гуляли час."
  },
  {
   "id": "l1-204",
   "level": 1,
   "text": "Zij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала рано."
  },
  {
   "id": "l1-205",
   "level": 1,
   "text": "Jullie ___ veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Вы ___ выпили много воды."
  },
  {
   "id": "l1-206",
   "level": 1,
   "text": "Hij ___ zijn fiets verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Он ___ продал свой велосипед."
  },
  {
   "id": "l1-207",
   "level": 1,
   "text": "Ik ___ naar de markt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл на рынок."
  },
  {
   "id": "l1-208",
   "level": 1,
   "text": "Wij ___ een nieuwe computer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый компьютер."
  },
  {
   "id": "l1-209",
   "level": 1,
   "text": "Zij ___ lang thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ долго оставалась дома."
  },
  {
   "id": "l1-210",
   "level": 1,
   "text": "Hij ___ om zes uur wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Он ___ проснулся в шесть часов."
  },
  {
   "id": "l1-211",
   "level": 1,
   "text": "Ik ___ een brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ написал письмо."
  },
  {
   "id": "l1-212",
   "level": 1,
   "text": "Jullie ___ naar school gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в школу пешком."
  },
  {
   "id": "l1-213",
   "level": 1,
   "text": "Wij ___ samen een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ вместе посмотрели фильм."
  },
  {
   "id": "l1-214",
   "level": 1,
   "text": "Zij ___ naar Portugal gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в Португалию."
  },
  {
   "id": "l1-215",
   "level": 1,
   "text": "Hij ___ zijn huiswerk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал домашнее задание."
  },
  {
   "id": "l1-216",
   "level": 1,
   "text": "Ik ___ een broodje gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Я ___ съел булочку."
  },
  {
   "id": "l1-217",
   "level": 1,
   "text": "Wij ___ laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ поздно пришли домой."
  },
  {
   "id": "l1-218",
   "level": 1,
   "text": "Zij ___ haar moeder gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Она ___ позвонила маме."
  },
  {
   "id": "l1-219",
   "level": 1,
   "text": "Hij ___ naar de supermarkt gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в супермаркет на велосипеде."
  },
  {
   "id": "l1-220",
   "level": 1,
   "text": "Jullie ___ een mooie vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Вы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-221",
   "level": 1,
   "text": "Ik ___ mijn telefoon gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свой телефон."
  },
  {
   "id": "l1-222",
   "level": 1,
   "text": "Zij ___ naar het station gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла на станцию."
  },
  {
   "id": "l1-223",
   "level": 1,
   "text": "Wij ___ veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ сделали много фотографий."
  },
  {
   "id": "l1-224",
   "level": 1,
   "text": "Hij ___ een uur geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ проспал час."
  },
  {
   "id": "l1-225",
   "level": 1,
   "text": "Ik ___ naar de dokter geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ ходил к врачу."
  },
  {
   "id": "l1-226",
   "level": 1,
   "text": "Jullie ___ een nieuwe auto gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Вы ___ купили новую машину."
  },
  {
   "id": "l1-227",
   "level": 1,
   "text": "Zij ___ de hele avond gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Она ___ читала весь вечер."
  },
  {
   "id": "l1-228",
   "level": 1,
   "text": "Wij ___ vroeg begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ начали рано."
  },
  {
   "id": "l1-229",
   "level": 1,
   "text": "Hij ___ naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал домой."
  },
  {
   "id": "l1-230",
   "level": 1,
   "text": "Ik ___ een cadeau gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ получил подарок."
  },
  {
   "id": "l1-231",
   "level": 1,
   "text": "Zij ___ in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Она ___ сидела в саду."
  },
  {
   "id": "l1-232",
   "level": 1,
   "text": "Wij ___ naar het strand gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли на пляж."
  },
  {
   "id": "l1-233",
   "level": 1,
   "text": "Hij ___ een glas sap gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Он ___ выпил стакан сока."
  },
  {
   "id": "l1-234",
   "level": 1,
   "text": "Ik ___ mijn tas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ забыл свою сумку."
  },
  {
   "id": "l1-235",
   "level": 1,
   "text": "Jullie ___ naar Frankrijk gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ улетели во Францию."
  },
  {
   "id": "l1-236",
   "level": 1,
   "text": "Zij ___ veel Nederlands gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gesproken",
   "rule": "default-hebben",
   "translationRu": "Она ___ много говорила по-голландски."
  },
  {
   "id": "l1-237",
   "level": 1,
   "text": "Wij ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ остались дома."
  },
  {
   "id": "l1-238",
   "level": 1,
   "text": "Hij ___ zijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ убрал свою комнату."
  },
  {
   "id": "l1-239",
   "level": 1,
   "text": "Ik ___ naar de winkel gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в магазин пешком."
  },
  {
   "id": "l1-240",
   "level": 1,
   "text": "Zij ___ een mooie jurk gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила красивое платье."
  },
  {
   "id": "l1-241",
   "level": 1,
   "text": "Wij ___ een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили долгую прогулку."
  },
  {
   "id": "l1-242",
   "level": 1,
   "text": "Hij ___ laat aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ приехал поздно."
  },
  {
   "id": "l1-243",
   "level": 1,
   "text": "Ik ___ mijn vader geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог отцу."
  },
  {
   "id": "l1-244",
   "level": 1,
   "text": "Jullie ___ naar Duitsland gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Германию."
  },
  {
   "id": "l1-245",
   "level": 1,
   "text": "Zij ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать."
  },
  {
   "id": "l1-246",
   "level": 1,
   "text": "Wij ___ samen gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Мы ___ поели вместе."
  },
  {
   "id": "l1-247",
   "level": 1,
   "text": "Hij ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал книгу."
  },
  {
   "id": "l1-248",
   "level": 1,
   "text": "Ik ___ om acht uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ уехал в восемь часов."
  },
  {
   "id": "l1-249",
   "level": 1,
   "text": "Zij ___ naar België gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в Бельгию."
  },
  {
   "id": "l1-250",
   "level": 1,
   "text": "Jullie ___ veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Вы ___ многому научились."
  },
  {
   "id": "l1-251",
   "level": 1,
   "text": "Wij ___ een nieuwe tafel besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Мы ___ заказали новый стол."
  },
  {
   "id": "l1-252",
   "level": 1,
   "text": "Hij ___ naar het werk gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал на работу на велосипеде."
  },
  {
   "id": "l1-253",
   "level": 1,
   "text": "Ik ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ ждал час."
  },
  {
   "id": "l1-254",
   "level": 1,
   "text": "Zij ___ thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ пришла домой."
  },
  {
   "id": "l1-255",
   "level": 1,
   "text": "Wij ___ een lekkere taart gebakken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebakken",
   "rule": "transitief",
   "translationRu": "Мы ___ испекли вкусный торт."
  },
  {
   "id": "l1-256",
   "level": 1,
   "text": "Hij ___ naar Amsterdam gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл в Амстердам пешком."
  },
  {
   "id": "l1-257",
   "level": 1,
   "text": "Jullie ___ koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Вы ___ выпили кофе."
  },
  {
   "id": "l1-258",
   "level": 1,
   "text": "Ik ___ mijn huiswerk vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ забыл домашнее задание."
  },
  {
   "id": "l1-259",
   "level": 1,
   "text": "Zij ___ naar een andere stad verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другой город."
  },
  {
   "id": "l1-260",
   "level": 1,
   "text": "Wij ___ een leuke dag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо провели день."
  },
  {
   "id": "l1-261",
   "level": 1,
   "text": "Hij ___ zijn sleutel verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял свой ключ."
  },
  {
   "id": "l1-262",
   "level": 1,
   "text": "Ik ___ naar de bioscoop gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в кино."
  },
  {
   "id": "l1-263",
   "level": 1,
   "text": "Zij ___ een mooie foto gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ сделала красивую фотографию."
  },
  {
   "id": "l1-264",
   "level": 1,
   "text": "Jullie ___ vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Вы ___ рано встали."
  },
  {
   "id": "l1-265",
   "level": 1,
   "text": "Wij ___ naar de markt gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали на рынок."
  },
  {
   "id": "l1-266",
   "level": 1,
   "text": "Hij ___ veel gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Он ___ много поел."
  },
  {
   "id": "l1-267",
   "level": 1,
   "text": "Ik ___ mijn fiets gebruikt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebruikt",
   "rule": "transitief",
   "translationRu": "Я ___ использовал свой велосипед."
  },
  {
   "id": "l1-268",
   "level": 1,
   "text": "Zij ___ naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вышла наружу."
  },
  {
   "id": "l1-269",
   "level": 1,
   "text": "Wij ___ lang gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "default-hebben",
   "translationRu": "Мы ___ долго разговаривали."
  },
  {
   "id": "l1-270",
   "level": 1,
   "text": "Hij ___ een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл новую работу."
  },
  {
   "id": "l1-271",
   "level": 1,
   "text": "Ik ___ gisteren thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера остался дома."
  },
  {
   "id": "l1-272",
   "level": 1,
   "text": "Jullie ___ naar het museum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в музей."
  },
  {
   "id": "l1-273",
   "level": 1,
   "text": "Zij ___ een kop thee gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Она ___ приготовила чашку чая."
  },
  {
   "id": "l1-274",
   "level": 1,
   "text": "Wij ___ een film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ посмотрели фильм."
  },
  {
   "id": "l1-275",
   "level": 1,
   "text": "Hij ___ naar Londen gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ улетел в Лондон."
  },
  {
   "id": "l1-276",
   "level": 1,
   "text": "Ik ___ mijn moeder gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ позвонил маме."
  },
  {
   "id": "l1-277",
   "level": 1,
   "text": "Zij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала рано."
  },
  {
   "id": "l1-278",
   "level": 1,
   "text": "Jullie ___ een lekkere pizza gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ съели вкусную пиццу."
  },
  {
   "id": "l1-279",
   "level": 1,
   "text": "Wij ___ naar het park gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в парк пешком."
  },
  {
   "id": "l1-280",
   "level": 1,
   "text": "Hij ___ zijn telefoon opgeladen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgeladen",
   "rule": "transitief",
   "translationRu": "Он ___ зарядил свой телефон."
  },
  {
   "id": "l1-281",
   "level": 1,
   "text": "Ik ___ veel Nederlands geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ многому научился по-голландски."
  },
  {
   "id": "l1-282",
   "level": 1,
   "text": "Zij ___ naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла домой."
  },
  {
   "id": "l1-283",
   "level": 1,
   "text": "Wij ___ een mooie foto gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ нашли красивую фотографию."
  },
  {
   "id": "l1-284",
   "level": 1,
   "text": "Hij ___ de hele dag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ работал весь день."
  },
  {
   "id": "l1-285",
   "level": 1,
   "text": "Jullie ___ naar het station gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали на станцию на велосипеде."
  },
  {
   "id": "l1-286",
   "level": 1,
   "text": "Ik ___ een brief gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ получил письмо."
  },
  {
   "id": "l1-287",
   "level": 1,
   "text": "Zij ___ in de trein geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ спала в поезде."
  },
  {
   "id": "l1-288",
   "level": 1,
   "text": "Wij ___ om tien uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ приехали в десять часов."
  },
  {
   "id": "l1-289",
   "level": 1,
   "text": "Hij ___ zijn jas aangehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangehouden",
   "rule": "transitief",
   "translationRu": "Он ___ не снял пальто."
  },
  {
   "id": "l1-290",
   "level": 1,
   "text": "Ik ___ naar mijn vriendin gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл к подруге."
  },
  {
   "id": "l1-291",
   "level": 1,
   "text": "Jullie ___ veel muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "geluisterd",
   "rule": "default-hebben",
   "translationRu": "Вы ___ слушали много музыки."
  },
  {
   "id": "l1-292",
   "level": 1,
   "text": "Zij ___ een cadeau gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила подарок."
  },
  {
   "id": "l1-293",
   "level": 1,
   "text": "Wij ___ vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ рано пошли домой."
  },
  {
   "id": "l1-294",
   "level": 1,
   "text": "Hij ___ een boterham gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал бутерброд."
  },
  {
   "id": "l1-295",
   "level": 1,
   "text": "Ik ___ mijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ убрал свою комнату."
  },
  {
   "id": "l1-296",
   "level": 1,
   "text": "Zij ___ naar school gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в школу."
  },
  {
   "id": "l1-297",
   "level": 1,
   "text": "Wij ___ lang in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ долго сидели в саду."
  },
  {
   "id": "l1-298",
   "level": 1,
   "text": "Jullie ___ een leuke film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Вы ___ посмотрели хороший фильм."
  },
  {
   "id": "l1-299",
   "level": 1,
   "text": "Hij ___ naar Italië gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Италию."
  },
  {
   "id": "l1-300",
   "level": 1,
   "text": "Ik ___ gisteren veel gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "default-hebben",
   "translationRu": "Я ___ вчера много работал."
  },
  {
   "id": "l1-301",
   "level": 1,
   "text": "Wij ___ naar het centrum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в центр."
  },
  {
   "id": "l1-302",
   "level": 1,
   "text": "Zij ___ een nieuwe fiets gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новый велосипед."
  },
  {
   "id": "l1-303",
   "level": 1,
   "text": "Hij ___ vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ рано встал."
  },
  {
   "id": "l1-304",
   "level": 1,
   "text": "Ik ___ een kop koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Я ___ выпил чашку кофе."
  },
  {
   "id": "l1-305",
   "level": 1,
   "text": "Jullie ___ naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли домой пешком."
  },
  {
   "id": "l1-306",
   "level": 1,
   "text": "Wij ___ een lange brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Мы ___ написали длинное письмо."
  },
  {
   "id": "l1-307",
   "level": 1,
   "text": "Zij ___ om negen uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала в девять часов."
  },
  {
   "id": "l1-308",
   "level": 1,
   "text": "Hij ___ zijn huiswerk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал домашнее задание."
  },
  {
   "id": "l1-309",
   "level": 1,
   "text": "Ik ___ naar de winkel gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в магазин."
  },
  {
   "id": "l1-310",
   "level": 1,
   "text": "Wij ___ veel foto's genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "genomen",
   "rule": "default-hebben",
   "translationRu": "Мы ___ сделали много фотографий."
  },
  {
   "id": "l1-311",
   "level": 1,
   "text": "Zij ___ de hele dag thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ оставалась дома весь день."
  },
  {
   "id": "l1-312",
   "level": 1,
   "text": "Hij ___ naar Rotterdam gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Роттердам."
  },
  {
   "id": "l1-313",
   "level": 1,
   "text": "Jullie ___ een lekkere lunch gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ вкусно поели на обед."
  },
  {
   "id": "l1-314",
   "level": 1,
   "text": "Ik ___ mijn sleutel gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свой ключ."
  },
  {
   "id": "l1-315",
   "level": 1,
   "text": "Wij ___ naar school gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в школу на велосипеде."
  },
  {
   "id": "l1-316",
   "level": 1,
   "text": "Zij ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Она ___ ждала час."
  },
  {
   "id": "l1-317",
   "level": 1,
   "text": "Hij ___ naar Frankrijk gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ улетел во Францию."
  },
  {
   "id": "l1-318",
   "level": 1,
   "text": "Ik ___ veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ многому научился."
  },
  {
   "id": "l1-319",
   "level": 1,
   "text": "Jullie ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Вы ___ уехали рано."
  },
  {
   "id": "l1-320",
   "level": 1,
   "text": "Wij ___ een mooie wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили красивую прогулку."
  },
  {
   "id": "l1-321",
   "level": 1,
   "text": "Zij ___ naar de dokter gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла к врачу."
  },
  {
   "id": "l1-322",
   "level": 1,
   "text": "Hij ___ een nieuwe telefoon gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Он ___ купил новый телефон."
  },
  {
   "id": "l1-323",
   "level": 1,
   "text": "Ik ___ gisteren ziek geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера был болен."
  },
  {
   "id": "l1-324",
   "level": 1,
   "text": "Wij ___ samen thee gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вместе выпили чай."
  },
  {
   "id": "l1-325",
   "level": 1,
   "text": "Jullie ___ naar het park gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в парк."
  },
  {
   "id": "l1-326",
   "level": 1,
   "text": "Zij ___ haar tas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ забыла свою сумку."
  },
  {
   "id": "l1-327",
   "level": 1,
   "text": "Hij ___ de hele avond tv gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Он ___ смотрел телевизор весь вечер."
  },
  {
   "id": "l1-328",
   "level": 1,
   "text": "Ik ___ naar mijn werk gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Я ___ поехал на работу на велосипеде."
  },
  {
   "id": "l1-329",
   "level": 1,
   "text": "Wij ___ thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ пришли домой."
  },
  {
   "id": "l1-330",
   "level": 1,
   "text": "Zij ___ een taart gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ приготовила торт."
  },
  {
   "id": "l1-331",
   "level": 1,
   "text": "Hij ___ naar Spanje gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Испанию."
  },
  {
   "id": "l1-332",
   "level": 1,
   "text": "Jullie ___ veel plezier gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gehad",
   "rule": "default-hebben",
   "translationRu": "Вы ___ получили много удовольствия."
  },
  {
   "id": "l1-333",
   "level": 1,
   "text": "Ik ___ mijn kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ убрал свою комнату."
  },
  {
   "id": "l1-334",
   "level": 1,
   "text": "Zij ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать."
  },
  {
   "id": "l1-335",
   "level": 1,
   "text": "Wij ___ een film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ посмотрели фильм."
  },
  {
   "id": "l1-336",
   "level": 1,
   "text": "Hij ___ zijn vriend gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Он ___ позвонил своему другу."
  },
  {
   "id": "l1-337",
   "level": 1,
   "text": "Ik ___ naar buiten gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вышел наружу."
  },
  {
   "id": "l1-338",
   "level": 1,
   "text": "Jullie ___ een nieuwe auto gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Вы ___ купили новую машину."
  },
  {
   "id": "l1-339",
   "level": 1,
   "text": "Zij ___ lang geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "default-hebben",
   "translationRu": "Она ___ долго спала."
  },
  {
   "id": "l1-340",
   "level": 1,
   "text": "Wij ___ om zes uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ уехали в шесть часов."
  },
  {
   "id": "l1-341",
   "level": 1,
   "text": "Hij ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал книгу."
  },
  {
   "id": "l1-342",
   "level": 1,
   "text": "Ik ___ naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в супермаркет."
  },
  {
   "id": "l1-343",
   "level": 1,
   "text": "Zij ___ een mooie foto gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ сделала красивую фотографию."
  },
  {
   "id": "l1-344",
   "level": 1,
   "text": "Wij ___ naar België gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Бельгию."
  },
  {
   "id": "l1-345",
   "level": 1,
   "text": "Jullie ___ samen gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Вы ___ поели вместе."
  },
  {
   "id": "l1-346",
   "level": 1,
   "text": "Hij ___ zijn jas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл своё пальто."
  },
  {
   "id": "l1-347",
   "level": 1,
   "text": "Ik ___ vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Я ___ рано проснулся."
  },
  {
   "id": "l1-348",
   "level": 1,
   "text": "Zij ___ naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала домой на велосипеде."
  },
  {
   "id": "l1-349",
   "level": 1,
   "text": "Wij ___ veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ выпили много воды."
  },
  {
   "id": "l1-350",
   "level": 1,
   "text": "Hij ___ zijn fiets gerepareerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gerepareerd",
   "rule": "transitief",
   "translationRu": "Он ___ починил свой велосипед."
  },
  {
   "id": "l1-351",
   "level": 1,
   "text": "Ik ___ een brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ написал письмо."
  },
  {
   "id": "l1-352",
   "level": 1,
   "text": "Jullie ___ naar Amsterdam gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в Амстердам."
  },
  {
   "id": "l1-353",
   "level": 1,
   "text": "Zij ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ осталась дома."
  },
  {
   "id": "l1-354",
   "level": 1,
   "text": "Wij ___ een lekkere soep gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ съели вкусный суп."
  },
  {
   "id": "l1-355",
   "level": 1,
   "text": "Hij ___ naar de trein gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл к поезду пешком."
  },
  {
   "id": "l1-356",
   "level": 1,
   "text": "Ik ___ mijn moeder geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог маме."
  },
  {
   "id": "l1-357",
   "level": 1,
   "text": "Zij ___ om twaalf uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала в двенадцать часов."
  },
  {
   "id": "l1-358",
   "level": 1,
   "text": "Jullie ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Вы ___ ждали час."
  },
  {
   "id": "l1-359",
   "level": 1,
   "text": "Wij ___ naar Duitsland gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Германию."
  },
  {
   "id": "l1-360",
   "level": 1,
   "text": "Hij ___ veel Nederlands gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "default-hebben",
   "translationRu": "Он ___ много говорил по-голландски."
  },
  {
   "id": "l1-361",
   "level": 1,
   "text": "Ik ___ mijn tas meegenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "meegenomen",
   "rule": "transitief",
   "translationRu": "Я ___ взял свою сумку с собой."
  },
  {
   "id": "l1-362",
   "level": 1,
   "text": "Zij ___ naar de markt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла на рынок."
  },
  {
   "id": "l1-363",
   "level": 1,
   "text": "Wij ___ een nieuwe tafel gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый стол."
  },
  {
   "id": "l1-364",
   "level": 1,
   "text": "Hij ___ vroeg begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ начал рано."
  },
  {
   "id": "l1-365",
   "level": 1,
   "text": "Jullie ___ een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Вы ___ совершили долгую прогулку."
  },
  {
   "id": "l1-366",
   "level": 1,
   "text": "Ik ___ naar de bioscoop gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в кино."
  },
  {
   "id": "l1-367",
   "level": 1,
   "text": "Zij ___ een glas melk gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Она ___ выпила стакан молока."
  },
  {
   "id": "l1-368",
   "level": 1,
   "text": "Wij ___ de hele dag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ работали весь день."
  },
  {
   "id": "l1-369",
   "level": 1,
   "text": "Hij ___ naar huis gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekomen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пришёл домой."
  },
  {
   "id": "l1-370",
   "level": 1,
   "text": "Ik ___ mijn telefoon verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Я ___ потерял свой телефон."
  },
  {
   "id": "l1-371",
   "level": 1,
   "text": "Jullie ___ een leuke vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Вы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-372",
   "level": 1,
   "text": "Zij ___ naar school gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в школу пешком."
  },
  {
   "id": "l1-373",
   "level": 1,
   "text": "Wij ___ een cadeau gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Мы ___ получили подарок."
  },
  {
   "id": "l1-374",
   "level": 1,
   "text": "Hij ___ zijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ убрал свою комнату."
  },
  {
   "id": "l1-375",
   "level": 1,
   "text": "Ik ___ om zeven uur opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ встал в семь часов."
  },
  {
   "id": "l1-376",
   "level": 1,
   "text": "Zij ___ naar Italië gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ улетела в Италию."
  },
  {
   "id": "l1-377",
   "level": 1,
   "text": "Jullie ___ veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gemaakt",
   "rule": "default-hebben",
   "translationRu": "Вы ___ сделали много фотографий."
  },
  {
   "id": "l1-378",
   "level": 1,
   "text": "Wij ___ samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вместе выпили кофе."
  },
  {
   "id": "l1-379",
   "level": 1,
   "text": "Hij ___ naar de winkel gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в магазин."
  },
  {
   "id": "l1-380",
   "level": 1,
   "text": "Ik ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ прочитал книгу."
  },
  {
   "id": "l1-381",
   "level": 1,
   "text": "Zij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала рано."
  },
  {
   "id": "l1-382",
   "level": 1,
   "text": "Wij ___ naar het strand gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли на пляж."
  },
  {
   "id": "l1-383",
   "level": 1,
   "text": "Jullie ___ een pizza gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ съели пиццу."
  },
  {
   "id": "l1-384",
   "level": 1,
   "text": "Hij ___ een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл новую работу."
  },
  {
   "id": "l1-385",
   "level": 1,
   "text": "Ik ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ остался дома."
  },
  {
   "id": "l1-386",
   "level": 1,
   "text": "Zij ___ een uur gefietst.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-duur",
   "translationRu": "Она ___ час ездила на велосипеде."
  },
  {
   "id": "l1-387",
   "level": 1,
   "text": "Wij ___ naar Utrecht gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Утрехт."
  },
  {
   "id": "l1-388",
   "level": 1,
   "text": "Hij ___ zijn huiswerk vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл домашнее задание."
  },
  {
   "id": "l1-389",
   "level": 1,
   "text": "Jullie ___ naar het museum geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ сходили в музей."
  },
  {
   "id": "l1-390",
   "level": 1,
   "text": "Ik ___ veel muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geluisterd",
   "rule": "default-hebben",
   "translationRu": "Я ___ слушал много музыки."
  },
  {
   "id": "l1-391",
   "level": 1,
   "text": "Zij ___ naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла домой пешком."
  },
  {
   "id": "l1-392",
   "level": 1,
   "text": "Wij ___ een mooie dag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо провели день."
  },
  {
   "id": "l1-393",
   "level": 1,
   "text": "Hij ___ zijn fiets meegenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "meegenomen",
   "rule": "transitief",
   "translationRu": "Он ___ взял свой велосипед с собой."
  },
  {
   "id": "l1-394",
   "level": 1,
   "text": "Ik ___ naar de dokter gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл к врачу."
  },
  {
   "id": "l1-395",
   "level": 1,
   "text": "Jullie ___ een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Вы ___ посмотрели фильм."
  },
  {
   "id": "l1-396",
   "level": 1,
   "text": "Zij ___ laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ поздно пришла домой."
  },
  {
   "id": "l1-397",
   "level": 1,
   "text": "Wij ___ een brief gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Мы ___ получили письмо."
  },
  {
   "id": "l1-398",
   "level": 1,
   "text": "Hij ___ naar zijn ouders gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал к родителям."
  },
  {
   "id": "l1-399",
   "level": 1,
   "text": "Ik ___ veel gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Я ___ много поел."
  },
  {
   "id": "l1-400",
   "level": 1,
   "text": "Zij ___ vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Она ___ рано проснулась."
  },
  {
   "id": "l1-401",
   "level": 1,
   "text": "Ik ___ gisteren naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера пошёл в школу."
  },
  {
   "id": "l1-402",
   "level": 1,
   "text": "Hij ___ zijn ontbijt gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ позавтракал."
  },
  {
   "id": "l1-403",
   "level": 1,
   "text": "Wij ___ naar de stad gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в город."
  },
  {
   "id": "l1-404",
   "level": 1,
   "text": "Zij ___ een mooie foto gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ сделала красивую фотографию."
  },
  {
   "id": "l1-405",
   "level": 1,
   "text": "Jullie ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Вы ___ остались дома."
  },
  {
   "id": "l1-406",
   "level": 1,
   "text": "Ik ___ vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ рано встал."
  },
  {
   "id": "l1-407",
   "level": 1,
   "text": "Hij ___ naar de winkel gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл в магазин пешком."
  },
  {
   "id": "l1-408",
   "level": 1,
   "text": "Wij ___ een nieuwe fiets gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый велосипед."
  },
  {
   "id": "l1-409",
   "level": 1,
   "text": "Zij ___ een kop koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Она ___ выпила чашку кофе."
  },
  {
   "id": "l1-410",
   "level": 1,
   "text": "Ik ___ naar mijn werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл на работу."
  },
  {
   "id": "l1-411",
   "level": 1,
   "text": "Jullie ___ een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Вы ___ совершили долгую прогулку."
  },
  {
   "id": "l1-412",
   "level": 1,
   "text": "Hij ___ laat aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ приехал поздно."
  },
  {
   "id": "l1-413",
   "level": 1,
   "text": "Wij ___ veel Nederlands geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Мы ___ многому научились по-голландски."
  },
  {
   "id": "l1-414",
   "level": 1,
   "text": "Zij ___ naar Frankrijk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала во Францию."
  },
  {
   "id": "l1-415",
   "level": 1,
   "text": "Ik ___ een brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ написал письмо."
  },
  {
   "id": "l1-416",
   "level": 1,
   "text": "Hij ___ zijn kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Он ___ убрал свою комнату."
  },
  {
   "id": "l1-417",
   "level": 1,
   "text": "Jullie ___ naar het station gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали на станцию на велосипеде."
  },
  {
   "id": "l1-418",
   "level": 1,
   "text": "Wij ___ een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ посмотрели фильм."
  },
  {
   "id": "l1-419",
   "level": 1,
   "text": "Zij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала рано."
  },
  {
   "id": "l1-420",
   "level": 1,
   "text": "Ik ___ gisteren veel gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "default-hebben",
   "translationRu": "Я ___ вчера много работал."
  },
  {
   "id": "l1-421",
   "level": 1,
   "text": "Hij ___ naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл домой."
  },
  {
   "id": "l1-422",
   "level": 1,
   "text": "Wij ___ een lekkere pizza gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ съели вкусную пиццу."
  },
  {
   "id": "l1-423",
   "level": 1,
   "text": "Zij ___ haar sleutel verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Она ___ потеряла свой ключ."
  },
  {
   "id": "l1-424",
   "level": 1,
   "text": "Jullie ___ naar België gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Бельгию."
  },
  {
   "id": "l1-425",
   "level": 1,
   "text": "Ik ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ ждал час."
  },
  {
   "id": "l1-426",
   "level": 1,
   "text": "Hij ___ naar school gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл в школу пешком."
  },
  {
   "id": "l1-427",
   "level": 1,
   "text": "Wij ___ samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вместе выпили кофе."
  },
  {
   "id": "l1-428",
   "level": 1,
   "text": "Zij ___ naar Spanje gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ улетела в Испанию."
  },
  {
   "id": "l1-429",
   "level": 1,
   "text": "Ik ___ mijn moeder gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ позвонил маме."
  },
  {
   "id": "l1-430",
   "level": 1,
   "text": "Jullie ___ een mooie vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Вы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-431",
   "level": 1,
   "text": "Hij ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ рано пошёл спать."
  },
  {
   "id": "l1-432",
   "level": 1,
   "text": "Wij ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ остались дома."
  },
  {
   "id": "l1-433",
   "level": 1,
   "text": "Zij ___ een nieuwe jas gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новое пальто."
  },
  {
   "id": "l1-434",
   "level": 1,
   "text": "Ik ___ naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл в супермаркет."
  },
  {
   "id": "l1-435",
   "level": 1,
   "text": "Hij ___ veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "default-hebben",
   "translationRu": "Он ___ выпил много воды."
  },
  {
   "id": "l1-436",
   "level": 1,
   "text": "Jullie ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Вы ___ прочитали книгу."
  },
  {
   "id": "l1-437",
   "level": 1,
   "text": "Wij ___ om acht uur vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ уехали в восемь часов."
  },
  {
   "id": "l1-438",
   "level": 1,
   "text": "Zij ___ naar het park gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в парк."
  },
  {
   "id": "l1-439",
   "level": 1,
   "text": "Ik ___ mijn huiswerk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ сделал домашнее задание."
  },
  {
   "id": "l1-440",
   "level": 1,
   "text": "Hij ___ een uur geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ проспал час."
  },
  {
   "id": "l1-441",
   "level": 1,
   "text": "Wij ___ naar Rotterdam gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали в Роттердам."
  },
  {
   "id": "l1-442",
   "level": 1,
   "text": "Zij ___ een taart gebakken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebakken",
   "rule": "transitief",
   "translationRu": "Она ___ испекла торт."
  },
  {
   "id": "l1-443",
   "level": 1,
   "text": "Jullie ___ laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Вы ___ поздно пришли домой."
  },
  {
   "id": "l1-444",
   "level": 1,
   "text": "Ik ___ naar de dokter geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ ходил к врачу."
  },
  {
   "id": "l1-445",
   "level": 1,
   "text": "Hij ___ zijn telefoon gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл свой телефон."
  },
  {
   "id": "l1-446",
   "level": 1,
   "text": "Wij ___ veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ сделали много фотографий."
  },
  {
   "id": "l1-447",
   "level": 1,
   "text": "Zij ___ naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала домой на велосипеде."
  },
  {
   "id": "l1-448",
   "level": 1,
   "text": "Ik ___ een boterham gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Я ___ съел бутерброд."
  },
  {
   "id": "l1-449",
   "level": 1,
   "text": "Jullie ___ vroeg opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Вы ___ рано встали."
  },
  {
   "id": "l1-450",
   "level": 1,
   "text": "Hij ___ naar Duitsland gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал в Германию."
  },
  {
   "id": "l1-451",
   "level": 1,
   "text": "Wij ___ een leuke dag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо провели день."
  },
  {
   "id": "l1-452",
   "level": 1,
   "text": "Zij ___ lang in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Она ___ долго сидела в саду."
  },
  {
   "id": "l1-453",
   "level": 1,
   "text": "Ik ___ naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вышел наружу."
  },
  {
   "id": "l1-454",
   "level": 1,
   "text": "Hij ___ zijn tas vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свою сумку."
  },
  {
   "id": "l1-455",
   "level": 1,
   "text": "Jullie ___ een nieuwe auto gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Вы ___ купили новую машину."
  },
  {
   "id": "l1-456",
   "level": 1,
   "text": "Wij ___ naar het strand gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли на пляж."
  },
  {
   "id": "l1-457",
   "level": 1,
   "text": "Zij ___ veel muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geluisterd",
   "rule": "default-hebben",
   "translationRu": "Она ___ слушала много музыки."
  },
  {
   "id": "l1-458",
   "level": 1,
   "text": "Ik ___ mijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ убрал свою комнату."
  },
  {
   "id": "l1-459",
   "level": 1,
   "text": "Hij ___ om tien uur aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ приехал в десять часов."
  },
  {
   "id": "l1-460",
   "level": 1,
   "text": "Wij ___ een lange brief geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Мы ___ написали длинное письмо."
  },
  {
   "id": "l1-461",
   "level": 1,
   "text": "Jullie ___ naar Amsterdam gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли в Амстердам."
  },
  {
   "id": "l1-462",
   "level": 1,
   "text": "Zij ___ een glas water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Она ___ выпила стакан воды."
  },
  {
   "id": "l1-463",
   "level": 1,
   "text": "Ik ___ thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ остался дома."
  },
  {
   "id": "l1-464",
   "level": 1,
   "text": "Hij ___ zijn vriend geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Он ___ помог своему другу."
  },
  {
   "id": "l1-465",
   "level": 1,
   "text": "Wij ___ naar de markt gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли на рынок пешком."
  },
  {
   "id": "l1-466",
   "level": 1,
   "text": "Zij ___ vroeg vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ уехала рано."
  },
  {
   "id": "l1-467",
   "level": 1,
   "text": "Jullie ___ samen gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "default-hebben",
   "translationRu": "Вы ___ поели вместе."
  },
  {
   "id": "l1-468",
   "level": 1,
   "text": "Ik ___ een mooie film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Я ___ посмотрел хороший фильм."
  },
  {
   "id": "l1-469",
   "level": 1,
   "text": "Hij ___ naar Italië gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ улетел в Италию."
  },
  {
   "id": "l1-470",
   "level": 1,
   "text": "Wij ___ een cadeau gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили подарок."
  },
  {
   "id": "l1-471",
   "level": 1,
   "text": "Zij ___ naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в школу."
  },
  {
   "id": "l1-472",
   "level": 1,
   "text": "Ik ___ veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ многому научился."
  },
  {
   "id": "l1-473",
   "level": 1,
   "text": "Hij ___ zijn fiets gerepareerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gerepareerd",
   "rule": "transitief",
   "translationRu": "Он ___ починил свой велосипед."
  },
  {
   "id": "l1-474",
   "level": 1,
   "text": "Jullie ___ naar Utrecht gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Утрехт."
  },
  {
   "id": "l1-475",
   "level": 1,
   "text": "Wij ___ een uur gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ ждали час."
  },
  {
   "id": "l1-476",
   "level": 1,
   "text": "Zij ___ thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ пришла домой."
  },
  {
   "id": "l1-477",
   "level": 1,
   "text": "Ik ___ mijn telefoon vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ забыл свой телефон."
  },
  {
   "id": "l1-478",
   "level": 1,
   "text": "Hij ___ een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал книгу."
  },
  {
   "id": "l1-479",
   "level": 1,
   "text": "Wij ___ naar het museum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в музей."
  },
  {
   "id": "l1-480",
   "level": 1,
   "text": "Jullie ___ een lekkere lunch gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Вы ___ вкусно поели на обед."
  },
  {
   "id": "l1-481",
   "level": 1,
   "text": "Zij ___ naar Frankrijk verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала во Францию."
  },
  {
   "id": "l1-482",
   "level": 1,
   "text": "Ik ___ vroeg wakker geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geworden",
   "rule": "verandering",
   "translationRu": "Я ___ рано проснулся."
  },
  {
   "id": "l1-483",
   "level": 1,
   "text": "Hij ___ naar zijn werk gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал на работу на велосипеде."
  },
  {
   "id": "l1-484",
   "level": 1,
   "text": "Wij ___ veel plezier gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "default-hebben",
   "translationRu": "Мы ___ получили много удовольствия."
  },
  {
   "id": "l1-485",
   "level": 1,
   "text": "Zij ___ een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла новую работу."
  },
  {
   "id": "l1-486",
   "level": 1,
   "text": "Jullie ___ naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли домой пешком."
  },
  {
   "id": "l1-487",
   "level": 1,
   "text": "Ik ___ een kop thee gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Я ___ выпил чашку чая."
  },
  {
   "id": "l1-488",
   "level": 1,
   "text": "Hij ___ naar de winkel gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл в магазин."
  },
  {
   "id": "l1-489",
   "level": 1,
   "text": "Wij ___ een mooie wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили красивую прогулку."
  },
  {
   "id": "l1-490",
   "level": 1,
   "text": "Zij ___ laat naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поздно пошла спать."
  },
  {
   "id": "l1-491",
   "level": 1,
   "text": "Ik ___ mijn vader geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог отцу."
  },
  {
   "id": "l1-492",
   "level": 1,
   "text": "Jullie ___ naar het station gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ пошли на станцию."
  },
  {
   "id": "l1-493",
   "level": 1,
   "text": "Hij ___ een nieuwe computer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Он ___ купил новый компьютер."
  },
  {
   "id": "l1-494",
   "level": 1,
   "text": "Wij ___ naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вышли наружу."
  },
  {
   "id": "l1-495",
   "level": 1,
   "text": "Zij ___ veel gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Она ___ много плавала."
  },
  {
   "id": "l1-496",
   "level": 1,
   "text": "Ik ___ in China geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ побывал в Китае."
  },
  {
   "id": "l1-497",
   "level": 1,
   "text": "Hij ___ veel gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedaan",
   "rule": "default-hebben",
   "translationRu": "Он ___ много сделал."
  },
  {
   "id": "l1-498",
   "level": 1,
   "text": "Jullie ___ naar Zwolle gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "jullie",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Вы ___ поехали в Зволле."
  },
  {
   "id": "l1-499",
   "level": 1,
   "text": "Wij ___ een mooie vakantie gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо отдохнули в отпуске."
  },
  {
   "id": "l1-500",
   "level": 1,
   "text": "Zij ___ gisteren de hele dag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Она ___ вчера работала весь день."
  },
  {
   "id": "l2-001",
   "level": 2,
   "text": "Ik ___ gisteren na het werk meteen naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера после работы сразу поехал домой."
  },
  {
   "id": "l2-002",
   "level": 2,
   "text": "Mijn broer ___ gisteren tot laat op zijn computer gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мой брат ___ вчера допоздна работал за компьютером."
  },
  {
   "id": "l2-003",
   "level": 2,
   "text": "Wij ___ vorige week naar een ander hotel verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ на прошлой неделе переехали в другой отель."
  },
  {
   "id": "l2-004",
   "level": 2,
   "text": "Sara ___ haar oude fiets aan haar buurman verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Сара ___ продала свой старый велосипед соседу."
  },
  {
   "id": "l2-005",
   "level": 2,
   "text": "De kinderen ___ na het eten buiten gaan spelen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gaan spelen",
   "rule": "groeps-inf",
   "translationRu": "Дети ___ после еды пошли играть на улицу."
  },
  {
   "id": "l2-006",
   "level": 2,
   "text": "Ik ___ vanochtend mijn bus gemist.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Я ___ сегодня утром опоздал на свой автобус."
  },
  {
   "id": "l2-007",
   "level": 2,
   "text": "Mijn ouders ___ vorige zomer naar Italië gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мои родители ___ прошлым летом поехали в Италию."
  },
  {
   "id": "l2-008",
   "level": 2,
   "text": "Hij ___ gisteren zijn beste vriend op straat tegengekomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "tegengekomen",
   "rule": "transitief",
   "translationRu": "Он ___ вчера встретил своего лучшего друга на улице."
  },
  {
   "id": "l2-009",
   "level": 2,
   "text": "Wij ___ de hele middag in de tuin gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день просидели в саду."
  },
  {
   "id": "l2-010",
   "level": 2,
   "text": "Anna ___ na de les naar de bibliotheek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Анна ___ после урока пошла в библиотеку."
  },
  {
   "id": "l2-011",
   "level": 2,
   "text": "Ik ___ gisteren een interessant programma op tv gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера смотрел интересную передачу по телевизору."
  },
  {
   "id": "l2-012",
   "level": 2,
   "text": "De trein ___ om half acht uit Rotterdam vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Поезд ___ в полвосьмого отправился из Роттердама."
  },
  {
   "id": "l2-013",
   "level": 2,
   "text": "Wij ___ zaterdag boodschappen voor de hele week gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Мы ___ в субботу сделали покупки на всю неделю."
  },
  {
   "id": "l2-014",
   "level": 2,
   "text": "Hij ___ na het werk nog naar de sportschool gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы ещё сходил в спортзал."
  },
  {
   "id": "l2-015",
   "level": 2,
   "text": "Zij ___ haar telefoon op tafel laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ оставила свой телефон лежать на столе."
  },
  {
   "id": "l2-016",
   "level": 2,
   "text": "Ik ___ gisteren erg moe geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ вчера был очень уставшим."
  },
  {
   "id": "l2-017",
   "level": 2,
   "text": "Mijn zus ___ haar verjaardag thuis gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Моя сестра ___ отпраздновала свой день рождения дома."
  },
  {
   "id": "l2-018",
   "level": 2,
   "text": "Wij ___ pas om elf uur in het hotel aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ добрались до отеля только в одиннадцать часов."
  },
  {
   "id": "l2-019",
   "level": 2,
   "text": "De kinderen ___ hun kamer netjes opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Дети ___ аккуратно убрали свою комнату."
  },
  {
   "id": "l2-020",
   "level": 2,
   "text": "Hij ___ met de trein naar Den Haag gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал поездом в Гаагу."
  },
  {
   "id": "l2-021",
   "level": 2,
   "text": "Ik ___ mijn sleutel gelukkig snel gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ к счастью быстро нашёл свой ключ."
  },
  {
   "id": "l2-022",
   "level": 2,
   "text": "Zij ___ gisteren de hele avond bij haar ouders gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ вчера весь вечер пробыла у своих родителей."
  },
  {
   "id": "l2-023",
   "level": 2,
   "text": "Wij ___ na het ontbijt naar het strand gewandeld.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака пошли гулять на пляж."
  },
  {
   "id": "l2-024",
   "level": 2,
   "text": "Hij ___ voor het examen veel geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Он ___ много занимался перед экзаменом."
  },
  {
   "id": "l2-025",
   "level": 2,
   "text": "Mijn vriendin ___ een nieuwe jas in de stad gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Моя подруга ___ купила новое пальто в городе."
  },
  {
   "id": "l2-026",
   "level": 2,
   "text": "Ik ___ om zes uur van mijn werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ в шесть часов ушёл с работы."
  },
  {
   "id": "l2-027",
   "level": 2,
   "text": "De buren ___ gisteren een groot feest gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Соседи ___ вчера устроили большую вечеринку."
  },
  {
   "id": "l2-028",
   "level": 2,
   "text": "Wij ___ een uur op de bus gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ час прождали автобус."
  },
  {
   "id": "l2-029",
   "level": 2,
   "text": "Zij ___ vorige maand naar een groter huis verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в прошлом месяце переехала в дом побольше."
  },
  {
   "id": "l2-030",
   "level": 2,
   "text": "Hij ___ zijn lunch thuis vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свой обед дома."
  },
  {
   "id": "l2-031",
   "level": 2,
   "text": "Ik ___ gisteren met mijn collega over het probleem gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Я ___ вчера поговорил с коллегой о проблеме."
  },
  {
   "id": "l2-032",
   "level": 2,
   "text": "Mijn ouders ___ zondag vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мои родители ___ в воскресенье рано поехали домой."
  },
  {
   "id": "l2-033",
   "level": 2,
   "text": "Wij ___ tijdens de vakantie veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска сделали много фотографий."
  },
  {
   "id": "l2-034",
   "level": 2,
   "text": "Zij ___ een uur in de trein geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ час проспала в поезде."
  },
  {
   "id": "l2-035",
   "level": 2,
   "text": "Hij ___ gisteren zijn oude leraar in de supermarkt gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Он ___ вчера увидел своего старого учителя в супермаркете."
  },
  {
   "id": "l2-036",
   "level": 2,
   "text": "Ik ___ na het ontbijt mijn e-mails gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ после завтрака прочитал свои письма."
  },
  {
   "id": "l2-037",
   "level": 2,
   "text": "De kinderen ___ naar het park gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Дети ___ поехали в парк на велосипедах."
  },
  {
   "id": "l2-038",
   "level": 2,
   "text": "Wij ___ gisteren samen een nieuwe tafel gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера вместе купили новый стол."
  },
  {
   "id": "l2-039",
   "level": 2,
   "text": "Zij ___ om negen uur bij het station aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в девять часов пришла на вокзал."
  },
  {
   "id": "l2-040",
   "level": 2,
   "text": "Hij ___ de hele ochtend in de keuken gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Он ___ простоял на кухне всё утро."
  },
  {
   "id": "l2-041",
   "level": 2,
   "text": "Ik ___ mijn vriend gisteren een bericht gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера отправил другу сообщение."
  },
  {
   "id": "l2-042",
   "level": 2,
   "text": "Mijn zus ___ na haar studie naar België verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Моя сестра ___ после учёбы переехала в Бельгию."
  },
  {
   "id": "l2-043",
   "level": 2,
   "text": "Wij ___ zaterdagavond een leuke film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ в субботу вечером посмотрели хороший фильм."
  },
  {
   "id": "l2-044",
   "level": 2,
   "text": "Hij ___ zijn portemonnee in de auto laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил свой бумажник лежать в машине."
  },
  {
   "id": "l2-045",
   "level": 2,
   "text": "Zij ___ gisteren vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вчера рано пошла спать."
  },
  {
   "id": "l2-046",
   "level": 2,
   "text": "Ik ___ de hele middag aan mijn huiswerk gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Я ___ весь день работал над домашним заданием."
  },
  {
   "id": "l2-047",
   "level": 2,
   "text": "De bus ___ vijf minuten geleden vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Автобус ___ уехал пять минут назад."
  },
  {
   "id": "l2-048",
   "level": 2,
   "text": "Wij ___ na de lunch een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после обеда совершили долгую прогулку."
  },
  {
   "id": "l2-049",
   "level": 2,
   "text": "Hij ___ zijn afspraak helemaal vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ совсем забыл про встречу."
  },
  {
   "id": "l2-050",
   "level": 2,
   "text": "Mijn ouders ___ gisteren bij ons op bezoek geweest.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "geweest",
   "rule": "reflexief",
   "translationRu": "Мои родители ___ вчера были у нас в гостях."
  },
  {
   "id": "l2-051",
   "level": 2,
   "text": "Ik ___ vanochtend mijn ontbijt thuis gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Я ___ сегодня утром позавтракал дома."
  },
  {
   "id": "l2-052",
   "level": 2,
   "text": "Zij ___ na het werk rechtstreeks naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы сразу поехала в супермаркет."
  },
  {
   "id": "l2-053",
   "level": 2,
   "text": "Wij ___ een paar dagen in een klein dorp gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пробыли пару дней в маленькой деревне."
  },
  {
   "id": "l2-054",
   "level": 2,
   "text": "Hij ___ gisteren een lange brief aan zijn broer geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера написал длинное письмо своему брату."
  },
  {
   "id": "l2-055",
   "level": 2,
   "text": "De kinderen ___ na school naar hun oma gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Дети ___ после школы поехали к бабушке."
  },
  {
   "id": "l2-056",
   "level": 2,
   "text": "Ik ___ mijn kamer gisteren eindelijk schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера наконец убрал свою комнату."
  },
  {
   "id": "l2-057",
   "level": 2,
   "text": "Zij ___ met haar man naar Frankrijk gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ со своим мужем улетела во Францию."
  },
  {
   "id": "l2-058",
   "level": 2,
   "text": "Wij ___ tot middernacht naar muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Мы ___ слушали музыку до полуночи."
  },
  {
   "id": "l2-059",
   "level": 2,
   "text": "Hij ___ onderweg zijn telefoon verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ по дороге потерял свой телефон."
  },
  {
   "id": "l2-060",
   "level": 2,
   "text": "Ik ___ gisteren om half zeven thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера в полседьмого пришёл домой."
  },
  {
   "id": "l2-061",
   "level": 2,
   "text": "Mijn broer ___ de hele avond met zijn vrienden gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Мой брат ___ весь вечер проговорил с друзьями."
  },
  {
   "id": "l2-062",
   "level": 2,
   "text": "Wij ___ vorig jaar een nieuwe auto gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ в прошлом году купили новую машину."
  },
  {
   "id": "l2-063",
   "level": 2,
   "text": "Zij ___ na de film meteen naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после фильма сразу поехала домой."
  },
  {
   "id": "l2-064",
   "level": 2,
   "text": "Ik ___ een lekkere taart voor mijn moeder gebakken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebakken",
   "rule": "transitief",
   "translationRu": "Я ___ испёк вкусный торт для мамы."
  },
  {
   "id": "l2-065",
   "level": 2,
   "text": "Hij ___ een week bij zijn tante gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ пробыл неделю у тёти."
  },
  {
   "id": "l2-066",
   "level": 2,
   "text": "De studenten ___ na de les samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Студенты ___ после урока вместе выпили кофе."
  },
  {
   "id": "l2-067",
   "level": 2,
   "text": "Wij ___ zondagmorgen naar de markt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в воскресенье утром пошли на рынок."
  },
  {
   "id": "l2-068",
   "level": 2,
   "text": "Zij ___ haar tas in de trein laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Она ___ оставила свою сумку в поезде."
  },
  {
   "id": "l2-069",
   "level": 2,
   "text": "Ik ___ gisteren mijn oude foto's bekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bekeken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера посмотрел свои старые фотографии."
  },
  {
   "id": "l2-070",
   "level": 2,
   "text": "Hij ___ pas laat van zijn vakantie teruggekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggekomen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ вернулся из отпуска только поздно."
  },
  {
   "id": "l2-071",
   "level": 2,
   "text": "Wij ___ een hele dag in Amsterdam doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Мы ___ провели целый день в Амстердаме."
  },
  {
   "id": "l2-072",
   "level": 2,
   "text": "Zij ___ haar collega op het station ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Она ___ встретила коллегу на вокзале."
  },
  {
   "id": "l2-073",
   "level": 2,
   "text": "Ik ___ gisteren niet naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера не выходил на улицу."
  },
  {
   "id": "l2-074",
   "level": 2,
   "text": "Hij ___ zijn huiswerk voor het eten gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал домашнее задание перед ужином."
  },
  {
   "id": "l2-075",
   "level": 2,
   "text": "De kinderen ___ de hele middag in het zwembad gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Дети ___ весь день плавали в бассейне."
  },
  {
   "id": "l2-076",
   "level": 2,
   "text": "Wij ___ na het eten nog een wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после ужина ещё погуляли."
  },
  {
   "id": "l2-077",
   "level": 2,
   "text": "Zij ___ om acht uur naar haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в восемь часов ушла на работу."
  },
  {
   "id": "l2-078",
   "level": 2,
   "text": "Ik ___ mijn sleutels in mijn jaszak gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свои ключи в кармане куртки."
  },
  {
   "id": "l2-079",
   "level": 2,
   "text": "Hij ___ gisteren een interessant boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ вчера прочитал интересную книгу."
  },
  {
   "id": "l2-080",
   "level": 2,
   "text": "Mijn ouders ___ vorige week naar Spanje gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Мои родители ___ на прошлой неделе улетели в Испанию."
  },
  {
   "id": "l2-081",
   "level": 2,
   "text": "Wij ___ na de vakantie weer aan het werk begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после отпуска снова приступили к работе."
  },
  {
   "id": "l2-082",
   "level": 2,
   "text": "Zij ___ de hele nacht slecht geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ плохо спала всю ночь."
  },
  {
   "id": "l2-083",
   "level": 2,
   "text": "Ik ___ gisteren met mijn buurvrouw gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера поговорил с соседкой."
  },
  {
   "id": "l2-084",
   "level": 2,
   "text": "Hij ___ zijn fiets voor het huis gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Он ___ поставил свой велосипед перед домом."
  },
  {
   "id": "l2-085",
   "level": 2,
   "text": "De kinderen ___ vroeg wakker geworden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "wakker geworden",
   "rule": "transitief",
   "translationRu": "Дети ___ рано проснулись."
  },
  {
   "id": "l2-086",
   "level": 2,
   "text": "Wij ___ een nieuwe koelkast voor de keuken gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый холодильник для кухни."
  },
  {
   "id": "l2-087",
   "level": 2,
   "text": "Zij ___ gisteren bij haar vriendin gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Она ___ вчера поела у подруги."
  },
  {
   "id": "l2-088",
   "level": 2,
   "text": "Ik ___ na mijn werk nog boodschappen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ после работы ещё сделал покупки."
  },
  {
   "id": "l2-089",
   "level": 2,
   "text": "Hij ___ naar een andere kamer verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ переехал в другую комнату."
  },
  {
   "id": "l2-090",
   "level": 2,
   "text": "Wij ___ de hele avond thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ весь вечер просидели дома."
  },
  {
   "id": "l2-091",
   "level": 2,
   "text": "Zij ___ haar examen vorige week gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Она ___ сдала свой экзамен на прошлой неделе."
  },
  {
   "id": "l2-092",
   "level": 2,
   "text": "Ik ___ gisteren te laat opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ вчера слишком поздно встал."
  },
  {
   "id": "l2-093",
   "level": 2,
   "text": "Hij ___ zijn ouders in het weekend bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Он ___ навестил своих родителей в выходные."
  },
  {
   "id": "l2-094",
   "level": 2,
   "text": "Wij ___ met de bus naar het centrum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали на автобусе в центр."
  },
  {
   "id": "l2-095",
   "level": 2,
   "text": "Zij ___ haar telefoon tijdens de wandeling verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Она ___ потеряла свой телефон во время прогулки."
  },
  {
   "id": "l2-096",
   "level": 2,
   "text": "Ik ___ een uur op mijn vriendin gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ прождал свою подругу час."
  },
  {
   "id": "l2-097",
   "level": 2,
   "text": "Hij ___ gisteren ziek thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ вчера остался дома из-за болезни."
  },
  {
   "id": "l2-098",
   "level": 2,
   "text": "Wij ___ veel nieuwe mensen tijdens de vakantie ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Мы ___ познакомились со многими новыми людьми во время отпуска."
  },
  {
   "id": "l2-099",
   "level": 2,
   "text": "Zij ___ om tien uur naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ в десять часов пошла спать."
  },
  {
   "id": "l2-100",
   "level": 2,
   "text": "Ik ___ gisteren mijn hele kamer geschilderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschilderd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера покрасил всю свою комнату."
  },
  {
   "id": "l2-101",
   "level": 2,
   "text": "Wij ___ zaterdag met de trein naar Haarlem gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в субботу поехали поездом в Харлем."
  },
  {
   "id": "l2-102",
   "level": 2,
   "text": "Zij ___ haar verjaardag in een restaurant gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Она ___ отпраздновала свой день рождения в ресторане."
  },
  {
   "id": "l2-103",
   "level": 2,
   "text": "Ik ___ gisteren mijn beste vriend opgebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgebeld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера позвонил своему лучшему другу."
  },
  {
   "id": "l2-104",
   "level": 2,
   "text": "Hij ___ na het ontbijt naar zijn werk gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после завтрака поехал на работу на велосипеде."
  },
  {
   "id": "l2-105",
   "level": 2,
   "text": "De kinderen ___ de hele middag buiten gespeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gespeeld",
   "rule": "transitief",
   "translationRu": "Дети ___ весь день играли на улице."
  },
  {
   "id": "l2-106",
   "level": 2,
   "text": "Wij ___ pas laat in het hotel aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ добрались до отеля только поздно."
  },
  {
   "id": "l2-107",
   "level": 2,
   "text": "Zij ___ voor haar examen hard gestudeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gestudeerd",
   "rule": "transitief",
   "translationRu": "Она ___ усердно занималась перед экзаменом."
  },
  {
   "id": "l2-108",
   "level": 2,
   "text": "Ik ___ mijn paspoort thuis laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой паспорт дома."
  },
  {
   "id": "l2-109",
   "level": 2,
   "text": "Hij ___ vorige maand een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ в прошлом месяце нашёл новую работу."
  },
  {
   "id": "l2-110",
   "level": 2,
   "text": "Wij ___ na het eten nog naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после ужина ещё сходили в супермаркет."
  },
  {
   "id": "l2-111",
   "level": 2,
   "text": "Zij ___ de hele ochtend in bed gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пролежала в постели всё утро."
  },
  {
   "id": "l2-112",
   "level": 2,
   "text": "Ik ___ gisteren een lange wandeling door de stad gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера совершил долгую прогулку по городу."
  },
  {
   "id": "l2-113",
   "level": 2,
   "text": "Hij ___ zijn trein naar Utrecht gemist.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Он ___ опоздал на свой поезд в Утрехт."
  },
  {
   "id": "l2-114",
   "level": 2,
   "text": "Wij ___ vorig weekend bij vrienden geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Мы ___ в прошлые выходные ночевали у друзей."
  },
  {
   "id": "l2-115",
   "level": 2,
   "text": "Zij ___ om zeven uur naar school vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в семь часов уехала в школу."
  },
  {
   "id": "l2-116",
   "level": 2,
   "text": "Ik ___ een interessant artikel in de krant gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ прочитал интересную статью в газете."
  },
  {
   "id": "l2-117",
   "level": 2,
   "text": "Hij ___ zijn zus op het vliegveld opgehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgehaald",
   "rule": "transitief",
   "translationRu": "Он ___ встретил свою сестру в аэропорту."
  },
  {
   "id": "l2-118",
   "level": 2,
   "text": "Wij ___ in de vakantie veel gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ во время отпуска много плавали."
  },
  {
   "id": "l2-119",
   "level": 2,
   "text": "Zij ___ naar een ander appartement verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другую квартиру."
  },
  {
   "id": "l2-120",
   "level": 2,
   "text": "Ik ___ gisteren mijn kleding gewassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewassen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера постирал свою одежду."
  },
  {
   "id": "l2-121",
   "level": 2,
   "text": "Hij ___ na zijn werk nog een uur gewandeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewandeld",
   "rule": "beweging-duur",
   "translationRu": "Он ___ после работы ещё час гулял."
  },
  {
   "id": "l2-122",
   "level": 2,
   "text": "Wij ___ een leuke avond met onze buren gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ провели хороший вечер с соседями."
  },
  {
   "id": "l2-123",
   "level": 2,
   "text": "Zij ___ haar boek in de bus vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ забыла свою книгу в автобусе."
  },
  {
   "id": "l2-124",
   "level": 2,
   "text": "Ik ___ om acht uur van huis vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ в восемь часов вышел из дома."
  },
  {
   "id": "l2-125",
   "level": 2,
   "text": "De kinderen ___ naar hun opa en oma gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Дети ___ поехали к бабушке и дедушке."
  },
  {
   "id": "l2-126",
   "level": 2,
   "text": "Wij ___ gisteren samen gekookt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekookt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера вместе готовили."
  },
  {
   "id": "l2-127",
   "level": 2,
   "text": "Hij ___ zijn oude computer weggegooid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "weggegooid",
   "rule": "transitief",
   "translationRu": "Он ___ выбросил свой старый компьютер."
  },
  {
   "id": "l2-128",
   "level": 2,
   "text": "Zij ___ laat thuisgekomen na het feest.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "feest",
   "rule": "transitief",
   "translationRu": "Она ___ поздно вернулась домой после вечеринки."
  },
  {
   "id": "l2-129",
   "level": 2,
   "text": "Ik ___ een cadeau voor mijn vriendin gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил подарок для своей подруги."
  },
  {
   "id": "l2-130",
   "level": 2,
   "text": "Wij ___ de hele middag op het terras gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ просидели на террасе весь день."
  },
  {
   "id": "l2-131",
   "level": 2,
   "text": "Hij ___ tijdens de vakantie veel nieuwe gerechten gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ во время отпуска попробовал много новых блюд."
  },
  {
   "id": "l2-132",
   "level": 2,
   "text": "Zij ___ na de les naar de bibliotheek gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после урока пошла пешком в библиотеку."
  },
  {
   "id": "l2-133",
   "level": 2,
   "text": "Ik ___ mijn fiets gisteren naar de fietsenmaker gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера отвёз свой велосипед в мастерскую."
  },
  {
   "id": "l2-134",
   "level": 2,
   "text": "Wij ___ een paar uur in het museum doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Мы ___ провели пару часов в музее."
  },
  {
   "id": "l2-135",
   "level": 2,
   "text": "Hij ___ zijn kamer opnieuw ingericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ingericht",
   "rule": "transitief",
   "translationRu": "Он ___ заново обустроил свою комнату."
  },
  {
   "id": "l2-136",
   "level": 2,
   "text": "Zij ___ om twaalf uur naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ в двенадцать часов поехала домой."
  },
  {
   "id": "l2-137",
   "level": 2,
   "text": "Ik ___ gisteren veel water gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера выпил много воды."
  },
  {
   "id": "l2-138",
   "level": 2,
   "text": "Wij ___ onze vrienden op het station ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Мы ___ встретили своих друзей на вокзале."
  },
  {
   "id": "l2-139",
   "level": 2,
   "text": "Hij ___ de hele dag achter zijn bureau gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ просидел за столом весь день."
  },
  {
   "id": "l2-140",
   "level": 2,
   "text": "Zij ___ een nieuwe telefoon besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Она ___ заказала новый телефон."
  },
  {
   "id": "l2-141",
   "level": 2,
   "text": "Ik ___ na het werk direct naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы сразу пошёл домой."
  },
  {
   "id": "l2-142",
   "level": 2,
   "text": "Wij ___ zondag naar de kust gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в воскресенье поехали на побережье."
  },
  {
   "id": "l2-143",
   "level": 2,
   "text": "Hij ___ zijn verjaardag met zijn familie gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Он ___ отпраздновал свой день рождения с семьёй."
  },
  {
   "id": "l2-144",
   "level": 2,
   "text": "Zij ___ een paar dagen in Londen gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пробыла пару дней в Лондоне."
  },
  {
   "id": "l2-145",
   "level": 2,
   "text": "Ik ___ gisteren mijn huiswerk niet afgemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "afgemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера не доделал домашнее задание."
  },
  {
   "id": "l2-146",
   "level": 2,
   "text": "De trein ___ precies op tijd aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Поезд ___ прибыл точно вовремя."
  },
  {
   "id": "l2-147",
   "level": 2,
   "text": "Wij ___ na de vakantie weer naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после отпуска снова пошли в школу."
  },
  {
   "id": "l2-148",
   "level": 2,
   "text": "Zij ___ haar sleutels op kantoor laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ оставила свои ключи на работе."
  },
  {
   "id": "l2-149",
   "level": 2,
   "text": "Hij ___ een uur met zijn moeder gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Он ___ час проговорил по телефону с мамой."
  },
  {
   "id": "l2-150",
   "level": 2,
   "text": "Ik ___ gisteren mijn boodschappen in de keuken gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ вчера поставил покупки в кухне."
  },
  {
   "id": "l2-151",
   "level": 2,
   "text": "Wij ___ naar een rustig hotel gezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ искали тихий отель."
  },
  {
   "id": "l2-152",
   "level": 2,
   "text": "Zij ___ vroeg uit bed gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано встала с кровати."
  },
  {
   "id": "l2-153",
   "level": 2,
   "text": "Hij ___ gisteren zijn auto gewassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewassen",
   "rule": "transitief",
   "translationRu": "Он ___ вчера помыл свою машину."
  },
  {
   "id": "l2-154",
   "level": 2,
   "text": "Ik ___ een leuke foto van mijn familie gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ сделал красивую фотографию своей семьи."
  },
  {
   "id": "l2-155",
   "level": 2,
   "text": "De kinderen ___ na het eten naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Дети ___ после еды вышли на улицу."
  },
  {
   "id": "l2-156",
   "level": 2,
   "text": "Wij ___ de hele dag op het strand gelegen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelegen",
   "rule": "transitief",
   "translationRu": "Мы ___ пролежали на пляже весь день."
  },
  {
   "id": "l2-157",
   "level": 2,
   "text": "Zij ___ haar oude kleren aan een goed doel gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Она ___ отдала свою старую одежду на благотворительность."
  },
  {
   "id": "l2-158",
   "level": 2,
   "text": "Ik ___ mijn collega op het station ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Я ___ встретил коллегу на вокзале."
  },
  {
   "id": "l2-159",
   "level": 2,
   "text": "Hij ___ na het werk naar de kapper gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы пошёл к парикмахеру."
  },
  {
   "id": "l2-160",
   "level": 2,
   "text": "Wij ___ gisteren een spannende film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера посмотрели захватывающий фильм."
  },
  {
   "id": "l2-161",
   "level": 2,
   "text": "Zij ___ haar fiets bij het station gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Она ___ поставила свой велосипед у вокзала."
  },
  {
   "id": "l2-162",
   "level": 2,
   "text": "Ik ___ de hele nacht bij mijn zieke kind gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ пробыл всю ночь у своего больного ребёнка."
  },
  {
   "id": "l2-163",
   "level": 2,
   "text": "Hij ___ vorige zomer naar Portugal gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ прошлым летом ездил в Португалию."
  },
  {
   "id": "l2-164",
   "level": 2,
   "text": "Wij ___ samen een plan voor de vakantie gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вместе составили план на отпуск."
  },
  {
   "id": "l2-165",
   "level": 2,
   "text": "Zij ___ haar trein net op tijd gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Она ___ успела на свой поезд как раз вовремя."
  },
  {
   "id": "l2-166",
   "level": 2,
   "text": "Ik ___ gisteren mijn moeder geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера помог своей маме."
  },
  {
   "id": "l2-167",
   "level": 2,
   "text": "Hij ___ om negen uur op kantoor aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в девять часов пришёл на работу."
  },
  {
   "id": "l2-168",
   "level": 2,
   "text": "Wij ___ een uur in de rij gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Мы ___ простояли в очереди час."
  },
  {
   "id": "l2-169",
   "level": 2,
   "text": "Zij ___ na de lunch naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после обеда поехала домой."
  },
  {
   "id": "l2-170",
   "level": 2,
   "text": "Ik ___ een nieuwe broek in de uitverkoop gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил новые брюки на распродаже."
  },
  {
   "id": "l2-171",
   "level": 2,
   "text": "Hij ___ gisteren niet goed geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ вчера плохо спал."
  },
  {
   "id": "l2-172",
   "level": 2,
   "text": "Wij ___ na school met de kinderen naar het park gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после школы пошли с детьми в парк."
  },
  {
   "id": "l2-173",
   "level": 2,
   "text": "Zij ___ haar kamer helemaal veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ полностью изменила свою комнату."
  },
  {
   "id": "l2-174",
   "level": 2,
   "text": "Ik ___ mijn verjaardag met mijn vrienden gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Я ___ отпраздновал свой день рождения с друзьями."
  },
  {
   "id": "l2-175",
   "level": 2,
   "text": "Hij ___ een paar dagen bij zijn broer gelogeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelogeerd",
   "rule": "transitief",
   "translationRu": "Он ___ прогостил пару дней у своего брата."
  },
  {
   "id": "l2-176",
   "level": 2,
   "text": "Wij ___ gisteren vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера рано поехали домой."
  },
  {
   "id": "l2-177",
   "level": 2,
   "text": "Zij ___ haar bril in de auto gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свои очки в машине."
  },
  {
   "id": "l2-178",
   "level": 2,
   "text": "Ik ___ de hele avond een boek gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ читал книгу весь вечер."
  },
  {
   "id": "l2-179",
   "level": 2,
   "text": "Hij ___ met zijn ouders over de vakantie gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ поговорил с родителями об отпуске."
  },
  {
   "id": "l2-180",
   "level": 2,
   "text": "Wij ___ vorig jaar naar een andere stad verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в прошлом году переехали в другой город."
  },
  {
   "id": "l2-181",
   "level": 2,
   "text": "Zij ___ na het ontbijt de afwas gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ после завтрака помыла посуду."
  },
  {
   "id": "l2-182",
   "level": 2,
   "text": "Ik ___ gisteren mijn fiets thuis laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Я ___ вчера оставил свой велосипед дома."
  },
  {
   "id": "l2-183",
   "level": 2,
   "text": "Hij ___ om vijf uur van zijn werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в пять часов ушёл с работы."
  },
  {
   "id": "l2-184",
   "level": 2,
   "text": "Wij ___ samen naar een concert gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вместе ходили на концерт."
  },
  {
   "id": "l2-185",
   "level": 2,
   "text": "Zij ___ een lekkere maaltijd voor haar gasten gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ приготовила вкусный ужин для гостей."
  },
  {
   "id": "l2-186",
   "level": 2,
   "text": "Ik ___ na de film nog een kop koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Я ___ после фильма выпил ещё чашку кофе."
  },
  {
   "id": "l2-187",
   "level": 2,
   "text": "Hij ___ zijn oude vrienden weer ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Он ___ снова встретил своих старых друзей."
  },
  {
   "id": "l2-188",
   "level": 2,
   "text": "Wij ___ twee uur in de trein gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ просидели в поезде два часа."
  },
  {
   "id": "l2-189",
   "level": 2,
   "text": "Zij ___ vroeg naar bed gegaan omdat ze moe was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать, потому что устала."
  },
  {
   "id": "l2-190",
   "level": 2,
   "text": "Ik ___ gisteren mijn hele bureau opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера прибрал весь свой стол."
  },
  {
   "id": "l2-191",
   "level": 2,
   "text": "Hij ___ naar het ziekenhuis gegaan voor een afspraak.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "afspraak",
   "rule": "transitief",
   "translationRu": "Он ___ поехал в больницу на приём."
  },
  {
   "id": "l2-192",
   "level": 2,
   "text": "Wij ___ een mooie dag aan zee gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ провели хороший день на море."
  },
  {
   "id": "l2-193",
   "level": 2,
   "text": "Zij ___ haar tas thuis vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ забыла свою сумку дома."
  },
  {
   "id": "l2-194",
   "level": 2,
   "text": "Ik ___ na school naar mijn vriendin gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после школы поехал на велосипеде к подруге."
  },
  {
   "id": "l2-195",
   "level": 2,
   "text": "Hij ___ een nieuwe baan in Rotterdam gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл новую работу в Роттердаме."
  },
  {
   "id": "l2-196",
   "level": 2,
   "text": "Wij ___ gisteren tot laat over ons werk gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "reflexief",
   "translationRu": "Мы ___ вчера допоздна говорили о нашей работе."
  },
  {
   "id": "l2-197",
   "level": 2,
   "text": "Zij ___ vorige week naar Duitsland gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ на прошлой неделе поехала в Германию."
  },
  {
   "id": "l2-198",
   "level": 2,
   "text": "Ik ___ mijn oude jas weggegooid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "weggegooid",
   "rule": "transitief",
   "translationRu": "Я ___ выбросил свою старую куртку."
  },
  {
   "id": "l2-199",
   "level": 2,
   "text": "Hij ___ gisteren bij zijn ouders gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ вчера поел у родителей."
  },
  {
   "id": "l2-200",
   "level": 2,
   "text": "Wij ___ na het ontbijt naar de markt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака пошли на рынок."
  },
  {
   "id": "l2-201",
   "level": 2,
   "text": "Zij ___ gisteren met haar zus naar de stad gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вчера поехала с сестрой в город."
  },
  {
   "id": "l2-202",
   "level": 2,
   "text": "Ik ___ een cadeau voor mijn vader gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил подарок для своего отца."
  },
  {
   "id": "l2-203",
   "level": 2,
   "text": "Hij ___ de hele ochtend op zijn kamer gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ пробыл у себя в комнате всё утро."
  },
  {
   "id": "l2-204",
   "level": 2,
   "text": "Wij ___ na het werk samen boodschappen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Мы ___ после работы вместе сделали покупки."
  },
  {
   "id": "l2-205",
   "level": 2,
   "text": "Zij ___ haar trein naar Amsterdam gemist.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Она ___ опоздала на свой поезд в Амстердам."
  },
  {
   "id": "l2-206",
   "level": 2,
   "text": "Ik ___ om half negen op kantoor aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ в полдевятого пришёл на работу."
  },
  {
   "id": "l2-207",
   "level": 2,
   "text": "Hij ___ zijn vriend een lange e-mail gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Он ___ отправил другу длинное письмо."
  },
  {
   "id": "l2-208",
   "level": 2,
   "text": "Wij ___ vorige zomer in een klein huisje gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ прошлым летом жили в маленьком домике."
  },
  {
   "id": "l2-209",
   "level": 2,
   "text": "Zij ___ na de cursus naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после курсов поехала домой на велосипеде."
  },
  {
   "id": "l2-210",
   "level": 2,
   "text": "Ik ___ gisteren mijn favoriete restaurant bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера посетил свой любимый ресторан."
  },
  {
   "id": "l2-211",
   "level": 2,
   "text": "Hij ___ zijn sleutels op tafel gelegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelegd",
   "rule": "transitief",
   "translationRu": "Он ___ положил свои ключи на стол."
  },
  {
   "id": "l2-212",
   "level": 2,
   "text": "Wij ___ een nieuwe bank voor de woonkamer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый диван для гостиной."
  },
  {
   "id": "l2-213",
   "level": 2,
   "text": "Zij ___ vroeg naar school vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано уехала в школу."
  },
  {
   "id": "l2-214",
   "level": 2,
   "text": "Ik ___ de hele middag met mijn dochter gespeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gespeeld",
   "rule": "transitief",
   "translationRu": "Я ___ весь день играл со своей дочкой."
  },
  {
   "id": "l2-215",
   "level": 2,
   "text": "Hij ___ naar zijn ouders in Duitsland gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал к родителям в Германию."
  },
  {
   "id": "l2-216",
   "level": 2,
   "text": "Wij ___ gisteren een wandeling langs de rivier gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера погуляли вдоль реки."
  },
  {
   "id": "l2-217",
   "level": 2,
   "text": "Zij ___ haar telefoon in de keuken gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свой телефон в кухне."
  },
  {
   "id": "l2-218",
   "level": 2,
   "text": "Ik ___ na het eten naar de sportschool gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после ужина пошёл в спортзал."
  },
  {
   "id": "l2-219",
   "level": 2,
   "text": "Hij ___ een interessant gesprek met zijn baas gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Он ___ провёл интересный разговор со своим начальником."
  },
  {
   "id": "l2-220",
   "level": 2,
   "text": "Wij ___ om elf uur thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в одиннадцать часов вернулись домой."
  },
  {
   "id": "l2-221",
   "level": 2,
   "text": "Zij ___ een paar dagen bij haar vriendin gelogeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelogeerd",
   "rule": "transitief",
   "translationRu": "Она ___ прогостила пару дней у подруги."
  },
  {
   "id": "l2-222",
   "level": 2,
   "text": "Ik ___ mijn huiswerk voor het slapen gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ сделал домашнее задание перед сном."
  },
  {
   "id": "l2-223",
   "level": 2,
   "text": "Hij ___ zijn fiets bij het station achtergelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "achtergelaten",
   "rule": "transitief",
   "translationRu": "Он ___ оставил свой велосипед у вокзала."
  },
  {
   "id": "l2-224",
   "level": 2,
   "text": "Wij ___ tijdens de vakantie veel lokale gerechten gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска попробовали много местных блюд."
  },
  {
   "id": "l2-225",
   "level": 2,
   "text": "Zij ___ naar een nieuwe school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ пошла в новую школу."
  },
  {
   "id": "l2-226",
   "level": 2,
   "text": "Ik ___ gisteren een brief van mijn broer gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера получил письмо от своего брата."
  },
  {
   "id": "l2-227",
   "level": 2,
   "text": "Hij ___ na zijn werk naar de supermarkt gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы поехал в супермаркет."
  },
  {
   "id": "l2-228",
   "level": 2,
   "text": "Wij ___ de hele avond naar muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер слушали музыку."
  },
  {
   "id": "l2-229",
   "level": 2,
   "text": "Zij ___ haar oude baan opgezegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgezegd",
   "rule": "transitief",
   "translationRu": "Она ___ уволилась со старой работы."
  },
  {
   "id": "l2-230",
   "level": 2,
   "text": "Ik ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ рано пошёл спать."
  },
  {
   "id": "l2-231",
   "level": 2,
   "text": "Hij ___ zijn familie in het weekend bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Он ___ навестил свою семью в выходные."
  },
  {
   "id": "l2-232",
   "level": 2,
   "text": "Wij ___ gisteren thuis een film gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера посмотрели фильм дома."
  },
  {
   "id": "l2-233",
   "level": 2,
   "text": "Zij ___ na de vakantie weer naar Nederland teruggekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekomen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после отпуска вернулась в Нидерланды."
  },
  {
   "id": "l2-234",
   "level": 2,
   "text": "Ik ___ een uur op de trein gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ прождал поезд час."
  },
  {
   "id": "l2-235",
   "level": 2,
   "text": "Hij ___ zijn portemonnee in zijn jas gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл свой бумажник в куртке."
  },
  {
   "id": "l2-236",
   "level": 2,
   "text": "Wij ___ samen een lekkere maaltijd gekookt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekookt",
   "rule": "transitief",
   "translationRu": "Мы ___ вместе приготовили вкусный ужин."
  },
  {
   "id": "l2-237",
   "level": 2,
   "text": "Zij ___ om zes uur naar haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в шесть часов ушла на работу."
  },
  {
   "id": "l2-238",
   "level": 2,
   "text": "Ik ___ gisteren een lange douche genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера принял долгий душ."
  },
  {
   "id": "l2-239",
   "level": 2,
   "text": "Hij ___ met zijn kinderen naar de speeltuin gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ пошёл с детьми на детскую площадку."
  },
  {
   "id": "l2-240",
   "level": 2,
   "text": "Wij ___ de hele middag in het park gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ просидели в парке весь день."
  },
  {
   "id": "l2-241",
   "level": 2,
   "text": "Zij ___ een nieuwe laptop gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новый ноутбук."
  },
  {
   "id": "l2-242",
   "level": 2,
   "text": "Ik ___ mijn vriendin op haar verjaardag gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ позвонил подруге в день рождения."
  },
  {
   "id": "l2-243",
   "level": 2,
   "text": "Hij ___ vorige maand naar een ander huis verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в прошлом месяце переехал в другой дом."
  },
  {
   "id": "l2-244",
   "level": 2,
   "text": "Wij ___ een paar mooie plaatsen bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ побывали в паре красивых мест."
  },
  {
   "id": "l2-245",
   "level": 2,
   "text": "Zij ___ na de les nog met haar docent gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Она ___ после урока ещё поговорила с преподавателем."
  },
  {
   "id": "l2-246",
   "level": 2,
   "text": "Ik ___ gisteren mijn fiets schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера почистил свой велосипед."
  },
  {
   "id": "l2-247",
   "level": 2,
   "text": "Hij ___ naar de dokter geweest omdat hij zich niet goed voelde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geweest",
   "rule": "reflexief",
   "translationRu": "Он ___ ходил к врачу, потому что плохо себя чувствовал."
  },
  {
   "id": "l2-248",
   "level": 2,
   "text": "Wij ___ om acht uur bij het restaurant aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в восемь часов пришли к ресторану."
  },
  {
   "id": "l2-249",
   "level": 2,
   "text": "Zij ___ haar kinderen naar school gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Она ___ отвезла своих детей в школу."
  },
  {
   "id": "l2-250",
   "level": 2,
   "text": "Ik ___ mijn oude foto's aan mijn vrienden laten zien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten zien",
   "rule": "groeps-inf",
   "translationRu": "Я ___ показал свои старые фотографии друзьям."
  },
  {
   "id": "l2-251",
   "level": 2,
   "text": "Hij ___ een uur in de wachtkamer gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ просидел в приёмной час."
  },
  {
   "id": "l2-252",
   "level": 2,
   "text": "Wij ___ naar een gezellig café gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в уютное кафе."
  },
  {
   "id": "l2-253",
   "level": 2,
   "text": "Zij ___ gisteren haar examen gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ вчера сдала свой экзамен."
  },
  {
   "id": "l2-254",
   "level": 2,
   "text": "Ik ___ mijn jas in de trein laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою куртку в поезде."
  },
  {
   "id": "l2-255",
   "level": 2,
   "text": "Hij ___ na het ontbijt de hond uitgelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "uitgelaten",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака выгулял собаку."
  },
  {
   "id": "l2-256",
   "level": 2,
   "text": "Wij ___ vorig jaar een lange reis door Spanje gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ в прошлом году совершили долгое путешествие по Испании."
  },
  {
   "id": "l2-257",
   "level": 2,
   "text": "Zij ___ laat van haar werk thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поздно вернулась домой с работы."
  },
  {
   "id": "l2-258",
   "level": 2,
   "text": "Ik ___ mijn collega een bericht gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Я ___ отправил коллеге сообщение."
  },
  {
   "id": "l2-259",
   "level": 2,
   "text": "Hij ___ zijn kamer gisteren geschilderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschilderd",
   "rule": "transitief",
   "translationRu": "Он ___ вчера покрасил свою комнату."
  },
  {
   "id": "l2-260",
   "level": 2,
   "text": "Wij ___ na het eten een spel gespeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gespeeld",
   "rule": "transitief",
   "translationRu": "Мы ___ после ужина поиграли в игру."
  },
  {
   "id": "l2-261",
   "level": 2,
   "text": "Zij ___ naar het buitenland verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала за границу."
  },
  {
   "id": "l2-262",
   "level": 2,
   "text": "Ik ___ een paar nieuwe schoenen gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил пару новых туфель."
  },
  {
   "id": "l2-263",
   "level": 2,
   "text": "Hij ___ de hele dag in de tuin gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ проработал в саду весь день."
  },
  {
   "id": "l2-264",
   "level": 2,
   "text": "Wij ___ met de bus naar het centrum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали на автобусе в центр."
  },
  {
   "id": "l2-265",
   "level": 2,
   "text": "Zij ___ haar broer op het vliegveld ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Она ___ встретила своего брата в аэропорту."
  },
  {
   "id": "l2-266",
   "level": 2,
   "text": "Ik ___ gisteren niet veel gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Я ___ вчера мало ел."
  },
  {
   "id": "l2-267",
   "level": 2,
   "text": "Hij ___ om zeven uur uit huis vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в семь часов вышел из дома."
  },
  {
   "id": "l2-268",
   "level": 2,
   "text": "Wij ___ een lange tijd op onze vrienden gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ долго прождали своих друзей."
  },
  {
   "id": "l2-269",
   "level": 2,
   "text": "Zij ___ na de vakantie weer aan het werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после отпуска снова вышла на работу."
  },
  {
   "id": "l2-270",
   "level": 2,
   "text": "Ik ___ mijn sleutel onder de tafel gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свой ключ под столом."
  },
  {
   "id": "l2-271",
   "level": 2,
   "text": "Hij ___ gisteren een boek voor zijn kinderen gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ вчера прочитал детям книгу."
  },
  {
   "id": "l2-272",
   "level": 2,
   "text": "Wij ___ zaterdag naar de markt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в субботу пошли на рынок."
  },
  {
   "id": "l2-273",
   "level": 2,
   "text": "Zij ___ een heerlijke taart voor haar verjaardag gebakken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebakken",
   "rule": "transitief",
   "translationRu": "Она ___ испекла вкусный торт на свой день рождения."
  },
  {
   "id": "l2-274",
   "level": 2,
   "text": "Ik ___ een paar dagen ziek geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ пробыл пару дней больным."
  },
  {
   "id": "l2-275",
   "level": 2,
   "text": "Hij ___ zijn auto bij het station geparkeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geparkeerd",
   "rule": "transitief",
   "translationRu": "Он ___ припарковал свою машину у вокзала."
  },
  {
   "id": "l2-276",
   "level": 2,
   "text": "Wij ___ de hele avond bij onze vrienden gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пробыли у друзей весь вечер."
  },
  {
   "id": "l2-277",
   "level": 2,
   "text": "Zij ___ naar een nieuwe woning gezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezocht",
   "rule": "transitief",
   "translationRu": "Она ___ искала новое жильё."
  },
  {
   "id": "l2-278",
   "level": 2,
   "text": "Ik ___ gisteren mijn moeder naar het ziekenhuis gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера отвёз маму в больницу."
  },
  {
   "id": "l2-279",
   "level": 2,
   "text": "Hij ___ na het werk met zijn collega's gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Он ___ после работы поел с коллегами."
  },
  {
   "id": "l2-280",
   "level": 2,
   "text": "Wij ___ om tien uur in Amsterdam aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в десять часов прибыли в Амстердам."
  },
  {
   "id": "l2-281",
   "level": 2,
   "text": "Zij ___ haar oude telefoon verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Она ___ продала свой старый телефон."
  },
  {
   "id": "l2-282",
   "level": 2,
   "text": "Ik ___ mijn kamer gisteren netjes gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера аккуратно прибрал свою комнату."
  },
  {
   "id": "l2-283",
   "level": 2,
   "text": "Hij ___ met de trein naar Brussel gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал поездом в Брюссель."
  },
  {
   "id": "l2-284",
   "level": 2,
   "text": "Wij ___ tijdens de wandeling veel foto's genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Мы ___ во время прогулки сделали много фотографий."
  },
  {
   "id": "l2-285",
   "level": 2,
   "text": "Zij ___ vroeg wakker geworden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "wakker geworden",
   "rule": "transitief",
   "translationRu": "Она ___ рано проснулась."
  },
  {
   "id": "l2-286",
   "level": 2,
   "text": "Ik ___ gisteren een interessante documentaire gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Я ___ вчера посмотрел интересный документальный фильм."
  },
  {
   "id": "l2-287",
   "level": 2,
   "text": "Hij ___ zijn vakantie goed voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Он ___ хорошо подготовился к отпуску."
  },
  {
   "id": "l2-288",
   "level": 2,
   "text": "Wij ___ na het ontbijt naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака вышли на улицу."
  },
  {
   "id": "l2-289",
   "level": 2,
   "text": "Zij ___ haar fiets thuis laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Она ___ оставила свой велосипед дома."
  },
  {
   "id": "l2-290",
   "level": 2,
   "text": "Ik ___ mijn broer op zijn verjaardag bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Я ___ навестил брата в его день рождения."
  },
  {
   "id": "l2-291",
   "level": 2,
   "text": "Hij ___ een paar dagen bij zijn ouders gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ пробыл пару дней у родителей."
  },
  {
   "id": "l2-292",
   "level": 2,
   "text": "Wij ___ gisteren samen naar de bioscoop gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера вместе ходили в кино."
  },
  {
   "id": "l2-293",
   "level": 2,
   "text": "Zij ___ haar boodschappen online besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Она ___ заказала свои покупки онлайн."
  },
  {
   "id": "l2-294",
   "level": 2,
   "text": "Ik ___ de hele middag op mijn werk gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Я ___ просидел на работе весь день."
  },
  {
   "id": "l2-295",
   "level": 2,
   "text": "Hij ___ zijn trein op het laatste moment gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Он ___ успел на свой поезд в последний момент."
  },
  {
   "id": "l2-296",
   "level": 2,
   "text": "Wij ___ na het feest met de taxi naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после вечеринки поехали домой на такси."
  },
  {
   "id": "l2-297",
   "level": 2,
   "text": "Zij ___ een mooi cadeau van haar ouders gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ получила красивый подарок от родителей."
  },
  {
   "id": "l2-298",
   "level": 2,
   "text": "Ik ___ gisteren mijn administratie gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ вчера разобрался со своими документами."
  },
  {
   "id": "l2-299",
   "level": 2,
   "text": "Hij ___ zijn vriendin op het station opgehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgehaald",
   "rule": "transitief",
   "translationRu": "Он ___ встретил свою подругу на вокзале."
  },
  {
   "id": "l2-300",
   "level": 2,
   "text": "Wij ___ een paar uur in de stad gewinkeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewinkeld",
   "rule": "transitief",
   "translationRu": "Мы ___ пару часов ходили по магазинам в городе."
  },
  {
   "id": "l2-301",
   "level": 2,
   "text": "Ik ___ vorige week voor het eerst naar Parijs gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ на прошлой неделе впервые поехал в Париж."
  },
  {
   "id": "l2-302",
   "level": 2,
   "text": "Zij ___ haar hele weekend bij haar familie doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Она ___ провела все выходные у своей семьи."
  },
  {
   "id": "l2-303",
   "level": 2,
   "text": "Hij ___ gisteren zijn afspraak vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ вчера забыл про встречу."
  },
  {
   "id": "l2-304",
   "level": 2,
   "text": "Wij ___ na het ontbijt naar het centrum gewandeld.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака пошли пешком в центр."
  },
  {
   "id": "l2-305",
   "level": 2,
   "text": "Ik ___ een nieuwe stoel voor mijn kamer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил новый стул для своей комнаты."
  },
  {
   "id": "l2-306",
   "level": 2,
   "text": "Zij ___ laat op haar werk aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ поздно пришла на работу."
  },
  {
   "id": "l2-307",
   "level": 2,
   "text": "Hij ___ zijn broer een bericht gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Он ___ отправил брату сообщение."
  },
  {
   "id": "l2-308",
   "level": 2,
   "text": "Wij ___ de hele middag op het strand gelegen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelegen",
   "rule": "transitief",
   "translationRu": "Мы ___ пролежали на пляже весь день."
  },
  {
   "id": "l2-309",
   "level": 2,
   "text": "Ik ___ na mijn werk nog naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы ещё сходил в супермаркет."
  },
  {
   "id": "l2-310",
   "level": 2,
   "text": "Zij ___ een interessante cursus gevolgd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevolgd",
   "rule": "transitief",
   "translationRu": "Она ___ прошла интересный курс."
  },
  {
   "id": "l2-311",
   "level": 2,
   "text": "Hij ___ vorige maand naar een andere afdeling verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в прошлом месяце перешёл в другой отдел."
  },
  {
   "id": "l2-312",
   "level": 2,
   "text": "Wij ___ gisteren samen een maaltijd gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера вместе приготовили еду."
  },
  {
   "id": "l2-313",
   "level": 2,
   "text": "Ik ___ mijn telefoon in mijn tas gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свой телефон в сумке."
  },
  {
   "id": "l2-314",
   "level": 2,
   "text": "Zij ___ vroeg van huis vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано вышла из дома."
  },
  {
   "id": "l2-315",
   "level": 2,
   "text": "Hij ___ een paar uur in de trein gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ просидел в поезде пару часов."
  },
  {
   "id": "l2-316",
   "level": 2,
   "text": "Wij ___ een mooie wandeling door het bos gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили красивую прогулку по лесу."
  },
  {
   "id": "l2-317",
   "level": 2,
   "text": "Ik ___ mijn ouders tijdens de vakantie bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Я ___ навестил родителей во время отпуска."
  },
  {
   "id": "l2-318",
   "level": 2,
   "text": "Zij ___ na de les naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после урока поехала домой на велосипеде."
  },
  {
   "id": "l2-319",
   "level": 2,
   "text": "Hij ___ zijn paspoort op het hotel gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл свой паспорт в отеле."
  },
  {
   "id": "l2-320",
   "level": 2,
   "text": "Wij ___ gisteren een nieuwe koelkast besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера заказали новый холодильник."
  },
  {
   "id": "l2-321",
   "level": 2,
   "text": "Ik ___ om zeven uur thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ в семь часов вернулся домой."
  },
  {
   "id": "l2-322",
   "level": 2,
   "text": "Zij ___ een week in een hotel gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пробыла неделю в отеле."
  },
  {
   "id": "l2-323",
   "level": 2,
   "text": "Hij ___ zijn hele ochtend aan zijn project gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ проработал над своим проектом всё утро."
  },
  {
   "id": "l2-324",
   "level": 2,
   "text": "Wij ___ na het eten naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после ужина вышли на улицу."
  },
  {
   "id": "l2-325",
   "level": 2,
   "text": "Ik ___ gisteren mijn favoriete liedjes geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера послушал свои любимые песни."
  },
  {
   "id": "l2-326",
   "level": 2,
   "text": "Zij ___ met haar man naar Zwitserland gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ со своим мужем поехала в Швейцарию."
  },
  {
   "id": "l2-327",
   "level": 2,
   "text": "Hij ___ zijn collega op straat tegengekomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "tegengekomen",
   "rule": "transitief",
   "translationRu": "Он ___ встретил своего коллегу на улице."
  },
  {
   "id": "l2-328",
   "level": 2,
   "text": "Wij ___ een leuke middag met de kinderen gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ провели хороший день с детьми."
  },
  {
   "id": "l2-329",
   "level": 2,
   "text": "Ik ___ mijn fiets bij de winkel gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ поставил свой велосипед у магазина."
  },
  {
   "id": "l2-330",
   "level": 2,
   "text": "Zij ___ vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать."
  },
  {
   "id": "l2-331",
   "level": 2,
   "text": "Hij ___ gisteren een brief aan zijn ouders geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера написал письмо своим родителям."
  },
  {
   "id": "l2-332",
   "level": 2,
   "text": "Wij ___ naar het museum gegaan omdat het regende.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли в музей, потому что шёл дождь."
  },
  {
   "id": "l2-333",
   "level": 2,
   "text": "Ik ___ mijn boodschappen in de auto gelegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelegd",
   "rule": "transitief",
   "translationRu": "Я ___ положил покупки в машину."
  },
  {
   "id": "l2-334",
   "level": 2,
   "text": "Zij ___ haar vriendin op het station opgehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgehaald",
   "rule": "transitief",
   "translationRu": "Она ___ встретила свою подругу на вокзале."
  },
  {
   "id": "l2-335",
   "level": 2,
   "text": "Hij ___ na de vakantie weer naar zijn werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после отпуска снова вышел на работу."
  },
  {
   "id": "l2-336",
   "level": 2,
   "text": "Wij ___ de hele avond samen gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер разговаривали друг с другом."
  },
  {
   "id": "l2-337",
   "level": 2,
   "text": "Ik ___ gisteren een nieuwe jas gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера купил новую куртку."
  },
  {
   "id": "l2-338",
   "level": 2,
   "text": "Zij ___ naar een ander land verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другую страну."
  },
  {
   "id": "l2-339",
   "level": 2,
   "text": "Hij ___ een paar dagen bij zijn oom geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ переночевал пару дней у своего дяди."
  },
  {
   "id": "l2-340",
   "level": 2,
   "text": "Wij ___ om negen uur bij het station aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в девять часов пришли на вокзал."
  },
  {
   "id": "l2-341",
   "level": 2,
   "text": "Ik ___ mijn oude computer verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Я ___ продал свой старый компьютер."
  },
  {
   "id": "l2-342",
   "level": 2,
   "text": "Zij ___ de hele dag thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ просидела дома весь день."
  },
  {
   "id": "l2-343",
   "level": 2,
   "text": "Hij ___ gisteren met de bus naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ вчера поехал на автобусе в школу."
  },
  {
   "id": "l2-344",
   "level": 2,
   "text": "Wij ___ een grote boodschappenlijst gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ составили большой список покупок."
  },
  {
   "id": "l2-345",
   "level": 2,
   "text": "Ik ___ na de film naar huis gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после фильма пошёл домой пешком."
  },
  {
   "id": "l2-346",
   "level": 2,
   "text": "Zij ___ een lange e-mail naar haar baas gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Она ___ отправила длинное письмо своему начальнику."
  },
  {
   "id": "l2-347",
   "level": 2,
   "text": "Hij ___ zijn kinderen naar school gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Он ___ отвёз своих детей в школу."
  },
  {
   "id": "l2-348",
   "level": 2,
   "text": "Wij ___ vorig jaar veel nieuwe vrienden ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Мы ___ в прошлом году познакомились со многими новыми друзьями."
  },
  {
   "id": "l2-349",
   "level": 2,
   "text": "Ik ___ gisteren mijn kamer opnieuw ingericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ingericht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера заново обустроил свою комнату."
  },
  {
   "id": "l2-350",
   "level": 2,
   "text": "Zij ___ om half zes van haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в полшестого ушла с работы."
  },
  {
   "id": "l2-351",
   "level": 2,
   "text": "Hij ___ een uur op zijn vriendin gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Он ___ прождал свою подругу час."
  },
  {
   "id": "l2-352",
   "level": 2,
   "text": "Wij ___ na de lunch naar het park gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после обеда пошли в парк."
  },
  {
   "id": "l2-353",
   "level": 2,
   "text": "Ik ___ mijn sleutels in mijn tas gestopt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gestopt",
   "rule": "transitief",
   "translationRu": "Я ___ положил свои ключи в сумку."
  },
  {
   "id": "l2-354",
   "level": 2,
   "text": "Zij ___ een interessante film gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Она ___ посмотрела интересный фильм."
  },
  {
   "id": "l2-355",
   "level": 2,
   "text": "Hij ___ vorige week ziek thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ на прошлой неделе остался дома из-за болезни."
  },
  {
   "id": "l2-356",
   "level": 2,
   "text": "Wij ___ naar een ander hotel verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ переехали в другой отель."
  },
  {
   "id": "l2-357",
   "level": 2,
   "text": "Ik ___ mijn zus een verjaardagscadeau gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ подарил сестре подарок на день рождения."
  },
  {
   "id": "l2-358",
   "level": 2,
   "text": "Zij ___ de hele ochtend koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Она ___ пила кофе всё утро."
  },
  {
   "id": "l2-359",
   "level": 2,
   "text": "Hij ___ met zijn fiets naar zijn werk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал на работу на велосипеде."
  },
  {
   "id": "l2-360",
   "level": 2,
   "text": "Wij ___ na het ontbijt de keuken schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после завтрака убрались на кухне."
  },
  {
   "id": "l2-361",
   "level": 2,
   "text": "Ik ___ gisteren een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера совершил долгую прогулку."
  },
  {
   "id": "l2-362",
   "level": 2,
   "text": "Zij ___ om acht uur opgestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в восемь часов встала."
  },
  {
   "id": "l2-363",
   "level": 2,
   "text": "Hij ___ zijn telefoon in de auto vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свой телефон в машине."
  },
  {
   "id": "l2-364",
   "level": 2,
   "text": "Wij ___ een paar uur in het café gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ просидели в кафе пару часов."
  },
  {
   "id": "l2-365",
   "level": 2,
   "text": "Ik ___ naar mijn dokter gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ пошёл к своему врачу."
  },
  {
   "id": "l2-366",
   "level": 2,
   "text": "Zij ___ gisteren haar examen gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Она ___ вчера сдала свой экзамен."
  },
  {
   "id": "l2-367",
   "level": 2,
   "text": "Hij ___ een nieuwe fiets gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Он ___ купил новый велосипед."
  },
  {
   "id": "l2-368",
   "level": 2,
   "text": "Wij ___ laat van onze vakantie teruggekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "teruggekomen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поздно вернулись из отпуска."
  },
  {
   "id": "l2-369",
   "level": 2,
   "text": "Ik ___ mijn oude boeken aan een vriend gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ отдал свои старые книги другу."
  },
  {
   "id": "l2-370",
   "level": 2,
   "text": "Zij ___ na het werk nog boodschappen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ после работы ещё сделала покупки."
  },
  {
   "id": "l2-371",
   "level": 2,
   "text": "Hij ___ de hele middag met zijn zoon gespeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gespeeld",
   "rule": "transitief",
   "translationRu": "Он ___ весь день играл со своим сыном."
  },
  {
   "id": "l2-372",
   "level": 2,
   "text": "Wij ___ naar het station gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ пошли пешком на вокзал."
  },
  {
   "id": "l2-373",
   "level": 2,
   "text": "Ik ___ gisteren een mooie foto van de zonsondergang gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера сделал красивую фотографию заката."
  },
  {
   "id": "l2-374",
   "level": 2,
   "text": "Zij ___ een paar dagen in Rotterdam gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пробыла пару дней в Роттердаме."
  },
  {
   "id": "l2-375",
   "level": 2,
   "text": "Hij ___ zijn ouders over zijn nieuwe baan verteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Он ___ рассказал родителям о своей новой работе."
  },
  {
   "id": "l2-376",
   "level": 2,
   "text": "Wij ___ na de vergadering naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после совещания поехали домой."
  },
  {
   "id": "l2-377",
   "level": 2,
   "text": "Ik ___ een uur in de trein gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ час читал в поезде."
  },
  {
   "id": "l2-378",
   "level": 2,
   "text": "Zij ___ haar tas in het restaurant laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ оставила свою сумку в ресторане."
  },
  {
   "id": "l2-379",
   "level": 2,
   "text": "Hij ___ vorige zomer naar Griekenland gevlogen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevlogen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ прошлым летом улетел в Грецию."
  },
  {
   "id": "l2-380",
   "level": 2,
   "text": "Wij ___ samen een nieuwe keuken gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ вместе купили новую кухню."
  },
  {
   "id": "l2-381",
   "level": 2,
   "text": "Ik ___ gisteren mijn buurman geholpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера помог соседу."
  },
  {
   "id": "l2-382",
   "level": 2,
   "text": "Zij ___ vroeg bij het kantoor aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано пришла к офису."
  },
  {
   "id": "l2-383",
   "level": 2,
   "text": "Hij ___ zijn oude auto verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Он ___ продал свою старую машину."
  },
  {
   "id": "l2-384",
   "level": 2,
   "text": "Wij ___ na het werk naar een café gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после работы пошли в кафе."
  },
  {
   "id": "l2-385",
   "level": 2,
   "text": "Ik ___ mijn hele weekend thuis doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Я ___ провёл все выходные дома."
  },
  {
   "id": "l2-386",
   "level": 2,
   "text": "Zij ___ een heerlijke maaltijd voor haar vrienden gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ приготовила вкусный ужин для друзей."
  },
  {
   "id": "l2-387",
   "level": 2,
   "text": "Hij ___ naar zijn zus in België gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Он ___ поехал к своей сестре в Бельгию."
  },
  {
   "id": "l2-388",
   "level": 2,
   "text": "Wij ___ gisteren veel gelachen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelachen",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера много смеялись."
  },
  {
   "id": "l2-389",
   "level": 2,
   "text": "Ik ___ mijn afspraak in mijn agenda gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ записал встречу в своём ежедневнике."
  },
  {
   "id": "l2-390",
   "level": 2,
   "text": "Zij ___ na de vakantie weer naar school gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после отпуска снова пошла в школу."
  },
  {
   "id": "l2-391",
   "level": 2,
   "text": "Hij ___ een paar uur op de bank geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ поспал пару часов на диване."
  },
  {
   "id": "l2-392",
   "level": 2,
   "text": "Wij ___ om elf uur naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в одиннадцать часов поехали домой."
  },
  {
   "id": "l2-393",
   "level": 2,
   "text": "Ik ___ mijn collega een kop koffie aangeboden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "aangeboden",
   "rule": "transitief",
   "translationRu": "Я ___ предложил коллеге чашку кофе."
  },
  {
   "id": "l2-394",
   "level": 2,
   "text": "Zij ___ haar verjaardag in een klein restaurant gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Она ___ отпраздновала свой день рождения в маленьком ресторане."
  },
  {
   "id": "l2-395",
   "level": 2,
   "text": "Hij ___ zijn fiets in de schuur gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Он ___ поставил свой велосипед в сарай."
  },
  {
   "id": "l2-396",
   "level": 2,
   "text": "Wij ___ een interessante tentoonstelling bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ посетили интересную выставку."
  },
  {
   "id": "l2-397",
   "level": 2,
   "text": "Ik ___ gisteren vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера рано пошёл спать."
  },
  {
   "id": "l2-398",
   "level": 2,
   "text": "Zij ___ haar sleutels op kantoor gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свои ключи на работе."
  },
  {
   "id": "l2-399",
   "level": 2,
   "text": "Hij ___ een paar dagen vrij genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Он ___ взял пару дней отгула."
  },
  {
   "id": "l2-400",
   "level": 2,
   "text": "Wij ___ naar de kust gegaan omdat het mooi weer was.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ поехали на побережье, потому что была хорошая погода."
  },
  {
   "id": "l2-401",
   "level": 2,
   "text": "Ik ___ gisteren na mijn werk naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера после работы пошёл в супермаркет."
  },
  {
   "id": "l2-402",
   "level": 2,
   "text": "Zij ___ haar vakantie al maanden gepland.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gepland",
   "rule": "transitief",
   "translationRu": "Она ___ спланировала свой отпуск за несколько месяцев."
  },
  {
   "id": "l2-403",
   "level": 2,
   "text": "Hij ___ om acht uur bij zijn vriend aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в восемь часов пришёл к другу."
  },
  {
   "id": "l2-404",
   "level": 2,
   "text": "Wij ___ de hele avond samen over onze plannen gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер говорили о наших планах."
  },
  {
   "id": "l2-405",
   "level": 2,
   "text": "Ik ___ mijn oude fiets aan mijn buurman gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ отдал свой старый велосипед соседу."
  },
  {
   "id": "l2-406",
   "level": 2,
   "text": "Zij ___ na de les rechtstreeks naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после урока сразу поехала домой."
  },
  {
   "id": "l2-407",
   "level": 2,
   "text": "Hij ___ gisteren een belangrijke e-mail geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера написал важное письмо."
  },
  {
   "id": "l2-408",
   "level": 2,
   "text": "Wij ___ een week in een klein appartement gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пробыли неделю в маленькой квартире."
  },
  {
   "id": "l2-409",
   "level": 2,
   "text": "Ik ___ mijn trein naar Den Haag gemist.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Я ___ опоздал на свой поезд в Гаагу."
  },
  {
   "id": "l2-410",
   "level": 2,
   "text": "Zij ___ haar kamer voor het bezoek opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Она ___ убрала свою комнату перед приходом гостей."
  },
  {
   "id": "l2-411",
   "level": 2,
   "text": "Hij ___ met zijn gezin naar Spanje gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ со своей семьёй поехал в Испанию."
  },
  {
   "id": "l2-412",
   "level": 2,
   "text": "Wij ___ na het eten nog een korte wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после ужина ещё немного погуляли."
  },
  {
   "id": "l2-413",
   "level": 2,
   "text": "Ik ___ gisteren mijn ouders opgebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgebeld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера позвонил родителям."
  },
  {
   "id": "l2-414",
   "level": 2,
   "text": "Zij ___ vroeg van haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано ушла с работы."
  },
  {
   "id": "l2-415",
   "level": 2,
   "text": "Hij ___ zijn portemonnee op kantoor gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ нашёл свой бумажник на работе."
  },
  {
   "id": "l2-416",
   "level": 2,
   "text": "Wij ___ een leuke avond bij vrienden gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо провели вечер у друзей."
  },
  {
   "id": "l2-417",
   "level": 2,
   "text": "Ik ___ na de vakantie weer aan mijn cursus begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ после отпуска снова приступил к своему курсу."
  },
  {
   "id": "l2-418",
   "level": 2,
   "text": "Zij ___ een nieuwe fiets in de stad gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила новый велосипед в городе."
  },
  {
   "id": "l2-419",
   "level": 2,
   "text": "Hij ___ een uur op de bus gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Он ___ прождал автобус час."
  },
  {
   "id": "l2-420",
   "level": 2,
   "text": "Wij ___ gisteren naar een interessant museum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера ходили в интересный музей."
  },
  {
   "id": "l2-421",
   "level": 2,
   "text": "Ik ___ mijn huiswerk op tijd gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вовремя сделал домашнее задание."
  },
  {
   "id": "l2-422",
   "level": 2,
   "text": "Zij ___ na haar werk naar de sportschool gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы поехала в спортзал на велосипеде."
  },
  {
   "id": "l2-423",
   "level": 2,
   "text": "Hij ___ zijn vakantie bij zijn ouders doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Он ___ провёл свой отпуск у родителей."
  },
  {
   "id": "l2-424",
   "level": 2,
   "text": "Wij ___ een paar mooie foto's van de stad gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ сделали пару красивых фотографий города."
  },
  {
   "id": "l2-425",
   "level": 2,
   "text": "Ik ___ gisteren erg laat thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера очень поздно вернулся домой."
  },
  {
   "id": "l2-426",
   "level": 2,
   "text": "Zij ___ haar sleutel in haar jaszak gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свой ключ в кармане куртки."
  },
  {
   "id": "l2-427",
   "level": 2,
   "text": "Hij ___ met zijn collega's over het nieuwe plan gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ поговорил с коллегами о новом плане."
  },
  {
   "id": "l2-428",
   "level": 2,
   "text": "Wij ___ na het ontbijt naar het strand gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака поехали на пляж."
  },
  {
   "id": "l2-429",
   "level": 2,
   "text": "Ik ___ een nieuwe laptop voor mijn studie gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил новый ноутбук для учёбы."
  },
  {
   "id": "l2-430",
   "level": 2,
   "text": "Zij ___ de hele ochtend thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ просидела дома всё утро."
  },
  {
   "id": "l2-431",
   "level": 2,
   "text": "Hij ___ gisteren zijn broer op het station opgehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgehaald",
   "rule": "transitief",
   "translationRu": "Он ___ вчера встретил своего брата на вокзале."
  },
  {
   "id": "l2-432",
   "level": 2,
   "text": "Wij ___ een lange brief naar het hotel gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Мы ___ отправили длинное письмо в отель."
  },
  {
   "id": "l2-433",
   "level": 2,
   "text": "Ik ___ na het werk nog naar de apotheek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы ещё зашёл в аптеку."
  },
  {
   "id": "l2-434",
   "level": 2,
   "text": "Zij ___ vorige maand naar een groter huis verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в прошлом месяце переехала в дом побольше."
  },
  {
   "id": "l2-435",
   "level": 2,
   "text": "Hij ___ zijn fiets buiten laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил свой велосипед на улице."
  },
  {
   "id": "l2-436",
   "level": 2,
   "text": "Wij ___ gisteren samen een pizza gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера вместе съели пиццу."
  },
  {
   "id": "l2-437",
   "level": 2,
   "text": "Ik ___ mijn tas op de stoel gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ поставил свою сумку на стул."
  },
  {
   "id": "l2-438",
   "level": 2,
   "text": "Zij ___ vroeg naar het vliegveld vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано уехала в аэропорт."
  },
  {
   "id": "l2-439",
   "level": 2,
   "text": "Hij ___ een interessant boek over Nederland gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал интересную книгу о Нидерландах."
  },
  {
   "id": "l2-440",
   "level": 2,
   "text": "Wij ___ een paar dagen in Amsterdam gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пробыли пару дней в Амстердаме."
  },
  {
   "id": "l2-441",
   "level": 2,
   "text": "Ik ___ gisteren mijn moeder geholpen met de boodschappen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "boodschappen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера помог маме с покупками."
  },
  {
   "id": "l2-442",
   "level": 2,
   "text": "Zij ___ na de lunch naar de bibliotheek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после обеда пошла в библиотеку."
  },
  {
   "id": "l2-443",
   "level": 2,
   "text": "Hij ___ zijn afspraak bij de tandarts vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл про свой приём у стоматолога."
  },
  {
   "id": "l2-444",
   "level": 2,
   "text": "Wij ___ de hele middag in de tuin gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ проработали в саду весь день."
  },
  {
   "id": "l2-445",
   "level": 2,
   "text": "Ik ___ met de trein naar mijn werk gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Я ___ ездил на работу поездом."
  },
  {
   "id": "l2-446",
   "level": 2,
   "text": "Zij ___ een cadeau voor haar dochter gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ купила подарок для дочери."
  },
  {
   "id": "l2-447",
   "level": 2,
   "text": "Hij ___ gisteren ziek thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ вчера остался дома из-за болезни."
  },
  {
   "id": "l2-448",
   "level": 2,
   "text": "Wij ___ na het ontbijt de hond uitgelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "uitgelaten",
   "rule": "transitief",
   "translationRu": "Мы ___ после завтрака выгуляли собаку."
  },
  {
   "id": "l2-449",
   "level": 2,
   "text": "Ik ___ een nieuwe jas voor de winter besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Я ___ заказал новое зимнее пальто."
  },
  {
   "id": "l2-450",
   "level": 2,
   "text": "Zij ___ om tien uur bij ons thuis aangekomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "reflexief",
   "translationRu": "Она ___ в десять часов пришла к нам домой."
  },
  {
   "id": "l2-451",
   "level": 2,
   "text": "Hij ___ een uur naar muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Он ___ час слушал музыку."
  },
  {
   "id": "l2-452",
   "level": 2,
   "text": "Wij ___ vorig jaar naar een ander dorp verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в прошлом году переехали в другую деревню."
  },
  {
   "id": "l2-453",
   "level": 2,
   "text": "Ik ___ gisteren mijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера убрал свою комнату."
  },
  {
   "id": "l2-454",
   "level": 2,
   "text": "Zij ___ haar kinderen naar school gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Она ___ отвезла своих детей в школу."
  },
  {
   "id": "l2-455",
   "level": 2,
   "text": "Hij ___ na zijn werk naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы поехал домой на велосипеде."
  },
  {
   "id": "l2-456",
   "level": 2,
   "text": "Wij ___ een gezellige middag met onze vrienden gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ провели хороший день с друзьями."
  },
  {
   "id": "l2-457",
   "level": 2,
   "text": "Ik ___ mijn oude telefoon verkocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Я ___ продал свой старый телефон."
  },
  {
   "id": "l2-458",
   "level": 2,
   "text": "Zij ___ vroeg naar bed gegaan omdat ze moe was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано пошла спать, потому что устала."
  },
  {
   "id": "l2-459",
   "level": 2,
   "text": "Hij ___ gisteren een lange wandeling met de hond gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ вчера совершил долгую прогулку с собакой."
  },
  {
   "id": "l2-460",
   "level": 2,
   "text": "Wij ___ naar Duitsland gereden voor een familiebezoek.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "familiebezoek",
   "rule": "transitief",
   "translationRu": "Мы ___ поехали в Германию навестить семью."
  },
  {
   "id": "l2-461",
   "level": 2,
   "text": "Ik ___ mijn boek op tafel laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою книгу лежать на столе."
  },
  {
   "id": "l2-462",
   "level": 2,
   "text": "Zij ___ haar vriendin een bericht gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Она ___ отправила подруге сообщение."
  },
  {
   "id": "l2-463",
   "level": 2,
   "text": "Hij ___ de hele ochtend in de keuken gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Он ___ простоял на кухне всё утро."
  },
  {
   "id": "l2-464",
   "level": 2,
   "text": "Wij ___ na het feest met de bus naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после вечеринки поехали домой на автобусе."
  },
  {
   "id": "l2-465",
   "level": 2,
   "text": "Ik ___ gisteren een nieuwe taalapp op mijn telefoon gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ вчера установил новое приложение для изучения языка на телефон."
  },
  {
   "id": "l2-466",
   "level": 2,
   "text": "Zij ___ een paar dagen bij haar ouders gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пробыла пару дней у родителей."
  },
  {
   "id": "l2-467",
   "level": 2,
   "text": "Hij ___ zijn kinderen een verhaal voorgelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorgelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал детям сказку."
  },
  {
   "id": "l2-468",
   "level": 2,
   "text": "Wij ___ in de vakantie veel nieuwe plaatsen bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска побывали во многих новых местах."
  },
  {
   "id": "l2-469",
   "level": 2,
   "text": "Ik ___ na de vergadering naar mijn kantoor gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после совещания пошёл в свой офис."
  },
  {
   "id": "l2-470",
   "level": 2,
   "text": "Zij ___ haar fiets bij het station gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свой велосипед у вокзала."
  },
  {
   "id": "l2-471",
   "level": 2,
   "text": "Hij ___ gisteren zijn verjaardag met zijn vrienden gevierd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevierd",
   "rule": "transitief",
   "translationRu": "Он ___ вчера отпраздновал свой день рождения с друзьями."
  },
  {
   "id": "l2-472",
   "level": 2,
   "text": "Wij ___ om zeven uur van huis vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в семь часов вышли из дома."
  },
  {
   "id": "l2-473",
   "level": 2,
   "text": "Ik ___ een paar uur aan mijn verslag gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Я ___ пару часов поработал над докладом."
  },
  {
   "id": "l2-474",
   "level": 2,
   "text": "Zij ___ naar een andere stad gegaan voor haar nieuwe baan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "baan",
   "rule": "transitief",
   "translationRu": "Она ___ переехала в другой город ради новой работы."
  },
  {
   "id": "l2-475",
   "level": 2,
   "text": "Hij ___ zijn bril in de auto vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свои очки в машине."
  },
  {
   "id": "l2-476",
   "level": 2,
   "text": "Wij ___ gisteren samen naar de bioscoop gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера вместе ходили в кино."
  },
  {
   "id": "l2-477",
   "level": 2,
   "text": "Ik ___ mijn boodschappen online besteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besteld",
   "rule": "transitief",
   "translationRu": "Я ___ заказал свои покупки онлайн."
  },
  {
   "id": "l2-478",
   "level": 2,
   "text": "Zij ___ de hele nacht goed geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ хорошо выспалась за ночь."
  },
  {
   "id": "l2-479",
   "level": 2,
   "text": "Hij ___ na het ontbijt zijn kamer schoongemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "schoongemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака убрал свою комнату."
  },
  {
   "id": "l2-480",
   "level": 2,
   "text": "Wij ___ een mooie vakantie in Frankrijk gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ хорошо отдохнули во Франции."
  },
  {
   "id": "l2-481",
   "level": 2,
   "text": "Ik ___ gisteren mijn trein op het laatste moment gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Я ___ вчера успел на свой поезд в последний момент."
  },
  {
   "id": "l2-482",
   "level": 2,
   "text": "Zij ___ na haar werk naar een vriendin gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы пошла к подруге."
  },
  {
   "id": "l2-483",
   "level": 2,
   "text": "Hij ___ een uur met zijn vader gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Он ___ час проговорил по телефону с отцом."
  },
  {
   "id": "l2-484",
   "level": 2,
   "text": "Wij ___ vorig weekend een lange fietstocht gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ в прошлые выходные совершили долгий велопоход."
  },
  {
   "id": "l2-485",
   "level": 2,
   "text": "Ik ___ mijn sleutels onder de bank gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ нашёл свои ключи под диваном."
  },
  {
   "id": "l2-486",
   "level": 2,
   "text": "Zij ___ vroeg opgestaan om te gaan werken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано встала, чтобы пойти на работу."
  },
  {
   "id": "l2-487",
   "level": 2,
   "text": "Hij ___ gisteren een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Он ___ вчера нашёл новую работу."
  },
  {
   "id": "l2-488",
   "level": 2,
   "text": "Wij ___ na de lunch naar het centrum gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после обеда пошли пешком в центр."
  },
  {
   "id": "l2-489",
   "level": 2,
   "text": "Ik ___ mijn oude kleding naar een winkel gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ отвёз свою старую одежду в магазин."
  },
  {
   "id": "l2-490",
   "level": 2,
   "text": "Zij ___ een paar dagen in een hotel geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ переночевала пару дней в отеле."
  },
  {
   "id": "l2-491",
   "level": 2,
   "text": "Hij ___ na het werk boodschappen voor zijn gezin gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Он ___ после работы сделал покупки для своей семьи."
  },
  {
   "id": "l2-492",
   "level": 2,
   "text": "Wij ___ om half tien thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ в полдесятого вернулись домой."
  },
  {
   "id": "l2-493",
   "level": 2,
   "text": "Ik ___ gisteren een lekkere soep gekookt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekookt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера сварил вкусный суп."
  },
  {
   "id": "l2-494",
   "level": 2,
   "text": "Zij ___ met haar vrienden naar het concert gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ с друзьями пошла на концерт."
  },
  {
   "id": "l2-495",
   "level": 2,
   "text": "Hij ___ zijn vakantie goed voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Он ___ хорошо подготовился к отпуску."
  },
  {
   "id": "l2-496",
   "level": 2,
   "text": "Wij ___ de hele middag op het terras gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ просидели на террасе весь день."
  },
  {
   "id": "l2-497",
   "level": 2,
   "text": "Ik ___ na de cursus naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после курсов поехал домой на велосипеде."
  },
  {
   "id": "l2-498",
   "level": 2,
   "text": "Zij ___ gisteren haar telefoon thuis vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ вчера забыла свой телефон дома."
  },
  {
   "id": "l2-499",
   "level": 2,
   "text": "Hij ___ een mooie foto van zijn kinderen gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ сделал красивую фотографию своих детей."
  },
  {
   "id": "l2-500",
   "level": 2,
   "text": "Wij ___ na een lange dag vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после долгого дня рано пошли спать."
  },
  {
   "id": "l3-001",
   "level": 3,
   "text": "Ik ___ gisteren pas laat naar huis gegaan omdat ik langer op mijn werk moest blijven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера поздно вечером пошёл домой, потому что мне пришлось задержаться на работе."
  },
  {
   "id": "l3-002",
   "level": 3,
   "text": "Mijn collega ___ de hele middag aan het nieuwe project gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мой коллега ___ весь день работал над новым проектом."
  },
  {
   "id": "l3-003",
   "level": 3,
   "text": "Nadat we hadden gegeten, ___ we nog een uur in de woonkamer blijven zitten.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "blijven zitten",
   "rule": "groeps-inf",
   "translationRu": "После того как мы поели, мы ___ ещё час остались сидеть в гостиной."
  },
  {
   "id": "l3-004",
   "level": 3,
   "text": "Zij ___ haar trein gemist omdat ze onderweg een probleem met haar fiets heeft gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Она ___ пропустила свой поезд, потому что у неё по дороге была проблема с велосипедом."
  },
  {
   "id": "l3-005",
   "level": 3,
   "text": "Vorige zomer ___ mijn ouders naar een kleiner appartement verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Прошлым летом мои родители ___ переехали в квартиру поменьше."
  },
  {
   "id": "l3-006",
   "level": 3,
   "text": "Ik ___ gisteren mijn oude leraar toevallig in de supermarkt tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ вчера случайно встретил своего старого учителя в супермаркете."
  },
  {
   "id": "l3-007",
   "level": 3,
   "text": "Nadat hij zijn examen had gehaald, ___ hij met zijn vrienden iets gaan drinken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gaan drinken",
   "rule": "groeps-inf",
   "translationRu": "После того как он сдал экзамен, он ___ пошёл с друзьями чего-нибудь выпить."
  },
  {
   "id": "l3-008",
   "level": 3,
   "text": "Wij ___ de hele avond over onze vakantieplannen gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер обсуждали планы на отпуск."
  },
  {
   "id": "l3-009",
   "level": 3,
   "text": "Omdat het zo hard regende, ___ de kinderen binnen gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Потому что так сильно шёл дождь, дети ___ остались дома."
  },
  {
   "id": "l3-010",
   "level": 3,
   "text": "Mijn broer ___ vorige week voor zijn werk naar Brussel gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мой брат ___ на прошлой неделе ездил в Брюссель по работе."
  },
  {
   "id": "l3-011",
   "level": 3,
   "text": "Ik ___ mijn portemonnee uiteindelijk onder de bank gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ в итоге нашёл свой кошелёк под скамейкой."
  },
  {
   "id": "l3-012",
   "level": 3,
   "text": "Zij ___ na de vergadering direct naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после совещания сразу пошла домой."
  },
  {
   "id": "l3-013",
   "level": 3,
   "text": "Wij ___ gisteren een interessante documentaire over klimaatverandering gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера смотрели интересный документальный фильм про изменение климата."
  },
  {
   "id": "l3-014",
   "level": 3,
   "text": "Hij ___ de hele nacht wakker gebleven omdat zijn dochter ziek was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "wakker gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ всю ночь не спал, потому что его дочь болела."
  },
  {
   "id": "l3-015",
   "level": 3,
   "text": "Nadat ik mijn huiswerk had afgemaakt, ___ ik nog een halfuur televisie gaan kijken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gaan kijken",
   "rule": "groeps-inf",
   "translationRu": "После того как я сделал домашнее задание, я ___ пошёл смотреть телевизор ещё полчаса."
  },
  {
   "id": "l3-016",
   "level": 3,
   "text": "Mijn ouders ___ vroeger vaak met de trein naar Duitsland gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Мои родители ___ раньше часто ездили в Германию на поезде."
  },
  {
   "id": "l3-017",
   "level": 3,
   "text": "Zij ___ haar afspraak bij de tandarts helemaal vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Она ___ совсем забыла про приём у стоматолога."
  },
  {
   "id": "l3-018",
   "level": 3,
   "text": "Toen het begon te sneeuwen, ___ we snel naar binnen gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Когда начал идти снег, мы ___ быстро пошли внутрь."
  },
  {
   "id": "l3-019",
   "level": 3,
   "text": "Ik ___ gisteren met mijn buurman over het probleem gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера разговаривал с соседом об этой проблеме."
  },
  {
   "id": "l3-020",
   "level": 3,
   "text": "De trein ___ door een technisch probleem bijna een uur later vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Поезд ___ из-за технической проблемы уехал почти на час позже."
  },
  {
   "id": "l3-021",
   "level": 3,
   "text": "Wij ___ tijdens onze vakantie verschillende kleine dorpjes bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска побывали в нескольких маленьких деревеньках."
  },
  {
   "id": "l3-022",
   "level": 3,
   "text": "Nadat hij zijn baan had verloren, ___ hij tijdelijk bij zijn ouders gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "После того как он потерял работу, он ___ временно переехал жить к родителям."
  },
  {
   "id": "l3-023",
   "level": 3,
   "text": "Ik ___ mijn sleutel thuis laten liggen en kon daardoor niet naar binnen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой ключ лежать дома и поэтому не смог попасть внутрь."
  },
  {
   "id": "l3-024",
   "level": 3,
   "text": "Zij ___ gisteren tot elf uur op kantoor gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ вчера осталась на работе до одиннадцати."
  },
  {
   "id": "l3-025",
   "level": 3,
   "text": "We ___ na de film nog iets in een café gaan drinken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gaan drinken",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ после фильма пошли выпить чего-нибудь в кафе."
  },
  {
   "id": "l3-026",
   "level": 3,
   "text": "Mijn zus ___ een paar jaar geleden naar Canada verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Моя сестра ___ несколько лет назад переехала в Канаду."
  },
  {
   "id": "l3-027",
   "level": 3,
   "text": "Hij ___ de hele ochtend geprobeerd om de computer te repareren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Он ___ всё утро пытался починить компьютер."
  },
  {
   "id": "l3-028",
   "level": 3,
   "text": "Nadat de les was afgelopen, ___ de studenten langzaam naar buiten gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "После того как урок закончился, студенты ___ медленно пошли к выходу."
  },
  {
   "id": "l3-029",
   "level": 3,
   "text": "Ik ___ gisteren veel te weinig geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geslapen",
   "rule": "default-hebben",
   "translationRu": "Я ___ вчера слишком мало спал."
  },
  {
   "id": "l3-030",
   "level": 3,
   "text": "Zij ___ ondanks het slechte weer toch naar het strand gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ несмотря на плохую погоду всё-таки пошла на пляж."
  },
  {
   "id": "l3-031",
   "level": 3,
   "text": "Wij ___ een uur op de bus gewacht voordat hij eindelijk kwam.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ час ждали автобус, прежде чем он наконец приехал."
  },
  {
   "id": "l3-032",
   "level": 3,
   "text": "Mijn vriend ___ tijdens zijn reis door Spanje veel nieuwe mensen ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Мой друг ___ во время поездки по Испании познакомился со многими новыми людьми."
  },
  {
   "id": "l3-033",
   "level": 3,
   "text": "Toen ik thuiskwam, ___ mijn kinderen al naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Когда я пришёл домой, мои дети ___ уже легли спать."
  },
  {
   "id": "l3-034",
   "level": 3,
   "text": "Hij ___ zijn telefoon in de trein laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил свой телефон лежать в поезде."
  },
  {
   "id": "l3-035",
   "level": 3,
   "text": "Wij ___ vorig jaar naar een andere wijk verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в прошлом году переехали в другой район."
  },
  {
   "id": "l3-036",
   "level": 3,
   "text": "Ik ___ gisteren een lange brief aan mijn werkgever geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ вчера написал длинное письмо своему работодателю."
  },
  {
   "id": "l3-037",
   "level": 3,
   "text": "Nadat zij haar diploma had gehaald, ___ ze meteen aan het werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "После того как она получила диплом, она ___ сразу приступила к работе."
  },
  {
   "id": "l3-038",
   "level": 3,
   "text": "Hij ___ urenlang over de oplossing van het probleem nagedacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "nagedacht",
   "rule": "transitief",
   "translationRu": "Он ___ часами думал над решением этой проблемы."
  },
  {
   "id": "l3-039",
   "level": 3,
   "text": "Wij ___ de hele middag in het park gewandeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ весь день гуляли в парке."
  },
  {
   "id": "l3-040",
   "level": 3,
   "text": "Omdat ik me niet goed voelde, ___ ik vroeg naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Потому что я плохо себя чувствовал, я ___ рано пошёл домой."
  },
  {
   "id": "l3-041",
   "level": 3,
   "text": "Zij ___ haar presentatie goed voorbereid voordat ze naar de vergadering ging.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Она ___ хорошо подготовила свою презентацию, прежде чем пойти на совещание."
  },
  {
   "id": "l3-042",
   "level": 3,
   "text": "Mijn broer ___ gisteren met de fiets naar zijn werk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мой брат ___ вчера ехал на работу на велосипеде."
  },
  {
   "id": "l3-043",
   "level": 3,
   "text": "Ik ___ een interessant artikel in de krant gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ прочитал интересную статью в газете."
  },
  {
   "id": "l3-044",
   "level": 3,
   "text": "Nadat we afscheid hadden genomen, ___ zij naar het station gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "После того как мы попрощались, она ___ пошла к вокзалу."
  },
  {
   "id": "l3-045",
   "level": 3,
   "text": "Hij ___ zijn vakantie al maanden van tevoren gepland.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gepland",
   "rule": "transitief",
   "translationRu": "Он ___ свой отпуск запланировал за несколько месяцев вперёд."
  },
  {
   "id": "l3-046",
   "level": 3,
   "text": "Wij ___ uiteindelijk toch besloten om niet mee te gaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Мы ___ в итоге всё-таки решили не идти."
  },
  {
   "id": "l3-047",
   "level": 3,
   "text": "Ik ___ gisteren mijn oude foto's opnieuw bekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bekeken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера заново пересмотрел свои старые фотографии."
  },
  {
   "id": "l3-048",
   "level": 3,
   "text": "Zij ___ na een lange reis eindelijk in Amsterdam aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгой поездки наконец добралась до Амстердама."
  },
  {
   "id": "l3-049",
   "level": 3,
   "text": "Mijn ouders ___ de hele middag in de tuin gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мои родители ___ весь день работали в саду."
  },
  {
   "id": "l3-050",
   "level": 3,
   "text": "Nadat hij zijn sleutels had gevonden, ___ hij meteen naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "После того как он нашёл свои ключи, он ___ сразу вышел на улицу."
  },
  {
   "id": "l3-051",
   "level": 3,
   "text": "Ik ___ mijn afspraak vergeten omdat ik het erg druk had.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ забыл про встречу, потому что у меня было много дел."
  },
  {
   "id": "l3-052",
   "level": 3,
   "text": "Wij ___ tijdens de vergadering verschillende belangrijke punten besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ во время совещания обсудили несколько важных моментов."
  },
  {
   "id": "l3-053",
   "level": 3,
   "text": "Zij ___ na haar studie naar Rotterdam verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после учёбы переехала в Роттердам."
  },
  {
   "id": "l3-054",
   "level": 3,
   "text": "Hij ___ gisteren uren op zijn vriend gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Он ___ вчера часами ждал своего друга."
  },
  {
   "id": "l3-055",
   "level": 3,
   "text": "Nadat de winkel was gesloten, ___ we terug naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "После того как магазин закрылся, мы ___ пошли обратно домой."
  },
  {
   "id": "l3-056",
   "level": 3,
   "text": "Ik ___ mijn presentatie gisteren voor de klas gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ свою презентацию вчера представил классу."
  },
  {
   "id": "l3-057",
   "level": 3,
   "text": "Zij ___ een paar dagen bij haar zus gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пару дней погостила у своей сестры."
  },
  {
   "id": "l3-058",
   "level": 3,
   "text": "Wij ___ onderweg een oude vriend tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ по дороге встретили старого друга."
  },
  {
   "id": "l3-059",
   "level": 3,
   "text": "Hij ___ zijn hele kamer opnieuw ingericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ingericht",
   "rule": "transitief",
   "translationRu": "Он ___ полностью переобставил свою комнату."
  },
  {
   "id": "l3-060",
   "level": 3,
   "text": "Nadat het concert was afgelopen, ___ iedereen naar buiten gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "После того как концерт закончился, все ___ пошли к выходу."
  },
  {
   "id": "l3-061",
   "level": 3,
   "text": "Ik ___ gisteren met mijn manager over mijn toekomst gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Я ___ вчера поговорил со своим начальником о своём будущем."
  },
  {
   "id": "l3-062",
   "level": 3,
   "text": "Zij ___ tijdens haar vakantie veel foto's gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ во время отпуска сделала много фотографий."
  },
  {
   "id": "l3-063",
   "level": 3,
   "text": "Wij ___ te laat van huis vertrokken en daardoor de trein gemist.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ слишком поздно вышли из дома и из-за этого пропустили поезд."
  },
  {
   "id": "l3-064",
   "level": 3,
   "text": "Hij ___ zijn jas in de auto laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил своё пальто лежать в машине."
  },
  {
   "id": "l3-065",
   "level": 3,
   "text": "Nadat ik had gegeten, ___ ik een korte wandeling gaan maken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gaan maken",
   "rule": "groeps-inf",
   "translationRu": "После того как я поел, я ___ пошёл на короткую прогулку."
  },
  {
   "id": "l3-066",
   "level": 3,
   "text": "Mijn zus ___ vorige maand een nieuwe baan begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Моя сестра ___ в прошлом месяце начала новую работу."
  },
  {
   "id": "l3-067",
   "level": 3,
   "text": "Wij ___ de hele avond naar muziek geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер слушали музыку."
  },
  {
   "id": "l3-068",
   "level": 3,
   "text": "Zij ___ zonder iets te zeggen uit de kamer gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ ничего не сказав вышла из комнаты."
  },
  {
   "id": "l3-069",
   "level": 3,
   "text": "Ik ___ gisteren mijn boodschappen vergeten te kopen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ вчера забыл купить продукты."
  },
  {
   "id": "l3-070",
   "level": 3,
   "text": "Hij ___ tijdens de vergadering erg nerveus geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ во время совещания был очень нервным."
  },
  {
   "id": "l3-071",
   "level": 3,
   "text": "Wij ___ na het ontbijt richting het centrum gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака поехали в сторону центра."
  },
  {
   "id": "l3-072",
   "level": 3,
   "text": "Zij ___ haar oude fiets aan haar buurvrouw gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Она ___ отдала свой старый велосипед соседке."
  },
  {
   "id": "l3-073",
   "level": 3,
   "text": "Ik ___ gisteren veel tijd aan mijn huiswerk besteed.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besteed",
   "rule": "transitief",
   "translationRu": "Я ___ вчера потратил много времени на домашнее задание."
  },
  {
   "id": "l3-074",
   "level": 3,
   "text": "Nadat hij klaar was met werken, ___ hij naar de sportschool gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "После того как он закончил работать, он ___ пошёл в спортзал."
  },
  {
   "id": "l3-075",
   "level": 3,
   "text": "Wij ___ een paar uur in de bibliotheek gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ пару часов посидели в библиотеке."
  },
  {
   "id": "l3-076",
   "level": 3,
   "text": "Zij ___ haar ouders verteld dat ze naar het buitenland wilde verhuizen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Она ___ рассказала родителям, что хочет переехать за границу."
  },
  {
   "id": "l3-077",
   "level": 3,
   "text": "Ik ___ gisteren mijn trein net op tijd gehaald.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gehaald",
   "rule": "transitief",
   "translationRu": "Я ___ вчера успел на свой поезд как раз вовремя."
  },
  {
   "id": "l3-078",
   "level": 3,
   "text": "Hij ___ na het eten in slaap gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после еды заснул."
  },
  {
   "id": "l3-079",
   "level": 3,
   "text": "Wij ___ vorig weekend een lange wandeling door het bos gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ на прошлых выходных совершили долгую прогулку по лесу."
  },
  {
   "id": "l3-080",
   "level": 3,
   "text": "Zij ___ pas laat thuisgekomen omdat haar trein vertraging had.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ вернулась домой поздно, потому что её поезд опоздал."
  },
  {
   "id": "l3-081",
   "level": 3,
   "text": "Ik ___ mijn collega gevraagd of hij mij kon helpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ спросил коллегу, не может ли он мне помочь."
  },
  {
   "id": "l3-082",
   "level": 3,
   "text": "Hij ___ de hele dag bezig geweest met het organiseren van de verhuizing.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ весь день был занят организацией переезда."
  },
  {
   "id": "l3-083",
   "level": 3,
   "text": "Wij ___ na de vergadering samen iets gaan eten.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gaan eten",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ после совещания вместе пошли поесть."
  },
  {
   "id": "l3-084",
   "level": 3,
   "text": "Zij ___ haar sleutel in haar jaszak gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла свой ключ в кармане куртки."
  },
  {
   "id": "l3-085",
   "level": 3,
   "text": "Ik ___ gisteren een interessante podcast geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера послушал интересный подкаст."
  },
  {
   "id": "l3-086",
   "level": 3,
   "text": "Hij ___ na zijn vakantie weer aan het werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после отпуска снова приступил к работе."
  },
  {
   "id": "l3-087",
   "level": 3,
   "text": "Wij ___ onderweg verschillende keren gestopt.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestopt",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ по дороге несколько раз останавливались."
  },
  {
   "id": "l3-088",
   "level": 3,
   "text": "Zij ___ haar telefoon tijdens de wandeling verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Она ___ потеряла свой телефон во время прогулки."
  },
  {
   "id": "l3-089",
   "level": 3,
   "text": "Ik ___ gisteren mijn kamer eindelijk opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера наконец убрался в своей комнате."
  },
  {
   "id": "l3-090",
   "level": 3,
   "text": "Hij ___ na lange tijd weer naar zijn geboortestad teruggegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ спустя долгое время снова поехал в свой родной город."
  },
  {
   "id": "l3-091",
   "level": 3,
   "text": "Wij ___ tijdens de reis veel geleerd over de geschiedenis van het land.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Мы ___ во время поездки узнали много нового об истории этой страны."
  },
  {
   "id": "l3-092",
   "level": 3,
   "text": "Zij ___ een uur later dan verwacht aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ приехала на час позже, чем ожидалось."
  },
  {
   "id": "l3-093",
   "level": 3,
   "text": "Ik ___ mijn ouders geholpen met het verhuizen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помогал родителям с переездом."
  },
  {
   "id": "l3-094",
   "level": 3,
   "text": "Hij ___ zijn oude baan opgezegd omdat hij iets anders wilde doen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgezegd",
   "rule": "transitief",
   "translationRu": "Он ___ уволился со старой работы, потому что хотел заняться чем-то другим."
  },
  {
   "id": "l3-095",
   "level": 3,
   "text": "Wij ___ gisteren tot laat over politiek en maatschappij gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gepraat",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вчера допоздна говорили о политике и обществе."
  },
  {
   "id": "l3-096",
   "level": 3,
   "text": "Zij ___ na het ongeluk een paar dagen in het ziekenhuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после аварии провела несколько дней в больнице."
  },
  {
   "id": "l3-097",
   "level": 3,
   "text": "Ik ___ mijn fiets buiten laten staan en hij is gestolen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой велосипед стоять на улице, и его украли."
  },
  {
   "id": "l3-098",
   "level": 3,
   "text": "Hij ___ tijdens zijn presentatie een belangrijke fout gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ во время презентации допустил важную ошибку."
  },
  {
   "id": "l3-099",
   "level": 3,
   "text": "Wij ___ na het ontbijt naar het museum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака пошли в музей."
  },
  {
   "id": "l3-100",
   "level": 3,
   "text": "Zij ___ de hele nacht slecht geslapen omdat het zo warm was.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Она ___ всю ночь плохо спала, потому что было так жарко."
  },
  {
   "id": "l3-101",
   "level": 3,
   "text": "Ik ___ gisteren mijn broer opgebeld om hem over het nieuws te vertellen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgebeld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера позвонил брату, чтобы рассказать ему новости."
  },
  {
   "id": "l3-102",
   "level": 3,
   "text": "Nadat zij haar werk had afgemaakt, ___ ze naar huis gefietst.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gefietst",
   "rule": "beweging-richting",
   "translationRu": "После того как она закончила работу, она ___ поехала домой на велосипеде."
  },
  {
   "id": "l3-103",
   "level": 3,
   "text": "Wij ___ de afgelopen maanden hard aan dit project gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewerkt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ последние месяцы упорно работали над этим проектом."
  },
  {
   "id": "l3-104",
   "level": 3,
   "text": "Hij ___ tijdens de vakantie ziek geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ во время отпуска заболел."
  },
  {
   "id": "l3-105",
   "level": 3,
   "text": "Ik ___ mijn tas in de trein laten staan zonder het te merken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою сумку стоять в поезде, не заметив этого."
  },
  {
   "id": "l3-106",
   "level": 3,
   "text": "Zij ___ na de cursus nog een uur met de docent gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Она ___ после курса ещё час разговаривала с преподавателем."
  },
  {
   "id": "l3-107",
   "level": 3,
   "text": "Wij ___ uiteindelijk een andere oplossing voor het probleem gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ в итоге нашли другое решение проблемы."
  },
  {
   "id": "l3-108",
   "level": 3,
   "text": "Hij ___ naar een ander land verhuisd omdat hij daar een goede baan had gevonden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ переехал в другую страну, потому что нашёл там хорошую работу."
  },
  {
   "id": "l3-109",
   "level": 3,
   "text": "Ik ___ gisteren een belangrijke e-mail van mijn baas ontvangen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontvangen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера получил важное письмо от начальника."
  },
  {
   "id": "l3-110",
   "level": 3,
   "text": "Zij ___ de hele ochtend bezig geweest met het schoonmaken van het huis.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ всё утро была занята уборкой дома."
  },
  {
   "id": "l3-111",
   "level": 3,
   "text": "Nadat de vergadering was afgelopen, ___ iedereen naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "После того как совещание закончилось, все ___ пошли домой."
  },
  {
   "id": "l3-112",
   "level": 3,
   "text": "Wij ___ jarenlang in hetzelfde huis gewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewoond",
   "rule": "default-hebben",
   "translationRu": "Мы ___ долгие годы жили в одном и том же доме."
  },
  {
   "id": "l3-113",
   "level": 3,
   "text": "Hij ___ gisteren zijn oude vrienden weer ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Он ___ вчера снова встретил своих старых друзей."
  },
  {
   "id": "l3-114",
   "level": 3,
   "text": "Ik ___ tijdens de reis mijn paspoort bijna verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Я ___ во время поездки чуть не потерял свой паспорт."
  },
  {
   "id": "l3-115",
   "level": 3,
   "text": "Zij ___ zonder jas naar buiten gegaan, hoewel het erg koud was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вышла на улицу без куртки, хотя было очень холодно."
  },
  {
   "id": "l3-116",
   "level": 3,
   "text": "Wij ___ de hele middag geprobeerd om de kast in elkaar te zetten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ весь день пытались собрать шкаф."
  },
  {
   "id": "l3-117",
   "level": 3,
   "text": "Hij ___ na zijn studie eerst een paar maanden in het buitenland gewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewoond",
   "rule": "transitief",
   "translationRu": "Он ___ после учёбы сначала несколько месяцев жил за границей."
  },
  {
   "id": "l3-118",
   "level": 3,
   "text": "Ik ___ gisteren te laat opgestaan en daardoor mijn bus gemist.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgestaan",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ вчера слишком поздно встал и из-за этого пропустил свой автобус."
  },
  {
   "id": "l3-119",
   "level": 3,
   "text": "Zij ___ haar presentatie voor de vergadering nog een keer geoefend.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geoefend",
   "rule": "transitief",
   "translationRu": "Она ___ ещё раз порепетировала свою презентацию перед совещанием."
  },
  {
   "id": "l3-120",
   "level": 3,
   "text": "Wij ___ na het werk samen naar een restaurant gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после работы вместе пошли в ресторан."
  },
  {
   "id": "l3-121",
   "level": 3,
   "text": "Hij ___ de hele avond op zijn telefoon gekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekeken",
   "rule": "transitief",
   "translationRu": "Он ___ весь вечер сидел в телефоне."
  },
  {
   "id": "l3-122",
   "level": 3,
   "text": "Ik ___ vorige week mijn huisarts bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Я ___ на прошлой неделе был у своего терапевта."
  },
  {
   "id": "l3-123",
   "level": 3,
   "text": "Zij ___ na het slechte nieuws erg verdrietig geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после плохих новостей очень расстроилась."
  },
  {
   "id": "l3-124",
   "level": 3,
   "text": "Wij ___ gisteren een lange discussie over het onderwerp gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера долго обсуждали эту тему."
  },
  {
   "id": "l3-125",
   "level": 3,
   "text": "Hij ___ tijdens de wedstrijd een blessure opgelopen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgelopen",
   "rule": "transitief",
   "translationRu": "Он ___ во время матча получил травму."
  },
  {
   "id": "l3-126",
   "level": 3,
   "text": "Ik ___ mijn sleutels op tafel gelegd voordat ik naar bed ging.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelegd",
   "rule": "transitief",
   "translationRu": "Я ___ положил свои ключи на стол, прежде чем лечь спать."
  },
  {
   "id": "l3-127",
   "level": 3,
   "text": "Zij ___ na de verhuizing eindelijk wat rust gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ после переезда наконец немного отдохнула."
  },
  {
   "id": "l3-128",
   "level": 3,
   "text": "Wij ___ met de auto naar Frankrijk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ на машине поехали во Францию."
  },
  {
   "id": "l3-129",
   "level": 3,
   "text": "Hij ___ gisteren zijn laatste examen gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ вчера сдал свой последний экзамен."
  },
  {
   "id": "l3-130",
   "level": 3,
   "text": "Ik ___ een paar uur op mijn vriend gewacht voordat hij belde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ пару часов ждал друга, прежде чем он позвонил."
  },
  {
   "id": "l3-131",
   "level": 3,
   "text": "Zij ___ tijdens haar vakantie veel interessante mensen leren kennen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "leren kennen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ во время отпуска познакомилась со многими интересными людьми."
  },
  {
   "id": "l3-132",
   "level": 3,
   "text": "Wij ___ pas na middernacht naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ только после полуночи пошли домой."
  },
  {
   "id": "l3-133",
   "level": 3,
   "text": "Hij ___ de hele ochtend in de file gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Он ___ простоял всё утро в пробке."
  },
  {
   "id": "l3-134",
   "level": 3,
   "text": "Ik ___ mijn oude telefoon verkocht omdat ik een nieuwe wilde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Я ___ продал свой старый телефон, потому что хотел новый."
  },
  {
   "id": "l3-135",
   "level": 3,
   "text": "Zij ___ na het ontbijt een wandeling gaan maken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gaan maken",
   "rule": "groeps-inf",
   "translationRu": "Она ___ после завтрака пошла на прогулку."
  },
  {
   "id": "l3-136",
   "level": 3,
   "text": "Wij ___ gisteren een vergadering met onze nieuwe directeur gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера провели совещание с нашим новым директором."
  },
  {
   "id": "l3-137",
   "level": 3,
   "text": "Hij ___ een paar dagen in het hotel gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ пару дней прожил в отеле."
  },
  {
   "id": "l3-138",
   "level": 3,
   "text": "Ik ___ onderweg naar huis een ongeluk gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Я ___ по дороге домой увидел аварию."
  },
  {
   "id": "l3-139",
   "level": 3,
   "text": "Zij ___ haar werk op tijd afgekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "afgekregen",
   "rule": "transitief",
   "translationRu": "Она ___ закончила работу вовремя."
  },
  {
   "id": "l3-140",
   "level": 3,
   "text": "Wij ___ na het eten nog een film gaan kijken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gaan kijken",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ после еды пошли смотреть ещё один фильм."
  },
  {
   "id": "l3-141",
   "level": 3,
   "text": "Hij ___ vorig jaar begonnen met een opleiding in Utrecht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ в прошлом году начал учёбу в Утрехте."
  },
  {
   "id": "l3-142",
   "level": 3,
   "text": "Ik ___ mijn collega gisteren een belangrijke vraag gesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesteld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера задал коллеге важный вопрос."
  },
  {
   "id": "l3-143",
   "level": 3,
   "text": "Zij ___ na een lange reis eindelijk thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгого путешествия наконец вернулась домой."
  },
  {
   "id": "l3-144",
   "level": 3,
   "text": "Wij ___ de hele middag over onze toekomstplannen gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день обсуждали планы на будущее."
  },
  {
   "id": "l3-145",
   "level": 3,
   "text": "Hij ___ zijn fiets tijdens de verhuizing beschadigd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "beschadigd",
   "rule": "transitief",
   "translationRu": "Он ___ повредил свой велосипед во время переезда."
  },
  {
   "id": "l3-146",
   "level": 3,
   "text": "Ik ___ gisteren mijn ouders naar het station gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера отвёз родителей на вокзал."
  },
  {
   "id": "l3-147",
   "level": 3,
   "text": "Zij ___ zonder afscheid te nemen uit de kamer gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ не попрощавшись вышла из комнаты."
  },
  {
   "id": "l3-148",
   "level": 3,
   "text": "Wij ___ verschillende manieren geprobeerd om het probleem op te lossen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ пробовали разные способы решить проблему."
  },
  {
   "id": "l3-149",
   "level": 3,
   "text": "Hij ___ na zijn ziekte langzaam weer beter geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после болезни медленно пошёл на поправку."
  },
  {
   "id": "l3-150",
   "level": 3,
   "text": "Ik ___ mijn agenda thuis laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой ежедневник лежать дома."
  },
  {
   "id": "l3-151",
   "level": 3,
   "text": "Zij ___ tijdens de vergadering een interessant voorstel gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ во время совещания внесла интересное предложение."
  },
  {
   "id": "l3-152",
   "level": 3,
   "text": "Wij ___ een uur door de stad gelopen voordat we het restaurant vonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelopen",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ час шли по городу, прежде чем нашли ресторан."
  },
  {
   "id": "l3-153",
   "level": 3,
   "text": "Hij ___ zijn baan verloren nadat het bedrijf was gesloten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял работу после того, как компания закрылась."
  },
  {
   "id": "l3-154",
   "level": 3,
   "text": "Ik ___ gisteren een hele middag aan mijn verslag geschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geschreven",
   "rule": "transitief",
   "translationRu": "Я ___ вчера целый день писал свой отчёт."
  },
  {
   "id": "l3-155",
   "level": 3,
   "text": "Zij ___ na de vakantie weer naar haar oude baan teruggegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после отпуска снова вышла на свою старую работу."
  },
  {
   "id": "l3-156",
   "level": 3,
   "text": "Wij ___ onderweg een paar keer verkeerd gereden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verkeerd gereden",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ по дороге пару раз сбились с пути."
  },
  {
   "id": "l3-157",
   "level": 3,
   "text": "Hij ___ de hele avond met zijn ouders gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Он ___ весь вечер разговаривал по телефону с родителями."
  },
  {
   "id": "l3-158",
   "level": 3,
   "text": "Ik ___ mijn afspraak bij de dokter vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ забыл про приём у врача."
  },
  {
   "id": "l3-159",
   "level": 3,
   "text": "Zij ___ gisteren een nieuwe computer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Она ___ вчера купила новый компьютер."
  },
  {
   "id": "l3-160",
   "level": 3,
   "text": "Wij ___ na de lunch naar het centrum gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после обеда пошли в центр."
  },
  {
   "id": "l3-161",
   "level": 3,
   "text": "Hij ___ tijdens de reis veel foto's van de natuur gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ во время поездки сделал много фотографий природы."
  },
  {
   "id": "l3-162",
   "level": 3,
   "text": "Ik ___ een paar dagen bij mijn zus gelogeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelogeerd",
   "rule": "transitief",
   "translationRu": "Я ___ пару дней погостил у своей сестры."
  },
  {
   "id": "l3-163",
   "level": 3,
   "text": "Zij ___ om zes uur van kantoor vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в шесть часов ушла с работы."
  },
  {
   "id": "l3-164",
   "level": 3,
   "text": "Wij ___ gisteren tot laat gewerkt om alles op tijd af te krijgen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewerkt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вчера работали допоздна, чтобы всё успеть вовремя."
  },
  {
   "id": "l3-165",
   "level": 3,
   "text": "Hij ___ na het nieuws erg boos geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после новостей очень разозлился."
  },
  {
   "id": "l3-166",
   "level": 3,
   "text": "Ik ___ mijn fiets naar de reparateur gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ отвёз свой велосипед в ремонт."
  },
  {
   "id": "l3-167",
   "level": 3,
   "text": "Zij ___ haar hele presentatie uit haar hoofd geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Она ___ выучила всю свою презентацию наизусть."
  },
  {
   "id": "l3-168",
   "level": 3,
   "text": "Wij ___ na de vergadering naar een café gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после совещания пошли в кафе."
  },
  {
   "id": "l3-169",
   "level": 3,
   "text": "Hij ___ zijn ouders gevraagd of hij daar mocht blijven slapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Он ___ спросил у родителей, можно ли у них переночевать."
  },
  {
   "id": "l3-170",
   "level": 3,
   "text": "Ik ___ gisteren een lange wandeling langs de rivier gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера совершил долгую прогулку вдоль реки."
  },
  {
   "id": "l3-171",
   "level": 3,
   "text": "Zij ___ in de trein in slaap gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в поезде заснула."
  },
  {
   "id": "l3-172",
   "level": 3,
   "text": "Wij ___ een nieuw plan voor onze vakantie gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ составили новый план нашего отпуска."
  },
  {
   "id": "l3-173",
   "level": 3,
   "text": "Hij ___ na het gesprek van gedachten veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Он ___ после разговора передумал."
  },
  {
   "id": "l3-174",
   "level": 3,
   "text": "Ik ___ mijn buurman geholpen met het verplaatsen van een kast.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог соседу передвинуть шкаф."
  },
  {
   "id": "l3-175",
   "level": 3,
   "text": "Zij ___ gisteren haar eerste dag op haar nieuwe werk gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Она ___ вчера провела свой первый день на новой работе."
  },
  {
   "id": "l3-176",
   "level": 3,
   "text": "Wij ___ na het eten nog een tijdje buiten gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ после еды ещё немного посидели на улице."
  },
  {
   "id": "l3-177",
   "level": 3,
   "text": "Hij ___ zijn sleutels tijdens het sporten verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял свои ключи во время занятий спортом."
  },
  {
   "id": "l3-178",
   "level": 3,
   "text": "Ik ___ gisteren naar de bibliotheek gegaan om rustig te kunnen studeren.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ходил в библиотеку, чтобы спокойно позаниматься."
  },
  {
   "id": "l3-179",
   "level": 3,
   "text": "Zij ___ een interessante baan in het buitenland gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ нашла интересную работу за границей."
  },
  {
   "id": "l3-180",
   "level": 3,
   "text": "Wij ___ de afgelopen week veel problemen gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ на прошлой неделе было много проблем."
  },
  {
   "id": "l3-181",
   "level": 3,
   "text": "Hij ___ na de training direct naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после тренировки сразу поехал домой."
  },
  {
   "id": "l3-182",
   "level": 3,
   "text": "Ik ___ mijn oude vrienden op een feest weer ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Я ___ встретил своих старых друзей на вечеринке."
  },
  {
   "id": "l3-183",
   "level": 3,
   "text": "Zij ___ vroeg wakker geworden omdat haar wekker niet goed stond.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ рано проснулась, потому что будильник плохо сработал."
  },
  {
   "id": "l3-184",
   "level": 3,
   "text": "Wij ___ tijdens de vakantie verschillende steden bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска побывали в нескольких городах."
  },
  {
   "id": "l3-185",
   "level": 3,
   "text": "Hij ___ zijn kamer niet op tijd opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Он ___ не убрал свою комнату вовремя."
  },
  {
   "id": "l3-186",
   "level": 3,
   "text": "Ik ___ gisteren een gesprek met mijn leidinggevende gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Я ___ вчера провёл беседу со своим руководителем."
  },
  {
   "id": "l3-187",
   "level": 3,
   "text": "Zij ___ na het ontbijt naar haar werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после завтрака пошла на работу."
  },
  {
   "id": "l3-188",
   "level": 3,
   "text": "Wij ___ de hele middag in de keuken gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день простояли на кухне."
  },
  {
   "id": "l3-189",
   "level": 3,
   "text": "Hij ___ zijn paspoort thuis vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл свой паспорт дома."
  },
  {
   "id": "l3-190",
   "level": 3,
   "text": "Ik ___ een paar nieuwe boeken gekocht voor mijn cursus.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Я ___ купил пару новых книг для своего курса."
  },
  {
   "id": "l3-191",
   "level": 3,
   "text": "Zij ___ na het slechte weer toch naar buiten gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ несмотря на плохую погоду всё-таки вышла на улицу."
  },
  {
   "id": "l3-192",
   "level": 3,
   "text": "Wij ___ gisteren samen naar een tentoonstelling geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ вчера вместе побывали на выставке."
  },
  {
   "id": "l3-193",
   "level": 3,
   "text": "Hij ___ zijn auto verkocht omdat hij dichter bij zijn werk was gaan wonen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Он ___ продал свою машину, потому что переехал ближе к работе."
  },
  {
   "id": "l3-194",
   "level": 3,
   "text": "Ik ___ mijn moeder verteld wat er was gebeurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Я ___ рассказал маме, что произошло."
  },
  {
   "id": "l3-195",
   "level": 3,
   "text": "Zij ___ tijdens de vakantie een paar dagen ziek geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geweest",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ во время отпуска пару дней болела."
  },
  {
   "id": "l3-196",
   "level": 3,
   "text": "Wij ___ om half tien bij het station aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в полдесятого прибыли на вокзал."
  },
  {
   "id": "l3-197",
   "level": 3,
   "text": "Hij ___ een uur met zijn broer gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ час разговаривал со своим братом."
  },
  {
   "id": "l3-198",
   "level": 3,
   "text": "Ik ___ na mijn werk boodschappen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ после работы сделал покупки."
  },
  {
   "id": "l3-199",
   "level": 3,
   "text": "Zij ___ naar een andere afdeling binnen het bedrijf verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другой отдел внутри компании."
  },
  {
   "id": "l3-200",
   "level": 3,
   "text": "Wij ___ gisteren een belangrijke beslissing genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера приняли важное решение."
  },
  {
   "id": "l3-201",
   "level": 3,
   "text": "Ik ___ gisteren naar de bank gegaan om een probleem met mijn rekening te bespreken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ходил в банк, чтобы обсудить проблему с моим счётом."
  },
  {
   "id": "l3-202",
   "level": 3,
   "text": "Zij ___ de hele ochtend aan haar presentatie gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Она ___ всё утро работала над своей презентацией."
  },
  {
   "id": "l3-203",
   "level": 3,
   "text": "Hij ___ na het ontbijt zijn kinderen naar school gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака отвёл детей в школу."
  },
  {
   "id": "l3-204",
   "level": 3,
   "text": "Wij ___ tijdens onze reis veel verschillende gerechten gegeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegeten",
   "rule": "transitief",
   "translationRu": "Мы ___ во время нашей поездки попробовали много разных блюд."
  },
  {
   "id": "l3-205",
   "level": 3,
   "text": "Ik ___ mijn telefoon thuis laten liggen en kon daardoor niemand bellen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой телефон лежать дома и поэтому не мог никому позвонить."
  },
  {
   "id": "l3-206",
   "level": 3,
   "text": "Zij ___ na het gesprek een stuk rustiger geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после разговора стала намного спокойнее."
  },
  {
   "id": "l3-207",
   "level": 3,
   "text": "Hij ___ gisteren zijn oude collega op straat tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ вчера случайно встретил на улице своего бывшего коллегу."
  },
  {
   "id": "l3-208",
   "level": 3,
   "text": "Wij ___ een paar uur in de trein gezeten voordat we aankwamen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ пару часов просидели в поезде, прежде чем добрались."
  },
  {
   "id": "l3-209",
   "level": 3,
   "text": "Ik ___ na de vergadering direct naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после совещания сразу пошёл домой."
  },
  {
   "id": "l3-210",
   "level": 3,
   "text": "Zij ___ haar vakantie goed voorbereid voordat ze vertrok.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Она ___ хорошо подготовилась к отпуску, прежде чем уехать."
  },
  {
   "id": "l3-211",
   "level": 3,
   "text": "Hij ___ zijn sleutel in het slot laten zitten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten zitten",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил свой ключ торчать в замке."
  },
  {
   "id": "l3-212",
   "level": 3,
   "text": "Wij ___ gisteren een interessante lezing bijgewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bijgewoond",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера побывали на интересной лекции."
  },
  {
   "id": "l3-213",
   "level": 3,
   "text": "Ik ___ de hele avond geprobeerd om mijn broer te bereiken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Я ___ весь вечер пытался дозвониться до брата."
  },
  {
   "id": "l3-214",
   "level": 3,
   "text": "Zij ___ na haar studie in een ander land gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ после учёбы поехала жить в другую страну."
  },
  {
   "id": "l3-215",
   "level": 3,
   "text": "Hij ___ tijdens het fietsen gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ упал во время езды на велосипеде."
  },
  {
   "id": "l3-216",
   "level": 3,
   "text": "Wij ___ onze plannen vanwege het slechte weer veranderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "veranderd",
   "rule": "transitief",
   "translationRu": "Мы ___ изменили свои планы из-за плохой погоды."
  },
  {
   "id": "l3-217",
   "level": 3,
   "text": "Ik ___ gisteren een belangrijke brief van de gemeente gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера получил важное письмо от муниципалитета."
  },
  {
   "id": "l3-218",
   "level": 3,
   "text": "Zij ___ na het werk nog even bij haar ouders langsgegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "langsgegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы заглянула к родителям."
  },
  {
   "id": "l3-219",
   "level": 3,
   "text": "Hij ___ de hele middag in de tuin gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ весь день работал в саду."
  },
  {
   "id": "l3-220",
   "level": 3,
   "text": "Wij ___ een week in een appartement aan zee verbleven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verbleven",
   "rule": "transitief",
   "translationRu": "Мы ___ неделю провели в апартаментах у моря."
  },
  {
   "id": "l3-221",
   "level": 3,
   "text": "Ik ___ mijn collega gevraagd om het document nog eens te controleren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ попросил коллегу ещё раз проверить документ."
  },
  {
   "id": "l3-222",
   "level": 3,
   "text": "Zij ___ gisteren naar een andere stad gereisd voor een sollicitatiegesprek.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вчера ездила в другой город на собеседование."
  },
  {
   "id": "l3-223",
   "level": 3,
   "text": "Hij ___ na de training erg moe geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после тренировки очень устал."
  },
  {
   "id": "l3-224",
   "level": 3,
   "text": "Wij ___ verschillende mogelijkheden besproken voordat we een keuze maakten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ обсудили разные варианты, прежде чем сделали выбор."
  },
  {
   "id": "l3-225",
   "level": 3,
   "text": "Ik ___ gisteren mijn oude kleding uitgezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "uitgezocht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера перебрал свою старую одежду."
  },
  {
   "id": "l3-226",
   "level": 3,
   "text": "Zij ___ haar kinderen bij de oppas gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Она ___ отвела детей к няне."
  },
  {
   "id": "l3-227",
   "level": 3,
   "text": "Hij ___ zijn afspraak vergeten omdat hij te druk was met zijn werk.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл про встречу, потому что был слишком занят на работе."
  },
  {
   "id": "l3-228",
   "level": 3,
   "text": "Wij ___ na het eten een wandeling door de buurt gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после еды прогулялись по окрестностям."
  },
  {
   "id": "l3-229",
   "level": 3,
   "text": "Ik ___ gisteren met de trein naar mijn ouders gereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereisd",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ездил на поезде к родителям."
  },
  {
   "id": "l3-230",
   "level": 3,
   "text": "Zij ___ een paar dagen thuis gebleven om uit te rusten.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пару дней оставалась дома, чтобы отдохнуть."
  },
  {
   "id": "l3-231",
   "level": 3,
   "text": "Hij ___ tijdens de vergadering een goed idee voorgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorgesteld",
   "rule": "transitief",
   "translationRu": "Он ___ во время совещания предложил хорошую идею."
  },
  {
   "id": "l3-232",
   "level": 3,
   "text": "Wij ___ onze buren geholpen nadat hun kelder was overstroomd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Мы ___ помогли соседям, когда у них затопило подвал."
  },
  {
   "id": "l3-233",
   "level": 3,
   "text": "Ik ___ mijn fiets bij het station laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой велосипед стоять у вокзала."
  },
  {
   "id": "l3-234",
   "level": 3,
   "text": "Zij ___ na een paar maanden een nieuwe baan gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ через пару месяцев нашла новую работу."
  },
  {
   "id": "l3-235",
   "level": 3,
   "text": "Hij ___ gisteren een uur in de file gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Он ___ вчера час простоял в пробке."
  },
  {
   "id": "l3-236",
   "level": 3,
   "text": "Wij ___ na de vakantie weer aan ons normale leven begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после отпуска снова вернулись к обычной жизни."
  },
  {
   "id": "l3-237",
   "level": 3,
   "text": "Ik ___ een interessant boek over de Nederlandse geschiedenis gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ прочитал интересную книгу по истории Нидерландов."
  },
  {
   "id": "l3-238",
   "level": 3,
   "text": "Zij ___ naar het ziekenhuis gegaan om haar vriendin te bezoeken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в больницу навестить свою подругу."
  },
  {
   "id": "l3-239",
   "level": 3,
   "text": "Hij ___ zijn presentatie pas op het laatste moment voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Он ___ подготовил свою презентацию только в последний момент."
  },
  {
   "id": "l3-240",
   "level": 3,
   "text": "Wij ___ de hele middag op onze vrienden gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день ждали наших друзей."
  },
  {
   "id": "l3-241",
   "level": 3,
   "text": "Ik ___ na het werk nog naar de winkel gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы ещё зашёл в магазин."
  },
  {
   "id": "l3-242",
   "level": 3,
   "text": "Zij ___ haar telefoon tijdens de vakantie verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Она ___ потеряла свой телефон во время отпуска."
  },
  {
   "id": "l3-243",
   "level": 3,
   "text": "Hij ___ na zijn scheiding in een andere stad gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ после развода переехал жить в другой город."
  },
  {
   "id": "l3-244",
   "level": 3,
   "text": "Wij ___ gisteren een lange vergadering gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ вчера было долгое совещание."
  },
  {
   "id": "l3-245",
   "level": 3,
   "text": "Ik ___ mijn jas in het restaurant laten hangen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten hangen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил своё пальто висеть в ресторане."
  },
  {
   "id": "l3-246",
   "level": 3,
   "text": "Zij ___ vroeg van huis vertrokken om de trein te halen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано вышла из дома, чтобы успеть на поезд."
  },
  {
   "id": "l3-247",
   "level": 3,
   "text": "Hij ___ een paar uur met zijn kinderen gespeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gespeeld",
   "rule": "transitief",
   "translationRu": "Он ___ пару часов поиграл со своими детьми."
  },
  {
   "id": "l3-248",
   "level": 3,
   "text": "Wij ___ na de lunch naar het strand gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после обеда поехали на пляж."
  },
  {
   "id": "l3-249",
   "level": 3,
   "text": "Ik ___ gisteren mijn belastingformulier ingevuld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ingevuld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера заполнил свою налоговую форму."
  },
  {
   "id": "l3-250",
   "level": 3,
   "text": "Zij ___ na de lange wandeling eindelijk bij het hotel aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгой прогулки наконец добралась до отеля."
  },
  {
   "id": "l3-251",
   "level": 3,
   "text": "Hij ___ zijn oude computer aan zijn neef gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Он ___ отдал свой старый компьютер племяннику."
  },
  {
   "id": "l3-252",
   "level": 3,
   "text": "Wij ___ verschillende problemen tijdens de verhuizing gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ во время переезда было несколько проблем."
  },
  {
   "id": "l3-253",
   "level": 3,
   "text": "Ik ___ mijn huisarts gebeld omdat ik me niet goed voelde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ позвонил своему терапевту, потому что плохо себя чувствовал."
  },
  {
   "id": "l3-254",
   "level": 3,
   "text": "Zij ___ gisteren tot laat op haar werk gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ вчера допоздна оставалась на работе."
  },
  {
   "id": "l3-255",
   "level": 3,
   "text": "Hij ___ na het eten meteen in slaap gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после еды сразу заснул."
  },
  {
   "id": "l3-256",
   "level": 3,
   "text": "Wij ___ een mooie route door de bergen gereden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ проехали красивый маршрут через горы."
  },
  {
   "id": "l3-257",
   "level": 3,
   "text": "Ik ___ mijn collega gisteren over de verandering verteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера рассказал коллеге об изменениях."
  },
  {
   "id": "l3-258",
   "level": 3,
   "text": "Zij ___ haar hele kamer opnieuw ingericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ingericht",
   "rule": "transitief",
   "translationRu": "Она ___ полностью переобставила свою комнату."
  },
  {
   "id": "l3-259",
   "level": 3,
   "text": "Hij ___ tijdens de vakantie een oude vriend bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Он ___ во время отпуска навестил старого друга."
  },
  {
   "id": "l3-260",
   "level": 3,
   "text": "Wij ___ na het slechte nieuws naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после плохих новостей пошли домой."
  },
  {
   "id": "l3-261",
   "level": 3,
   "text": "Ik ___ gisteren mijn fiets buiten gezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezet",
   "rule": "transitief",
   "translationRu": "Я ___ вчера выставил свой велосипед на улицу."
  },
  {
   "id": "l3-262",
   "level": 3,
   "text": "Zij ___ een uur op haar trein gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Она ___ час ждала свой поезд."
  },
  {
   "id": "l3-263",
   "level": 3,
   "text": "Hij ___ zijn vakantie vroeg afgebroken vanwege een familieprobleem.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "afgebroken",
   "rule": "transitief",
   "translationRu": "Он ___ рано прервал свой отпуск из-за семейной проблемы."
  },
  {
   "id": "l3-264",
   "level": 3,
   "text": "Wij ___ de hele middag over onze plannen nagedacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "nagedacht",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день обдумывали наши планы."
  },
  {
   "id": "l3-265",
   "level": 3,
   "text": "Ik ___ na de cursus naar een café gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после курсов пошёл в кафе."
  },
  {
   "id": "l3-266",
   "level": 3,
   "text": "Zij ___ gisteren haar eerste rijles gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Она ___ вчера провела свой первый урок вождения."
  },
  {
   "id": "l3-267",
   "level": 3,
   "text": "Hij ___ tijdens het gesprek erg nerveus geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ во время разговора очень нервничал."
  },
  {
   "id": "l3-268",
   "level": 3,
   "text": "Wij ___ onze oude auto ingeruild voor een kleiner model.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ingeruild",
   "rule": "transitief",
   "translationRu": "Мы ___ обменяли нашу старую машину на модель поменьше."
  },
  {
   "id": "l3-269",
   "level": 3,
   "text": "Ik ___ een lange e-mail naar de klantenservice gestuurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Я ___ отправил длинное письмо в службу поддержки."
  },
  {
   "id": "l3-270",
   "level": 3,
   "text": "Zij ___ na haar werk bij haar vriendin langsgegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "langsgegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы зашла к подруге."
  },
  {
   "id": "l3-271",
   "level": 3,
   "text": "Hij ___ een paar dagen in het ziekenhuis gelegen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelegen",
   "rule": "transitief",
   "translationRu": "Он ___ пару дней пролежал в больнице."
  },
  {
   "id": "l3-272",
   "level": 3,
   "text": "Wij ___ gisteren een moeilijke keuze gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера сделали трудный выбор."
  },
  {
   "id": "l3-273",
   "level": 3,
   "text": "Ik ___ mijn sleutel nergens kunnen vinden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "kunnen vinden",
   "rule": "groeps-inf",
   "translationRu": "Я ___ нигде не мог найти свой ключ."
  },
  {
   "id": "l3-274",
   "level": 3,
   "text": "Zij ___ na de wedstrijd direct naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после матча сразу поехала домой."
  },
  {
   "id": "l3-275",
   "level": 3,
   "text": "Hij ___ tijdens zijn reis veel over de lokale cultuur geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Он ___ во время поездки узнал много нового о местной культуре."
  },
  {
   "id": "l3-276",
   "level": 3,
   "text": "Wij ___ in een klein hotel aan de kust geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Мы ___ ночевали в маленьком отеле на побережье."
  },
  {
   "id": "l3-277",
   "level": 3,
   "text": "Ik ___ gisteren mijn afspraak verzet omdat ik ziek was.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verzet",
   "rule": "transitief",
   "translationRu": "Я ___ вчера перенёс встречу, потому что заболел."
  },
  {
   "id": "l3-278",
   "level": 3,
   "text": "Zij ___ haar oude baan verlaten omdat ze meer uitdaging wilde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verlaten",
   "rule": "transitief",
   "translationRu": "Она ___ ушла со старой работы, потому что хотела больше вызова."
  },
  {
   "id": "l3-279",
   "level": 3,
   "text": "Hij ___ na het ontbijt naar de markt gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после завтрака пошёл на рынок."
  },
  {
   "id": "l3-280",
   "level": 3,
   "text": "Wij ___ de hele avond naar een interessante discussie geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер слушали интересную дискуссию."
  },
  {
   "id": "l3-281",
   "level": 3,
   "text": "Ik ___ mijn broer gevraagd of hij mee wilde gaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ спросил брата, не хочет ли он пойти с нами."
  },
  {
   "id": "l3-282",
   "level": 3,
   "text": "Zij ___ na een lange zoektocht eindelijk een appartement gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Она ___ после долгих поисков наконец нашла квартиру."
  },
  {
   "id": "l3-283",
   "level": 3,
   "text": "Hij ___ gisteren zijn portemonnee in de auto laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ вчера оставил свой кошелёк лежать в машине."
  },
  {
   "id": "l3-284",
   "level": 3,
   "text": "Wij ___ onderweg een paar mooie dorpjes tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ по дороге проехали пару красивых деревушек."
  },
  {
   "id": "l3-285",
   "level": 3,
   "text": "Ik ___ na het werk een uur in de sportschool getraind.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "getraind",
   "rule": "transitief",
   "translationRu": "Я ___ после работы час потренировался в спортзале."
  },
  {
   "id": "l3-286",
   "level": 3,
   "text": "Zij ___ vroeg naar bed gegaan omdat ze de volgende ochtend moest werken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ рано легла спать, потому что утром нужно было работать."
  },
  {
   "id": "l3-287",
   "level": 3,
   "text": "Hij ___ zijn presentatie gisteren voor zijn collega's gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера представил свою презентацию коллегам."
  },
  {
   "id": "l3-288",
   "level": 3,
   "text": "Wij ___ na het ontbijt onze koffers ingepakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ingepakt",
   "rule": "transitief",
   "translationRu": "Мы ___ после завтрака собрали свои чемоданы."
  },
  {
   "id": "l3-289",
   "level": 3,
   "text": "Ik ___ mijn ouders tijdens de vakantie meerdere keren gebeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ звонил родителям несколько раз во время отпуска."
  },
  {
   "id": "l3-290",
   "level": 3,
   "text": "Zij ___ tijdens de wandeling haar enkel bezeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "bezeerd",
   "rule": "transitief",
   "translationRu": "Она ___ во время прогулки повредила лодыжку."
  },
  {
   "id": "l3-291",
   "level": 3,
   "text": "Hij ___ na het ongeluk enkele dagen thuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после аварии несколько дней оставался дома."
  },
  {
   "id": "l3-292",
   "level": 3,
   "text": "Wij ___ een interessante oplossing voor het probleem bedacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bedacht",
   "rule": "transitief",
   "translationRu": "Мы ___ придумали интересное решение проблемы."
  },
  {
   "id": "l3-293",
   "level": 3,
   "text": "Ik ___ gisteren naar een vergadering op het gemeentehuis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ходил на совещание в мэрию."
  },
  {
   "id": "l3-294",
   "level": 3,
   "text": "Zij ___ haar oude meubels verkocht voordat ze verhuisde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Она ___ продала свою старую мебель, прежде чем переехать."
  },
  {
   "id": "l3-295",
   "level": 3,
   "text": "Hij ___ de hele dag met zijn nieuwe auto gereden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gereden",
   "rule": "beweging-duur",
   "translationRu": "Он ___ целый день ездил на своей новой машине."
  },
  {
   "id": "l3-296",
   "level": 3,
   "text": "Wij ___ na de vergadering samen koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Мы ___ после совещания вместе выпили кофе."
  },
  {
   "id": "l3-297",
   "level": 3,
   "text": "Ik ___ mijn tas in de bus laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою сумку лежать в автобусе."
  },
  {
   "id": "l3-298",
   "level": 3,
   "text": "Zij ___ na haar examen opgelucht geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после экзамена почувствовала облегчение."
  },
  {
   "id": "l3-299",
   "level": 3,
   "text": "Hij ___ zijn kinderen een verhaal voorgelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorgelezen",
   "rule": "transitief",
   "translationRu": "Он ___ прочитал своим детям сказку."
  },
  {
   "id": "l3-300",
   "level": 3,
   "text": "Wij ___ gisteren tot laat over onze plannen gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gesproken",
   "rule": "default-hebben",
   "translationRu": "Мы ___ вчера допоздна обсуждали наши планы."
  },
  {
   "id": "l3-301",
   "level": 3,
   "text": "Ik ___ vorige week naar de dokter gegaan omdat ik al dagen hoofdpijn had.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ на прошлой неделе ходил к врачу, потому что несколько дней болела голова."
  },
  {
   "id": "l3-302",
   "level": 3,
   "text": "Zij ___ de hele ochtend geprobeerd om haar computer te repareren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Она ___ всё утро пыталась починить свой компьютер."
  },
  {
   "id": "l3-303",
   "level": 3,
   "text": "Hij ___ na zijn werk rechtstreeks naar de supermarkt gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы сразу поехал в супермаркет."
  },
  {
   "id": "l3-304",
   "level": 3,
   "text": "Wij ___ tijdens onze vakantie een aantal interessante musea bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время нашего отпуска посетили несколько интересных музеев."
  },
  {
   "id": "l3-305",
   "level": 3,
   "text": "Ik ___ mijn oude laptop verkocht nadat ik een nieuwe had gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Я ___ продал свой старый ноутбук после того, как купил новый."
  },
  {
   "id": "l3-306",
   "level": 3,
   "text": "Zij ___ gisteren veel te laat naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ вчера легла спать слишком поздно."
  },
  {
   "id": "l3-307",
   "level": 3,
   "text": "Hij ___ zijn sleutel in de trein verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял свой ключ в поезде."
  },
  {
   "id": "l3-308",
   "level": 3,
   "text": "Wij ___ na het ontbijt richting de bergen gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака поехали в сторону гор."
  },
  {
   "id": "l3-309",
   "level": 3,
   "text": "Ik ___ mijn collega gevraagd of hij de vergadering kon verplaatsen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ спросил коллегу, не может ли он перенести совещание."
  },
  {
   "id": "l3-310",
   "level": 3,
   "text": "Zij ___ na een lange dag op het werk eindelijk thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгого рабочего дня наконец вернулась домой."
  },
  {
   "id": "l3-311",
   "level": 3,
   "text": "Hij ___ de hele avond met zijn vrienden over voetbal gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Он ___ весь вечер разговаривал с друзьями о футболе."
  },
  {
   "id": "l3-312",
   "level": 3,
   "text": "Wij ___ vorig jaar naar een groter huis verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ в прошлом году переехали в дом побольше."
  },
  {
   "id": "l3-313",
   "level": 3,
   "text": "Ik ___ gisteren een belangrijke beslissing genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера принял важное решение."
  },
  {
   "id": "l3-314",
   "level": 3,
   "text": "Zij ___ haar ouders verteld dat ze een andere baan had gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Она ___ рассказала родителям, что нашла другую работу."
  },
  {
   "id": "l3-315",
   "level": 3,
   "text": "Hij ___ tijdens het hardlopen gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ упал во время пробежки."
  },
  {
   "id": "l3-316",
   "level": 3,
   "text": "Wij ___ de hele middag in de tuin gezeten omdat het mooi weer was.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день сидели в саду, потому что была хорошая погода."
  },
  {
   "id": "l3-317",
   "level": 3,
   "text": "Ik ___ mijn tas in de auto laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою сумку лежать в машине."
  },
  {
   "id": "l3-318",
   "level": 3,
   "text": "Zij ___ na de cursus nog met een paar studenten gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Она ___ после курса ещё поговорила с парой студентов."
  },
  {
   "id": "l3-319",
   "level": 3,
   "text": "Hij ___ gisteren zijn trein gemist omdat hij zich had verslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Он ___ вчера опоздал на свой поезд, потому что проспал."
  },
  {
   "id": "l3-320",
   "level": 3,
   "text": "Wij ___ een paar dagen in een dorpje aan zee gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пару дней оставались в деревне у моря."
  },
  {
   "id": "l3-321",
   "level": 3,
   "text": "Ik ___ na het eten de afwas gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ после еды помыл посуду."
  },
  {
   "id": "l3-322",
   "level": 3,
   "text": "Zij ___ tijdens de reis haar paspoort verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Она ___ во время поездки потеряла свой паспорт."
  },
  {
   "id": "l3-323",
   "level": 3,
   "text": "Hij ___ na zijn ziekte langzaam weer aan het werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после болезни медленно вернулся к работе."
  },
  {
   "id": "l3-324",
   "level": 3,
   "text": "Wij ___ gisteren een lange wandeling door de stad gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера долго гуляли по городу."
  },
  {
   "id": "l3-325",
   "level": 3,
   "text": "Ik ___ mijn oude vriend na twintig jaar weer ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Я ___ снова встретил своего старого друга через двадцать лет."
  },
  {
   "id": "l3-326",
   "level": 3,
   "text": "Zij ___ vroeg naar het station vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ рано уехала на вокзал."
  },
  {
   "id": "l3-327",
   "level": 3,
   "text": "Hij ___ zijn auto bij het hotel geparkeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geparkeerd",
   "rule": "transitief",
   "translationRu": "Он ___ припарковал свою машину у отеля."
  },
  {
   "id": "l3-328",
   "level": 3,
   "text": "Wij ___ verschillende ideeën voor het nieuwe project besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ обсудили разные идеи для нового проекта."
  },
  {
   "id": "l3-329",
   "level": 3,
   "text": "Ik ___ gisteren een uur op mijn afspraak gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Я ___ вчера час ждал свою встречу."
  },
  {
   "id": "l3-330",
   "level": 3,
   "text": "Zij ___ na de vakantie weer bij haar ouders gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ после отпуска снова переехала жить к родителям."
  },
  {
   "id": "l3-331",
   "level": 3,
   "text": "Hij ___ zijn presentatie goed voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorbereid",
   "rule": "transitief",
   "translationRu": "Он ___ хорошо подготовил свою презентацию."
  },
  {
   "id": "l3-332",
   "level": 3,
   "text": "Wij ___ onderweg een paar keer gestopt om foto's te maken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestopt",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ по дороге пару раз останавливались, чтобы сделать фотографии."
  },
  {
   "id": "l3-333",
   "level": 3,
   "text": "Ik ___ mijn moeder geholpen met het organiseren van haar verjaardag.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ помог маме организовать её день рождения."
  },
  {
   "id": "l3-334",
   "level": 3,
   "text": "Zij ___ na het gesprek van mening veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ после разговора переменила мнение."
  },
  {
   "id": "l3-335",
   "level": 3,
   "text": "Hij ___ de hele nacht niet geslapen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geslapen",
   "rule": "transitief",
   "translationRu": "Он ___ всю ночь не спал."
  },
  {
   "id": "l3-336",
   "level": 3,
   "text": "Wij ___ gisteren naar een concert in Rotterdam gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера ходили на концерт в Роттердаме."
  },
  {
   "id": "l3-337",
   "level": 3,
   "text": "Ik ___ mijn fiets naar het station gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ отвёз свой велосипед на вокзал."
  },
  {
   "id": "l3-338",
   "level": 3,
   "text": "Zij ___ een nieuwe baan in een andere stad aangenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangenomen",
   "rule": "transitief",
   "translationRu": "Она ___ приняла предложение о новой работе в другом городе."
  },
  {
   "id": "l3-339",
   "level": 3,
   "text": "Hij ___ na het ontbijt de hond uitgelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "uitgelaten",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака выгулял собаку."
  },
  {
   "id": "l3-340",
   "level": 3,
   "text": "Wij ___ een paar uur in een café gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ пару часов посидели в кафе."
  },
  {
   "id": "l3-341",
   "level": 3,
   "text": "Ik ___ gisteren een interessante cursus gevolgd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevolgd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера прошёл интересный курс."
  },
  {
   "id": "l3-342",
   "level": 3,
   "text": "Zij ___ na haar werk naar de sportschool gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы пошла в спортзал."
  },
  {
   "id": "l3-343",
   "level": 3,
   "text": "Hij ___ tijdens zijn vakantie veel nieuwe gerechten geprobeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Он ___ во время отпуска попробовал много новых блюд."
  },
  {
   "id": "l3-344",
   "level": 3,
   "text": "Wij ___ onze plannen vanwege de situatie aangepast.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Мы ___ скорректировали свои планы в связи с ситуацией."
  },
  {
   "id": "l3-345",
   "level": 3,
   "text": "Ik ___ mijn sleutel uiteindelijk in mijn jaszak gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Я ___ в итоге нашёл свой ключ в кармане куртки."
  },
  {
   "id": "l3-346",
   "level": 3,
   "text": "Zij ___ zonder iets te zeggen de kamer verlaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verlaten",
   "rule": "transitief",
   "translationRu": "Она ___ ничего не сказав покинула комнату."
  },
  {
   "id": "l3-347",
   "level": 3,
   "text": "Hij ___ gisteren zijn oude foto's gescand.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gescand",
   "rule": "transitief",
   "translationRu": "Он ___ вчера отсканировал свои старые фотографии."
  },
  {
   "id": "l3-348",
   "level": 3,
   "text": "Wij ___ na het diner naar het hotel teruggegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "teruggegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после ужина вернулись в отель."
  },
  {
   "id": "l3-349",
   "level": 3,
   "text": "Ik ___ mijn collega een vraag over het nieuwe systeem gesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesteld",
   "rule": "transitief",
   "translationRu": "Я ___ задал коллеге вопрос о новой системе."
  },
  {
   "id": "l3-350",
   "level": 3,
   "text": "Zij ___ een paar dagen bij haar broer gelogeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelogeerd",
   "rule": "transitief",
   "translationRu": "Она ___ пару дней погостила у своего брата."
  },
  {
   "id": "l3-351",
   "level": 3,
   "text": "Hij ___ tijdens de vergadering een belangrijke fout gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ во время совещания допустил важную ошибку."
  },
  {
   "id": "l3-352",
   "level": 3,
   "text": "Wij ___ gisteren een nieuwe tafel voor de woonkamer gekocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера купили новый стол в гостиную."
  },
  {
   "id": "l3-353",
   "level": 3,
   "text": "Ik ___ na mijn werk direct naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы сразу поехал домой."
  },
  {
   "id": "l3-354",
   "level": 3,
   "text": "Zij ___ na een lange reis erg moe geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после долгой поездки очень устала."
  },
  {
   "id": "l3-355",
   "level": 3,
   "text": "Hij ___ zijn ouders in het weekend bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Он ___ навестил своих родителей на выходных."
  },
  {
   "id": "l3-356",
   "level": 3,
   "text": "Wij ___ een paar uur door het centrum gewandeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewandeld",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ пару часов прогулялись по центру."
  },
  {
   "id": "l3-357",
   "level": 3,
   "text": "Ik ___ mijn agenda thuis laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой ежедневник лежать дома."
  },
  {
   "id": "l3-358",
   "level": 3,
   "text": "Zij ___ gisteren haar laatste examen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ вчера сдала свой последний экзамен."
  },
  {
   "id": "l3-359",
   "level": 3,
   "text": "Hij ___ na de vergadering nog even met zijn baas gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ после совещания ещё немного поговорил со своим начальником."
  },
  {
   "id": "l3-360",
   "level": 3,
   "text": "Wij ___ tijdens de vakantie verschillende stranden bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска побывали на нескольких пляжах."
  },
  {
   "id": "l3-361",
   "level": 3,
   "text": "Ik ___ mijn oude telefoon aan mijn zus gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ отдал свой старый телефон сестре."
  },
  {
   "id": "l3-362",
   "level": 3,
   "text": "Zij ___ na het ontbijt naar haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после завтрака ушла на работу."
  },
  {
   "id": "l3-363",
   "level": 3,
   "text": "Hij ___ een paar dagen ziek thuis gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ пару дней сидел дома из-за болезни."
  },
  {
   "id": "l3-364",
   "level": 3,
   "text": "Wij ___ gisteren een probleem met de auto gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ вчера была проблема с машиной."
  },
  {
   "id": "l3-365",
   "level": 3,
   "text": "Ik ___ mijn afspraak bij de tandarts verplaatst.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verplaatst",
   "rule": "transitief",
   "translationRu": "Я ___ перенёс свой приём у стоматолога."
  },
  {
   "id": "l3-366",
   "level": 3,
   "text": "Zij ___ na haar studie in Amsterdam gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "Она ___ после учёбы поехала жить в Амстердам."
  },
  {
   "id": "l3-367",
   "level": 3,
   "text": "Hij ___ tijdens de wandeling een mooie vogel gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Он ___ во время прогулки увидел красивую птицу."
  },
  {
   "id": "l3-368",
   "level": 3,
   "text": "Wij ___ een uur op onze vrienden gewacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Мы ___ час ждали наших друзей."
  },
  {
   "id": "l3-369",
   "level": 3,
   "text": "Ik ___ gisteren mijn hele kamer opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера полностью убрался в своей комнате."
  },
  {
   "id": "l3-370",
   "level": 3,
   "text": "Zij ___ met haar gezin naar Frankrijk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ со своей семьёй поехала во Францию."
  },
  {
   "id": "l3-371",
   "level": 3,
   "text": "Hij ___ na het nieuws erg stil geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после новостей стал очень тихим."
  },
  {
   "id": "l3-372",
   "level": 3,
   "text": "Wij ___ een interessant gesprek over de toekomst gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ состоялся интересный разговор о будущем."
  },
  {
   "id": "l3-373",
   "level": 3,
   "text": "Ik ___ mijn paspoort in de hotelkamer laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой паспорт лежать в гостиничном номере."
  },
  {
   "id": "l3-374",
   "level": 3,
   "text": "Zij ___ na de lunch naar de bibliotheek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после обеда пошла в библиотеку."
  },
  {
   "id": "l3-375",
   "level": 3,
   "text": "Hij ___ zijn nieuwe collega aan iedereen voorgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "voorgesteld",
   "rule": "transitief",
   "translationRu": "Он ___ представил своего нового коллегу всем."
  },
  {
   "id": "l3-376",
   "level": 3,
   "text": "Wij ___ gisteren een lange vergadering bijgewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bijgewoond",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера побывали на долгом совещании."
  },
  {
   "id": "l3-377",
   "level": 3,
   "text": "Ik ___ na het werk nog boodschappen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ после работы ещё сделал покупки."
  },
  {
   "id": "l3-378",
   "level": 3,
   "text": "Zij ___ haar fiets tijdens de verhuizing beschadigd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "beschadigd",
   "rule": "transitief",
   "translationRu": "Она ___ повредила свой велосипед во время переезда."
  },
  {
   "id": "l3-379",
   "level": 3,
   "text": "Hij ___ na het ontbijt een lange wandeling gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака совершил долгую прогулку."
  },
  {
   "id": "l3-380",
   "level": 3,
   "text": "Wij ___ na een paar uur eindelijk een oplossing gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ через пару часов наконец нашли решение."
  },
  {
   "id": "l3-381",
   "level": 3,
   "text": "Ik ___ mijn ouders gevraagd om op mijn kinderen te passen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ попросил родителей присмотреть за моими детьми."
  },
  {
   "id": "l3-382",
   "level": 3,
   "text": "Zij ___ gisteren pas om middernacht thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ вчера вернулась домой только в полночь."
  },
  {
   "id": "l3-383",
   "level": 3,
   "text": "Hij ___ zijn hele weekend aan zijn studie besteed.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "besteed",
   "rule": "transitief",
   "translationRu": "Он ___ посвятил все выходные своей учёбе."
  },
  {
   "id": "l3-384",
   "level": 3,
   "text": "Wij ___ tijdens de reis veel geleerd over de geschiedenis van de stad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Мы ___ во время поездки узнали много нового об истории города."
  },
  {
   "id": "l3-385",
   "level": 3,
   "text": "Ik ___ mijn oude kamer bij mijn ouders bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Я ___ навестил свою старую комнату у родителей."
  },
  {
   "id": "l3-386",
   "level": 3,
   "text": "Zij ___ na het gesprek meteen naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после разговора сразу пошла домой."
  },
  {
   "id": "l3-387",
   "level": 3,
   "text": "Hij ___ een aantal belangrijke documenten vergeten mee te nemen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Он ___ забыл взять с собой несколько важных документов."
  },
  {
   "id": "l3-388",
   "level": 3,
   "text": "Wij ___ gisteren samen een planning voor de komende maanden gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера вместе составили план на следующие месяцы."
  },
  {
   "id": "l3-389",
   "level": 3,
   "text": "Ik ___ na de cursus met de trein naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после курсов поехал домой на поезде."
  },
  {
   "id": "l3-390",
   "level": 3,
   "text": "Zij ___ haar baan opgezegd omdat ze meer tijd voor haar gezin wilde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgezegd",
   "rule": "transitief",
   "translationRu": "Она ___ уволилась с работы, потому что хотела больше времени проводить с семьёй."
  },
  {
   "id": "l3-391",
   "level": 3,
   "text": "Hij ___ tijdens het sporten zijn arm gebroken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebroken",
   "rule": "transitief",
   "translationRu": "Он ___ сломал руку во время занятий спортом."
  },
  {
   "id": "l3-392",
   "level": 3,
   "text": "Wij ___ de hele avond naar de radio geluisterd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geluisterd",
   "rule": "transitief",
   "translationRu": "Мы ___ весь вечер слушали радио."
  },
  {
   "id": "l3-393",
   "level": 3,
   "text": "Ik ___ mijn fiets buiten laten staan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten staan",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой велосипед стоять на улице."
  },
  {
   "id": "l3-394",
   "level": 3,
   "text": "Zij ___ na de verhuizing eindelijk wat rust gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ после переезда наконец немного отдохнула."
  },
  {
   "id": "l3-395",
   "level": 3,
   "text": "Hij ___ gisteren een presentatie voor zijn team gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера провёл презентацию для своей команды."
  },
  {
   "id": "l3-396",
   "level": 3,
   "text": "Wij ___ onderweg een oude bekende tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ по дороге встретили старого знакомого."
  },
  {
   "id": "l3-397",
   "level": 3,
   "text": "Ik ___ mijn broer verteld dat ik later zou komen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Я ___ рассказал брату, что приду позже."
  },
  {
   "id": "l3-398",
   "level": 3,
   "text": "Zij ___ een paar dagen in een hotel aan zee verbleven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verbleven",
   "rule": "transitief",
   "translationRu": "Она ___ пару дней провела в отеле у моря."
  },
  {
   "id": "l3-399",
   "level": 3,
   "text": "Hij ___ na zijn vakantie weer naar zijn werk teruggegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после отпуска снова вернулся на работу."
  },
  {
   "id": "l3-400",
   "level": 3,
   "text": "Wij ___ gisteren een moeilijke vergadering gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "У нас ___ вчера было трудное совещание."
  },
  {
   "id": "l3-401",
   "level": 3,
   "text": "Ik ___ gisteren naar de supermarkt gegaan nadat ik mijn werk had afgemaakt.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера пошёл в супермаркет после того, как закончил работу."
  },
  {
   "id": "l3-402",
   "level": 3,
   "text": "Zij ___ de hele ochtend aan haar scriptie gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Она ___ всё утро работала над своей дипломной работой."
  },
  {
   "id": "l3-403",
   "level": 3,
   "text": "Hij ___ na het ontbijt zijn auto naar de garage gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Он ___ после завтрака отогнал машину в гараж."
  },
  {
   "id": "l3-404",
   "level": 3,
   "text": "Wij ___ tijdens onze vakantie verschillende historische plaatsen bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время нашего отпуска побывали в нескольких исторических местах."
  },
  {
   "id": "l3-405",
   "level": 3,
   "text": "Ik ___ mijn oude baan verlaten omdat ik dichter bij mijn familie wilde wonen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verlaten",
   "rule": "transitief",
   "translationRu": "Я ___ ушёл со старой работы, потому что хотел жить ближе к семье."
  },
  {
   "id": "l3-406",
   "level": 3,
   "text": "Zij ___ na het gesprek een stuk zekerder van zichzelf geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после разговора стала намного увереннее в себе."
  },
  {
   "id": "l3-407",
   "level": 3,
   "text": "Hij ___ gisteren zijn ouders opgebeld om te vertellen dat hij was aangekomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgebeld",
   "rule": "transitief",
   "translationRu": "Он ___ вчера позвонил родителям, чтобы рассказать, что добрался."
  },
  {
   "id": "l3-408",
   "level": 3,
   "text": "Wij ___ een paar dagen in een rustig dorp gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ пару дней оставались в тихой деревне."
  },
  {
   "id": "l3-409",
   "level": 3,
   "text": "Ik ___ mijn trein bijna gemist omdat ik te laat van huis vertrokken was.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gemist",
   "rule": "transitief",
   "translationRu": "Я ___ чуть не опоздал на свой поезд, потому что слишком поздно вышел из дома."
  },
  {
   "id": "l3-410",
   "level": 3,
   "text": "Zij ___ haar presentatie verschillende keren geoefend voordat ze voor de groep stond.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geoefend",
   "rule": "transitief",
   "translationRu": "Она ___ несколько раз отрепетировала свою презентацию, прежде чем выступить перед группой."
  },
  {
   "id": "l3-411",
   "level": 3,
   "text": "Hij ___ tijdens de vakantie een aantal nieuwe vrienden gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ во время отпуска завёл несколько новых друзей."
  },
  {
   "id": "l3-412",
   "level": 3,
   "text": "Wij ___ na het eten nog een uur op het terras gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Мы ___ после еды ещё час посидели на террасе."
  },
  {
   "id": "l3-413",
   "level": 3,
   "text": "Ik ___ gisteren mijn collega geholpen met een ingewikkeld probleem.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geholpen",
   "rule": "transitief",
   "translationRu": "Я ___ вчера помог коллеге со сложной проблемой."
  },
  {
   "id": "l3-414",
   "level": 3,
   "text": "Zij ___ naar een andere stad verhuisd nadat ze daar een nieuwe baan had gevonden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ переехала в другой город после того, как нашла там новую работу."
  },
  {
   "id": "l3-415",
   "level": 3,
   "text": "Hij ___ zijn telefoon thuis laten liggen en kon daardoor geen foto's maken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ оставил свой телефон лежать дома и поэтому не мог делать фотографии."
  },
  {
   "id": "l3-416",
   "level": 3,
   "text": "Wij ___ de hele middag geprobeerd om de kast te repareren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geprobeerd",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ весь день пытались починить шкаф."
  },
  {
   "id": "l3-417",
   "level": 3,
   "text": "Ik ___ na het werk naar mijn ouders gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Я ___ после работы поехал к родителям."
  },
  {
   "id": "l3-418",
   "level": 3,
   "text": "Zij ___ tijdens de vergadering een interessante vraag gesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gesteld",
   "rule": "transitief",
   "translationRu": "Она ___ во время совещания задала интересный вопрос."
  },
  {
   "id": "l3-419",
   "level": 3,
   "text": "Hij ___ na de lange reis meteen in slaap gevallen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gevallen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после долгой поездки сразу заснул."
  },
  {
   "id": "l3-420",
   "level": 3,
   "text": "Wij ___ gisteren een aantal belangrijke afspraken gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера назначили несколько важных встреч."
  },
  {
   "id": "l3-421",
   "level": 3,
   "text": "Ik ___ mijn oude boeken aan een bibliotheek gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Я ___ отдал свои старые книги библиотеке."
  },
  {
   "id": "l3-422",
   "level": 3,
   "text": "Zij ___ na het ontbijt naar de markt gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gelopen",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после завтрака пошла на рынок."
  },
  {
   "id": "l3-423",
   "level": 3,
   "text": "Hij ___ de hele avond met zijn zus over haar probleem gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ весь вечер разговаривал с сестрой о её проблеме."
  },
  {
   "id": "l3-424",
   "level": 3,
   "text": "Wij ___ tijdens onze vakantie veel in de zee gezwommen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezwommen",
   "rule": "beweging-duur",
   "translationRu": "Мы ___ во время нашего отпуска много плавали в море."
  },
  {
   "id": "l3-425",
   "level": 3,
   "text": "Ik ___ gisteren mijn afspraak bij de tandarts vergeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "vergeten",
   "rule": "transitief",
   "translationRu": "Я ___ вчера забыл про приём у стоматолога."
  },
  {
   "id": "l3-426",
   "level": 3,
   "text": "Zij ___ na haar werk nog bij haar vriendin langsgegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "langsgegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы ещё заглянула к подруге."
  },
  {
   "id": "l3-427",
   "level": 3,
   "text": "Hij ___ zijn hele kamer opnieuw geschilderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geschilderd",
   "rule": "transitief",
   "translationRu": "Он ___ полностью перекрасил свою комнату."
  },
  {
   "id": "l3-428",
   "level": 3,
   "text": "Wij ___ na de vergadering samen naar een restaurant gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после совещания вместе пошли в ресторан."
  },
  {
   "id": "l3-429",
   "level": 3,
   "text": "Ik ___ mijn portemonnee gelukkig snel teruggevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "teruggevonden",
   "rule": "transitief",
   "translationRu": "Я ___ к счастью быстро нашёл свой кошелёк."
  },
  {
   "id": "l3-430",
   "level": 3,
   "text": "Zij ___ een paar dagen bij haar ouders gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ пару дней погостила у родителей."
  },
  {
   "id": "l3-431",
   "level": 3,
   "text": "Hij ___ tijdens het fietsen een ongeluk gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Он ___ попал в аварию во время езды на велосипеде."
  },
  {
   "id": "l3-432",
   "level": 3,
   "text": "Wij ___ gisteren een interessant boek besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера обсудили интересную книгу."
  },
  {
   "id": "l3-433",
   "level": 3,
   "text": "Ik ___ na het ontbijt mijn koffers ingepakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ingepakt",
   "rule": "transitief",
   "translationRu": "Я ___ после завтрака собрал свои чемоданы."
  },
  {
   "id": "l3-434",
   "level": 3,
   "text": "Zij ___ naar Duitsland gereden om haar familie te bezoeken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Она ___ поехала в Германию навестить свою семью."
  },
  {
   "id": "l3-435",
   "level": 3,
   "text": "Hij ___ zijn oude auto verkocht omdat de reparaties te duur werden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Он ___ продал свою старую машину, потому что ремонт стал слишком дорогим."
  },
  {
   "id": "l3-436",
   "level": 3,
   "text": "Wij ___ de hele dag aan onze presentatie gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ весь день работали над нашей презентацией."
  },
  {
   "id": "l3-437",
   "level": 3,
   "text": "Ik ___ gisteren mijn huisarts gebeld om een afspraak te maken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebeld",
   "rule": "transitief",
   "translationRu": "Я ___ вчера позвонил своему терапевту, чтобы записаться на приём."
  },
  {
   "id": "l3-438",
   "level": 3,
   "text": "Zij ___ na het slechte nieuws erg stil geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после плохих новостей стала очень тихой."
  },
  {
   "id": "l3-439",
   "level": 3,
   "text": "Hij ___ een uur op het station gewacht voordat de trein kwam.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewacht",
   "rule": "transitief",
   "translationRu": "Он ___ час ждал на вокзале, прежде чем пришёл поезд."
  },
  {
   "id": "l3-440",
   "level": 3,
   "text": "Wij ___ tijdens de reis verschillende keren van hotel veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Мы ___ во время поездки несколько раз меняли отель."
  },
  {
   "id": "l3-441",
   "level": 3,
   "text": "Ik ___ mijn sleutel in de deur laten zitten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten zitten",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свой ключ торчать в двери."
  },
  {
   "id": "l3-442",
   "level": 3,
   "text": "Zij ___ gisteren haar laatste werkdag gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Она ___ вчера провела свой последний рабочий день."
  },
  {
   "id": "l3-443",
   "level": 3,
   "text": "Hij ___ na het werk naar de sportschool gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Он ___ после работы пошёл в спортзал."
  },
  {
   "id": "l3-444",
   "level": 3,
   "text": "Wij ___ een lange wandeling door het centrum gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ совершили долгую прогулку по центру."
  },
  {
   "id": "l3-445",
   "level": 3,
   "text": "Ik ___ mijn oude fiets naar de kringloopwinkel gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Я ___ отвёз свой старый велосипед в комиссионный магазин."
  },
  {
   "id": "l3-446",
   "level": 3,
   "text": "Zij ___ na haar examen met haar vrienden iets gaan drinken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gaan drinken",
   "rule": "groeps-inf",
   "translationRu": "Она ___ после экзамена пошла с друзьями чего-нибудь выпить."
  },
  {
   "id": "l3-447",
   "level": 3,
   "text": "Hij ___ gisteren zijn tas in de trein laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ вчера оставил свою сумку лежать в поезде."
  },
  {
   "id": "l3-448",
   "level": 3,
   "text": "Wij ___ een paar dagen aan zee doorgebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "doorgebracht",
   "rule": "transitief",
   "translationRu": "Мы ___ провели пару дней у моря."
  },
  {
   "id": "l3-449",
   "level": 3,
   "text": "Ik ___ na het gesprek mijn mening veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Я ___ после разговора изменил своё мнение."
  },
  {
   "id": "l3-450",
   "level": 3,
   "text": "Zij ___ haar kinderen naar school gebracht voordat ze naar haar werk ging.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebracht",
   "rule": "transitief",
   "translationRu": "Она ___ отвела детей в школу, прежде чем пойти на работу."
  },
  {
   "id": "l3-451",
   "level": 3,
   "text": "Hij ___ tijdens zijn verblijf in Nederland veel Nederlands geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Он ___ во время пребывания в Нидерландах многому научился по-нидерландски."
  },
  {
   "id": "l3-452",
   "level": 3,
   "text": "Wij ___ gisteren laat naar huis gegaan omdat het feest nog bezig was.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера поздно пошли домой, потому что вечеринка ещё продолжалась."
  },
  {
   "id": "l3-453",
   "level": 3,
   "text": "Ik ___ mijn collega gevraagd of hij mij met het verslag kon helpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ спросил коллегу, не может ли он помочь мне с отчётом."
  },
  {
   "id": "l3-454",
   "level": 3,
   "text": "Zij ___ na de vakantie weer bij haar oude werkgever begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после отпуска снова вышла на работу к своему старому работодателю."
  },
  {
   "id": "l3-455",
   "level": 3,
   "text": "Hij ___ zijn portemonnee tijdens het winkelen verloren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verloren",
   "rule": "transitief",
   "translationRu": "Он ___ потерял свой кошелёк во время шопинга."
  },
  {
   "id": "l3-456",
   "level": 3,
   "text": "Wij ___ een paar interessante mensen op de conferentie ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Мы ___ познакомились с несколькими интересными людьми на конференции."
  },
  {
   "id": "l3-457",
   "level": 3,
   "text": "Ik ___ gisteren mijn hele ochtend aan de administratie besteed.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besteed",
   "rule": "transitief",
   "translationRu": "Я ___ вчера потратил на бумажную работу всё утро."
  },
  {
   "id": "l3-458",
   "level": 3,
   "text": "Zij ___ na het ontbijt een wandeling langs de rivier gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Она ___ после завтрака совершила прогулку вдоль реки."
  },
  {
   "id": "l3-459",
   "level": 3,
   "text": "Hij ___ tijdens de verhuizing een aantal dozen laten vallen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "laten vallen",
   "rule": "groeps-inf",
   "translationRu": "Он ___ во время переезда уронил несколько коробок."
  },
  {
   "id": "l3-460",
   "level": 3,
   "text": "Wij ___ na een lange discussie eindelijk een beslissing genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Мы ___ после долгого обсуждения наконец приняли решение."
  },
  {
   "id": "l3-461",
   "level": 3,
   "text": "Ik ___ mijn ouders verteld dat ik volgend jaar misschien ga verhuizen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verteld",
   "rule": "transitief",
   "translationRu": "Я ___ рассказал родителям, что, возможно, перееду в следующем году."
  },
  {
   "id": "l3-462",
   "level": 3,
   "text": "Zij ___ na haar werk rechtstreeks naar het station gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы сразу поехала на вокзал."
  },
  {
   "id": "l3-463",
   "level": 3,
   "text": "Hij ___ de hele nacht wakker gelegen omdat hij zich zorgen maakte.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gelegen",
   "rule": "reflexief",
   "translationRu": "Он ___ пролежал всю ночь без сна, потому что беспокоился."
  },
  {
   "id": "l3-464",
   "level": 3,
   "text": "Wij ___ tijdens de vakantie veel lokale markten bezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ во время отпуска побывали на многих местных рынках."
  },
  {
   "id": "l3-465",
   "level": 3,
   "text": "Ik ___ gisteren mijn oude kamer bij mijn ouders opgeruimd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "opgeruimd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера убрался в своей старой комнате у родителей."
  },
  {
   "id": "l3-466",
   "level": 3,
   "text": "Zij ___ na het gesprek naar buiten gegaan om even frisse lucht te krijgen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после разговора вышла на улицу подышать свежим воздухом."
  },
  {
   "id": "l3-467",
   "level": 3,
   "text": "Hij ___ een paar uur met zijn manager over zijn toekomst gepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gepraat",
   "rule": "transitief",
   "translationRu": "Он ___ пару часов поговорил со своим руководителем о будущем."
  },
  {
   "id": "l3-468",
   "level": 3,
   "text": "Wij ___ een nieuwe computer gekocht nadat onze oude kapot was gegaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekocht",
   "rule": "transitief",
   "translationRu": "Мы ___ купили новый компьютер после того, как наш старый сломался."
  },
  {
   "id": "l3-469",
   "level": 3,
   "text": "Ik ___ mijn tas op kantoor laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свою сумку лежать на работе."
  },
  {
   "id": "l3-470",
   "level": 3,
   "text": "Zij ___ tijdens haar studie verschillende stages gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ во время учёбы прошла несколько стажировок."
  },
  {
   "id": "l3-471",
   "level": 3,
   "text": "Hij ___ na zijn ontslag een tijdje zonder werk gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ после увольнения какое-то время сидел без работы."
  },
  {
   "id": "l3-472",
   "level": 3,
   "text": "Wij ___ gisteren naar een lezing over klimaatverandering gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ вчера ходили на лекцию об изменении климата."
  },
  {
   "id": "l3-473",
   "level": 3,
   "text": "Ik ___ mijn broer gevraagd om mij van het station op te halen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ попросил брата заехать за мной на вокзал."
  },
  {
   "id": "l3-474",
   "level": 3,
   "text": "Zij ___ na de lange reis eindelijk in haar hotel aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгого путешествия наконец добралась до своего отеля."
  },
  {
   "id": "l3-475",
   "level": 3,
   "text": "Hij ___ zijn presentatie pas de avond ervoor afgemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "afgemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ закончил свою презентацию только накануне вечером."
  },
  {
   "id": "l3-476",
   "level": 3,
   "text": "Wij ___ tijdens de wandeling een prachtig uitzicht gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ во время прогулки увидели прекрасный вид."
  },
  {
   "id": "l3-477",
   "level": 3,
   "text": "Ik ___ gisteren mijn fiets naar mijn werk gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Я ___ вчера ехал на работу на велосипеде."
  },
  {
   "id": "l3-478",
   "level": 3,
   "text": "Zij ___ haar oude appartement verkocht voordat ze naar het buitenland verhuisde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verkocht",
   "rule": "transitief",
   "translationRu": "Она ___ продала свою старую квартиру, прежде чем переехать за границу."
  },
  {
   "id": "l3-479",
   "level": 3,
   "text": "Hij ___ na de vergadering nog een kop koffie gedronken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedronken",
   "rule": "transitief",
   "translationRu": "Он ___ после совещания ещё выпил чашку кофе."
  },
  {
   "id": "l3-480",
   "level": 3,
   "text": "Wij ___ een paar uur in de file gestaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Мы ___ пару часов простояли в пробке."
  },
  {
   "id": "l3-481",
   "level": 3,
   "text": "Ik ___ mijn vakantie vroeg geboekt omdat de prijzen daarna hoger werden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geboekt",
   "rule": "transitief",
   "translationRu": "Я ___ забронировал свой отпуск заранее, потому что потом цены стали выше."
  },
  {
   "id": "l3-482",
   "level": 3,
   "text": "Zij ___ na het ontbijt naar haar werk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после завтрака ушла на работу."
  },
  {
   "id": "l3-483",
   "level": 3,
   "text": "Hij ___ tijdens het koken zijn hand bezeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bezeerd",
   "rule": "transitief",
   "translationRu": "Он ___ поранил руку во время готовки."
  },
  {
   "id": "l3-484",
   "level": 3,
   "text": "Wij ___ gisteren een interessante film over de geschiedenis van Nederland gezien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezien",
   "rule": "transitief",
   "translationRu": "Мы ___ вчера посмотрели интересный фильм об истории Нидерландов."
  },
  {
   "id": "l3-485",
   "level": 3,
   "text": "Ik ___ mijn collega een bericht gestuurd omdat ik later zou komen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gestuurd",
   "rule": "transitief",
   "translationRu": "Я ___ отправил коллеге сообщение, потому что собирался прийти позже."
  },
  {
   "id": "l3-486",
   "level": 3,
   "text": "Zij ___ na haar studie naar Utrecht verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после учёбы переехала в Утрехт."
  },
  {
   "id": "l3-487",
   "level": 3,
   "text": "Hij ___ een paar dagen thuis gebleven om voor zijn kinderen te zorgen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ пару дней оставался дома, чтобы присмотреть за детьми."
  },
  {
   "id": "l3-488",
   "level": 3,
   "text": "Wij ___ tijdens onze reis veel foto's van de natuur gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ во время нашей поездки сделали много фотографий природы."
  },
  {
   "id": "l3-489",
   "level": 3,
   "text": "Ik ___ gisteren mijn administratie eindelijk afgemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "afgemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ вчера наконец закончил свои бумажные дела."
  },
  {
   "id": "l3-490",
   "level": 3,
   "text": "Zij ___ na het werk nog naar de winkel gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после работы ещё зашла в магазин."
  },
  {
   "id": "l3-491",
   "level": 3,
   "text": "Hij ___ zijn oude vrienden na jaren weer ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Он ___ снова встретил своих старых друзей через много лет."
  },
  {
   "id": "l3-492",
   "level": 3,
   "text": "Wij ___ een uur naar de juiste weg gezocht voordat we hem vonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gezocht",
   "rule": "transitief",
   "translationRu": "Мы ___ час искали правильную дорогу, прежде чем нашли её."
  },
  {
   "id": "l3-493",
   "level": 3,
   "text": "Ik ___ mijn sleutels op het werk laten liggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "laten liggen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ оставил свои ключи лежать на работе."
  },
  {
   "id": "l3-494",
   "level": 3,
   "text": "Zij ___ na het gesprek besloten om toch mee te gaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Она ___ после разговора решила всё-таки пойти."
  },
  {
   "id": "l3-495",
   "level": 3,
   "text": "Hij ___ gisteren een belangrijke presentatie voor zijn manager gegeven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegeven",
   "rule": "transitief",
   "translationRu": "Он ___ вчера провёл важную презентацию для своего руководителя."
  },
  {
   "id": "l3-496",
   "level": 3,
   "text": "Wij ___ na het ontbijt met de auto naar huis gereden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gereden",
   "rule": "beweging-richting",
   "translationRu": "Мы ___ после завтрака поехали домой на машине."
  },
  {
   "id": "l3-497",
   "level": 3,
   "text": "Ik ___ tijdens mijn vakantie veel nieuwe dingen geleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Я ___ во время отпуска узнал много нового."
  },
  {
   "id": "l3-498",
   "level": 3,
   "text": "Zij ___ na een lange dag op het werk vroeg naar bed gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gegaan",
   "rule": "beweging-richting",
   "translationRu": "Она ___ после долгого рабочего дня рано легла спать."
  },
  {
   "id": "l3-499",
   "level": 3,
   "text": "Hij ___ zijn plannen veranderd nadat hij met zijn ouders had gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "veranderd",
   "rule": "transitief",
   "translationRu": "Он ___ изменил свои планы после того, как поговорил с родителями."
  },
  {
   "id": "l3-500",
   "level": 3,
   "text": "Wij ___ na een lange reis eindelijk weer thuisgekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "thuisgekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после долгого путешествия наконец вернулись домой."
  },
  {
   "id": "l4-001",
   "level": 4,
   "text": "Hoewel het aanvankelijk niet de bedoeling was, ___ we uiteindelijk toch tot een compromis gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Хотя изначально это не входило в планы, мы ___ в итоге всё-таки пришли к компромиссу."
  },
  {
   "id": "l4-002",
   "level": 4,
   "text": "De directie ___ na maandenlang overleg besloten om de reorganisatie uit te stellen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "besloten om de reorganisatie uit te stellen",
   "rule": "transitief",
   "translationRu": "Правление ___ после долгих месяцев переговоров решило отложить реорганизацию."
  },
  {
   "id": "l4-003",
   "level": 4,
   "text": "Nadat hij zijn baan had opgezegd, ___ hij tijdelijk bij een vriend gaan wonen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gaan wonen",
   "rule": "groeps-inf",
   "translationRu": "После того как он уволился с работы, он ___ временно переехал жить к другу."
  },
  {
   "id": "l4-004",
   "level": 4,
   "text": "De onderzoekers ___ tijdens het onderzoek op onverwachte problemen gestuit.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gestuit",
   "rule": "passief",
   "translationRu": "Исследователи ___ в ходе исследования столкнулись с неожиданными проблемами."
  },
  {
   "id": "l4-005",
   "level": 4,
   "text": "Ondanks de slechte weersomstandigheden ___ de deelnemers aan de marathon allemaal op tijd aangekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "aangekomen",
   "rule": "vaste-zijn",
   "translationRu": "Несмотря на плохие погодные условия, все участники марафона ___ прибыли вовремя."
  },
  {
   "id": "l4-006",
   "level": 4,
   "text": "De regering ___ de afgelopen maanden verschillende maatregelen aangekondigd om de inflatie te beperken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangekondigd",
   "rule": "transitief",
   "translationRu": "Правительство ___ за последние месяцы объявило о ряде мер по сдерживанию инфляции."
  },
  {
   "id": "l4-007",
   "level": 4,
   "text": "Nadat de onderhandelingen waren mislukt, ___ beide partijen opnieuw met elkaar in gesprek gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "in gesprek gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как переговоры сорвались, обе стороны ___ вновь вступили в диалог друг с другом."
  },
  {
   "id": "l4-008",
   "level": 4,
   "text": "Ik ___ gisteren urenlang geprobeerd om contact met de klantenservice te krijgen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера целыми часами пытался связаться со службой поддержки клиентов."
  },
  {
   "id": "l4-009",
   "level": 4,
   "text": "De studenten ___ na afloop van de lezing nog uitgebreid met de professor gediscussieerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gediscussieerd",
   "rule": "transitief",
   "translationRu": "Студенты ___ после лекции ещё долго обсуждали с профессором."
  },
  {
   "id": "l4-010",
   "level": 4,
   "text": "Zij ___ uiteindelijk tot de conclusie gekomen dat het oorspronkelijke plan niet haalbaar was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в итоге пришла к выводу, что первоначальный план нереализуем."
  },
  {
   "id": "l4-011",
   "level": 4,
   "text": "Het bedrijf ___ de afgelopen jaren aanzienlijk gegroeid, ondanks de economische onzekerheid.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gegroeid",
   "rule": "verandering",
   "translationRu": "Компания ___ за последние годы значительно выросла, несмотря на экономическую неопределённость."
  },
  {
   "id": "l4-012",
   "level": 4,
   "text": "Wij ___ gedurende het hele project regelmatig met onverwachte vertragingen geconfronteerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geconfronteerd",
   "rule": "passief",
   "translationRu": "Мы ___ на протяжении всего проекта регулярно сталкивались с непредвиденными задержками."
  },
  {
   "id": "l4-013",
   "level": 4,
   "text": "Nadat hij zijn studie had afgerond, ___ hij eerst een jaar in het buitenland gaan werken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gaan werken",
   "rule": "groeps-inf",
   "translationRu": "После того как он закончил учёбу, он ___ сначала на год уехал работать за границу."
  },
  {
   "id": "l4-014",
   "level": 4,
   "text": "De vergadering ___ veel langer geduurd dan oorspronkelijk was gepland.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geduurd",
   "rule": "transitief",
   "translationRu": "Заседание ___ длилось гораздо дольше, чем было изначально запланировано."
  },
  {
   "id": "l4-015",
   "level": 4,
   "text": "Zij ___ na lang nadenken van mening veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ после долгих раздумий изменила своё мнение."
  },
  {
   "id": "l4-016",
   "level": 4,
   "text": "De commissie ___ verschillende alternatieven onderzocht voordat zij een beslissing heeft genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Комиссия ___ рассмотрела несколько альтернатив, прежде чем приняла решение."
  },
  {
   "id": "l4-017",
   "level": 4,
   "text": "Toen de situatie verslechterde, ___ steeds meer werknemers naar een andere baan gaan zoeken.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gaan zoeken",
   "rule": "groeps-inf",
   "translationRu": "Когда ситуация ухудшилась, всё больше сотрудников ___ стали искать другую работу."
  },
  {
   "id": "l4-018",
   "level": 4,
   "text": "Ik ___ me de afgelopen weken intensief met dit onderwerp beziggehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "beziggehouden",
   "rule": "reflexief",
   "translationRu": "Я ___ в последние недели усиленно занимался этой темой."
  },
  {
   "id": "l4-019",
   "level": 4,
   "text": "De onderzoekers ___ tot nu toe onvoldoende bewijs gevonden om deze theorie te ondersteunen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Исследователи ___ до сих пор не нашли достаточных доказательств в поддержку этой теории."
  },
  {
   "id": "l4-020",
   "level": 4,
   "text": "Nadat het contract was afgelopen, ___ het bedrijf op zoek gegaan naar een nieuwe leverancier.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "op zoek gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как контракт истёк, компания ___ занялась поисками нового поставщика."
  },
  {
   "id": "l4-021",
   "level": 4,
   "text": "Hij ___ zich tijdens het gesprek opvallend rustig gehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehouden",
   "rule": "reflexief",
   "translationRu": "Он ___ во время разговора на удивление вёл себя спокойно."
  },
  {
   "id": "l4-022",
   "level": 4,
   "text": "Wij ___ de kwestie meerdere keren besproken, maar nog steeds geen oplossing gevonden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ несколько раз обсудили этот вопрос, но решения так и не нашли."
  },
  {
   "id": "l4-023",
   "level": 4,
   "text": "De organisatie ___ de afgelopen tien jaar sterk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Организация ___ за последние десять лет сильно изменилась."
  },
  {
   "id": "l4-024",
   "level": 4,
   "text": "Nadat de resultaten bekend waren geworden, ___ er binnen het team veel discussie ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "После того как результаты стали известны, в команде ___ разгорелись жаркие споры."
  },
  {
   "id": "l4-025",
   "level": 4,
   "text": "Zij ___ jarenlang in dezelfde stad gewoond voordat ze naar het buitenland verhuisde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewoond",
   "rule": "transitief",
   "translationRu": "Она ___ долгие годы жила в одном и том же городе, прежде чем переехала за границу."
  },
  {
   "id": "l4-026",
   "level": 4,
   "text": "De medewerkers ___ zich vanaf het begin tegen het nieuwe systeem verzet.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzet",
   "rule": "reflexief",
   "translationRu": "Сотрудники ___ с самого начала сопротивлялись новой системе."
  },
  {
   "id": "l4-027",
   "level": 4,
   "text": "Hoewel hij aanvankelijk twijfelde, ___ hij uiteindelijk akkoord gegaan met het voorstel.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "akkoord gegaan",
   "rule": "vaste-zijn",
   "translationRu": "Хотя он поначалу сомневался, он ___ в итоге согласился с предложением."
  },
  {
   "id": "l4-028",
   "level": 4,
   "text": "De voorzitter ___ tijdens de bijeenkomst verschillende belangrijke punten naar voren gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "naar voren gebracht",
   "rule": "transitief",
   "translationRu": "Председатель ___ в ходе собрания выдвинул несколько важных пунктов."
  },
  {
   "id": "l4-029",
   "level": 4,
   "text": "Wij ___ gedurende het hele proces nauw met de betrokken partijen samengewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "samengewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ в течение всего процесса тесно сотрудничали с заинтересованными сторонами."
  },
  {
   "id": "l4-030",
   "level": 4,
   "text": "Nadat de financiering was geregeld, ___ het project eindelijk van start gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "van start gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как финансирование было обеспечено, проект ___ наконец стартовал."
  },
  {
   "id": "l4-031",
   "level": 4,
   "text": "De journalist ___ maandenlang onderzoek gedaan naar de achtergrond van het bedrijf.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "onderzoek gedaan",
   "rule": "transitief",
   "translationRu": "Журналист ___ на протяжении многих месяцев расследовал подноготную этой компании."
  },
  {
   "id": "l4-032",
   "level": 4,
   "text": "De onderhandelaars ___ na een lange discussie tot een voorlopig akkoord gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Переговорщики ___ после долгого обсуждения пришли к предварительному соглашению."
  },
  {
   "id": "l4-033",
   "level": 4,
   "text": "Het aantal deelnemers ___ sinds vorig jaar aanzienlijk toegenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "toegenomen",
   "rule": "verandering",
   "translationRu": "Число участников ___ с прошлого года значительно выросло."
  },
  {
   "id": "l4-034",
   "level": 4,
   "text": "De manager ___ de beslissing genomen zonder eerst zijn medewerkers te raadplegen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Менеджер ___ принял решение, не посоветовавшись сначала со своими сотрудниками."
  },
  {
   "id": "l4-035",
   "level": 4,
   "text": "Ik ___ de afgelopen tijd veel geleerd van mijn fouten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Я ___ в последнее время многому научился на собственных ошибках."
  },
  {
   "id": "l4-036",
   "level": 4,
   "text": "Nadat de situatie was geëscaleerd, ___ de politie ter plaatse gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "После того как ситуация обострилась, полиция ___ прибыла на место."
  },
  {
   "id": "l4-037",
   "level": 4,
   "text": "De organisatie ___ verschillende klachten ontvangen over de nieuwe procedure.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontvangen",
   "rule": "transitief",
   "translationRu": "Организация ___ получила ряд жалоб на новую процедуру."
  },
  {
   "id": "l4-038",
   "level": 4,
   "text": "Zij ___ gedurende haar carrière meerdere keren van functie veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ за время своей карьеры несколько раз меняла должности."
  },
  {
   "id": "l4-039",
   "level": 4,
   "text": "Wij ___ lang over de mogelijke gevolgen van de beslissing nagedacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "nagedacht",
   "rule": "transitief",
   "translationRu": "Мы ___ долго думали о возможных последствиях этого решения."
  },
  {
   "id": "l4-040",
   "level": 4,
   "text": "De minister ___ tijdens de persconferentie uitgebreid op de kwestie ingegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ingegaan",
   "rule": "vaste-zijn",
   "translationRu": "Министр ___ в ходе пресс-конференции подробно остановился на этом вопросе."
  },
  {
   "id": "l4-041",
   "level": 4,
   "text": "De markt ___ de afgelopen maanden sterk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Рынок ___ за последние месяцы сильно изменился."
  },
  {
   "id": "l4-042",
   "level": 4,
   "text": "De medewerkers ___ zich uiteindelijk bij de nieuwe situatie neergelegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "neergelegd",
   "rule": "reflexief",
   "translationRu": "Сотрудники ___ в итоге смирились с новой ситуацией."
  },
  {
   "id": "l4-043",
   "level": 4,
   "text": "Nadat de vergadering was afgelopen, ___ de deelnemers nog lang blijven napraten.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "blijven napraten",
   "rule": "groeps-inf",
   "translationRu": "После того как заседание закончилось, участники ___ ещё долго оставались и обсуждали услышанное."
  },
  {
   "id": "l4-044",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de moeilijke omstandigheden winst gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "winst gemaakt",
   "rule": "transitief",
   "translationRu": "Компания ___ несмотря на сложные обстоятельства получила прибыль."
  },
  {
   "id": "l4-045",
   "level": 4,
   "text": "Hij ___ na jaren van twijfel eindelijk voor zichzelf gekozen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekozen",
   "rule": "transitief",
   "translationRu": "Он ___ после долгих лет сомнений наконец выбрал себя."
  },
  {
   "id": "l4-046",
   "level": 4,
   "text": "De onderzoekers ___ verschillende verklaringen voor het verschijnsel onderzocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Исследователи ___ рассмотрели несколько объяснений этого явления."
  },
  {
   "id": "l4-047",
   "level": 4,
   "text": "De situatie ___ in korte tijd volledig uit de hand gelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "uit de hand gelopen",
   "rule": "verandering",
   "translationRu": "Ситуация ___ за короткое время полностью вышла из-под контроля."
  },
  {
   "id": "l4-048",
   "level": 4,
   "text": "Wij ___ vooraf duidelijke afspraken gemaakt over de verdeling van de taken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ заранее чётко договорились о распределении задач."
  },
  {
   "id": "l4-049",
   "level": 4,
   "text": "Zij ___ na de kritiek onmiddellijk in actie gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после критики немедленно начала действовать."
  },
  {
   "id": "l4-050",
   "level": 4,
   "text": "De organisatie ___ het beleid meerdere keren aangepast.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Организация ___ политику несколько раз пересматривала."
  },
  {
   "id": "l4-051",
   "level": 4,
   "text": "Nadat hij zijn excuses had aangeboden, ___ de spanning langzaam verdwenen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verdwenen",
   "rule": "verandering",
   "translationRu": "После того как он извинился, напряжение ___ постепенно спало."
  },
  {
   "id": "l4-052",
   "level": 4,
   "text": "Ik ___ de afgelopen maanden verschillende boeken over dit onderwerp gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelezen",
   "rule": "transitief",
   "translationRu": "Я ___ за последние месяцы прочитал несколько книг на эту тему."
  },
  {
   "id": "l4-053",
   "level": 4,
   "text": "De werknemers ___ na lang overleg met het voorstel ingestemd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "ingestemd",
   "rule": "transitief",
   "translationRu": "Работники ___ после долгого обсуждения согласились с предложением."
  },
  {
   "id": "l4-054",
   "level": 4,
   "text": "De overheid ___ de gevolgen van de maatregel duidelijk onderschat.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "onderschat",
   "rule": "transitief",
   "translationRu": "Правительство ___ явно недооценило последствия этой меры."
  },
  {
   "id": "l4-055",
   "level": 4,
   "text": "De discussie ___ uiteindelijk veel emotioneler geworden dan verwacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Дискуссия ___ в итоге оказалась намного эмоциональнее, чем ожидалось."
  },
  {
   "id": "l4-056",
   "level": 4,
   "text": "Wij ___ verschillende deskundigen geraadpleegd voordat we een beslissing namen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geraadpleegd",
   "rule": "transitief",
   "translationRu": "Мы ___ проконсультировались с несколькими экспертами, прежде чем приняли решение."
  },
  {
   "id": "l4-057",
   "level": 4,
   "text": "Nadat de eerste resultaten waren gepubliceerd, ___ er veel kritiek ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "После публикации первых результатов ___ появилось много критики."
  },
  {
   "id": "l4-058",
   "level": 4,
   "text": "Zij ___ gedurende haar studie verschillende internationale contacten opgebouwd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgebouwd",
   "rule": "transitief",
   "translationRu": "Она ___ за время учёбы завела множество международных контактов."
  },
  {
   "id": "l4-059",
   "level": 4,
   "text": "Het project ___ door financiële problemen ernstig vertraagd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "vertraagd",
   "rule": "verandering",
   "translationRu": "Проект ___ из-за финансовых проблем серьёзно задержался."
  },
  {
   "id": "l4-060",
   "level": 4,
   "text": "De directeur ___ zijn medewerkers persoonlijk op de hoogte gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "op de hoogte gebracht",
   "rule": "transitief",
   "translationRu": "Директор ___ лично проинформировал своих сотрудников."
  },
  {
   "id": "l4-061",
   "level": 4,
   "text": "Ik ___ nog nooit zo'n ingewikkelde situatie meegemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "meegemaakt",
   "rule": "transitief",
   "translationRu": "Я ___ никогда раньше не оказывался в такой запутанной ситуации."
  },
  {
   "id": "l4-062",
   "level": 4,
   "text": "Nadat het nieuws bekend was geworden, ___ de aandelenkoers snel gedaald.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gedaald",
   "rule": "verandering",
   "translationRu": "После того как новость стала известна, курс акций ___ быстро упал."
  },
  {
   "id": "l4-063",
   "level": 4,
   "text": "De onderzoekers ___ hun conclusies zorgvuldig onderbouwd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "onderbouwd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ тщательно обосновали свои выводы."
  },
  {
   "id": "l4-064",
   "level": 4,
   "text": "Wij ___ uiteindelijk een andere strategie gekozen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekozen",
   "rule": "transitief",
   "translationRu": "Мы ___ в итоге выбрали другую стратегию."
  },
  {
   "id": "l4-065",
   "level": 4,
   "text": "Zij ___ zich jarenlang voor deze organisatie ingezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ingezet",
   "rule": "reflexief",
   "translationRu": "Она ___ долгие годы работала на эту организацию."
  },
  {
   "id": "l4-066",
   "level": 4,
   "text": "De deelnemers ___ na afloop van het programma naar huis teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Участники ___ после окончания программы вернулись домой."
  },
  {
   "id": "l4-067",
   "level": 4,
   "text": "Het bedrijf ___ zijn activiteiten naar verschillende Europese landen uitgebreid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "uitgebreid",
   "rule": "transitief",
   "translationRu": "Компания ___ свою деятельность распространила на несколько европейских стран."
  },
  {
   "id": "l4-068",
   "level": 4,
   "text": "Nadat hij was afgestudeerd, ___ hij naar een andere stad verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "После того как он окончил университет, он ___ переехал в другой город."
  },
  {
   "id": "l4-069",
   "level": 4,
   "text": "De commissie ___ de kwestie grondig onderzocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Комиссия ___ тщательно расследовала это дело."
  },
  {
   "id": "l4-070",
   "level": 4,
   "text": "De omstandigheden ___ de afgelopen jaren aanzienlijk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Обстоятельства ___ за последние годы существенно изменились."
  },
  {
   "id": "l4-071",
   "level": 4,
   "text": "Wij ___ ondanks alle kritiek achter het oorspronkelijke plan blijven staan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "blijven staan",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ несмотря на всю критику продолжали стоять за первоначальным планом."
  },
  {
   "id": "l4-072",
   "level": 4,
   "text": "Zij ___ verschillende voorstellen ingediend voordat het definitieve besluit werd genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ingediend",
   "rule": "transitief",
   "translationRu": "Она ___ внесла несколько предложений, прежде чем было принято окончательное решение."
  },
  {
   "id": "l4-073",
   "level": 4,
   "text": "De onderhandelingen ___ onverwacht snel verlopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verlopen",
   "rule": "verandering",
   "translationRu": "Переговоры ___ неожиданно быстро продвинулись."
  },
  {
   "id": "l4-074",
   "level": 4,
   "text": "Hij ___ zich tijdens de vergadering bewust op de achtergrond gehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehouden",
   "rule": "reflexief",
   "translationRu": "Он ___ на заседании сознательно держался в тени."
  },
  {
   "id": "l4-075",
   "level": 4,
   "text": "De organisatie ___ haar doelstellingen de afgelopen periode niet volledig bereikt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "bereikt",
   "rule": "transitief",
   "translationRu": "Организация ___ своих целей за последний период полностью не достигла."
  },
  {
   "id": "l4-076",
   "level": 4,
   "text": "Nadat de situatie was verbeterd, ___ de meeste medewerkers weer aan het werk gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "aan het werk gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как ситуация улучшилась, большинство сотрудников ___ снова приступили к работе."
  },
  {
   "id": "l4-077",
   "level": 4,
   "text": "Ik ___ lange tijd geprobeerd om de oorzaak van het probleem te achterhalen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Я ___ долго пытался установить причину проблемы."
  },
  {
   "id": "l4-078",
   "level": 4,
   "text": "Het aantal klachten ___ sinds de invoering van het nieuwe systeem afgenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "afgenomen",
   "rule": "verandering",
   "translationRu": "Число жалоб ___ с момента введения новой системы снизилось."
  },
  {
   "id": "l4-079",
   "level": 4,
   "text": "De onderzoekers ___ nieuwe gegevens verzameld die hun eerdere conclusies tegenspraken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzameld",
   "rule": "transitief",
   "translationRu": "Исследователи ___ собрали новые данные, которые противоречили их прежним выводам."
  },
  {
   "id": "l4-080",
   "level": 4,
   "text": "Zij ___ uiteindelijk besloten om de samenwerking voort te zetten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Она ___ в итоге решила продолжить сотрудничество."
  },
  {
   "id": "l4-081",
   "level": 4,
   "text": "De discussie ___ verschillende keren opnieuw begonnen nadat nieuwe informatie beschikbaar was gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Дискуссия ___ несколько раз возобновлялась после появления новой информации."
  },
  {
   "id": "l4-082",
   "level": 4,
   "text": "Wij ___ de mogelijke risico's vooraf uitgebreid besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ возможные риски заранее подробно обсудили."
  },
  {
   "id": "l4-083",
   "level": 4,
   "text": "De regering ___ onder grote druk gestaan om snel te handelen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gestaan",
   "rule": "transitief",
   "translationRu": "Правительство ___ находилось под большим давлением, вынуждавшим действовать быстро."
  },
  {
   "id": "l4-084",
   "level": 4,
   "text": "Nadat de crisis was uitgebroken, ___ verschillende bedrijven failliet gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "failliet gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как разразился кризис, несколько компаний ___ обанкротились."
  },
  {
   "id": "l4-085",
   "level": 4,
   "text": "De manager ___ de verantwoordelijkheid voor de gemaakte fouten genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Менеджер ___ взял на себя ответственность за допущенные ошибки."
  },
  {
   "id": "l4-086",
   "level": 4,
   "text": "Ik ___ me nooit eerder zo sterk voor een maatschappelijk onderwerp ingezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ingezet",
   "rule": "reflexief",
   "translationRu": "Я ___ никогда раньше так активно не выступал за какую-либо общественную тему."
  },
  {
   "id": "l4-087",
   "level": 4,
   "text": "De deelnemers ___ tijdens de conferentie veel nieuwe inzichten opgedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "opgedaan",
   "rule": "transitief",
   "translationRu": "Участники ___ во время конференции получили много новых знаний."
  },
  {
   "id": "l4-088",
   "level": 4,
   "text": "Het voorstel ___ na de stemming met een ruime meerderheid aangenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangenomen",
   "rule": "transitief",
   "translationRu": "Предложение ___ после голосования было принято значительным большинством."
  },
  {
   "id": "l4-089",
   "level": 4,
   "text": "Zij ___ gedurende meerdere jaren in het buitenland gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Она ___ на протяжении многих лет работала за границей."
  },
  {
   "id": "l4-090",
   "level": 4,
   "text": "Wij ___ uiteindelijk een oplossing gevonden waar iedereen zich in kon vinden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ в итоге нашли решение, которое устраивало всех."
  },
  {
   "id": "l4-091",
   "level": 4,
   "text": "Nadat hij was teruggekeerd, ___ hij zijn ervaringen uitgebreid beschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "beschreven",
   "rule": "transitief",
   "translationRu": "После того как он вернулся, он ___ подробно описал свой опыт."
  },
  {
   "id": "l4-092",
   "level": 4,
   "text": "De economie ___ zich sneller hersteld dan veel deskundigen hadden verwacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "hersteld",
   "rule": "reflexief",
   "translationRu": "Экономика ___ восстановилась быстрее, чем ожидали многие эксперты."
  },
  {
   "id": "l4-093",
   "level": 4,
   "text": "De organisatie ___ de afgelopen maanden veel kritiek gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Организация ___ за последние месяцы получила много критики."
  },
  {
   "id": "l4-094",
   "level": 4,
   "text": "Zij ___ na het incident niet meer naar haar oorspronkelijke functie teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Она ___ после инцидента больше не вернулась на прежнюю должность."
  },
  {
   "id": "l4-095",
   "level": 4,
   "text": "De onderzoekers ___ gedurende lange tijd gegevens verzameld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzameld",
   "rule": "transitief",
   "translationRu": "Исследователи ___ в течение долгого времени собирали данные."
  },
  {
   "id": "l4-096",
   "level": 4,
   "text": "Het probleem ___ veel ingewikkelder gebleken dan aanvankelijk werd gedacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gebleken",
   "rule": "zijn-blijven",
   "translationRu": "Проблема ___ оказалась гораздо сложнее, чем думали поначалу."
  },
  {
   "id": "l4-097",
   "level": 4,
   "text": "Wij ___ ons zorgvuldig op de onderhandelingen voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "voorbereid",
   "rule": "reflexief",
   "translationRu": "Мы ___ тщательно подготовились к переговорам."
  },
  {
   "id": "l4-098",
   "level": 4,
   "text": "Nadat de eerste poging was mislukt, ___ zij opnieuw begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "После того как первая попытка не удалась, они ___ начали заново."
  },
  {
   "id": "l4-099",
   "level": 4,
   "text": "De directeur ___ tijdens de bijeenkomst verschillende bezwaren erkend.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "erkend",
   "rule": "transitief",
   "translationRu": "Директор ___ в ходе собрания признал ряд возражений."
  },
  {
   "id": "l4-100",
   "level": 4,
   "text": "De situatie ___ uiteindelijk minder ernstig geworden dan aanvankelijk werd gevreesd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Ситуация ___ в итоге оказалась менее серьёзной, чем опасались поначалу."
  },
  {
   "id": "l4-101",
   "level": 4,
   "text": "Ik ___ gisteren pas laat tot het inzicht gekomen dat ik de situatie verkeerd had ingeschat.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ вчера только поздно осознал, что неверно оценил ситуацию."
  },
  {
   "id": "l4-102",
   "level": 4,
   "text": "De organisatie ___ de afgelopen jaren veel ervaring opgedaan met internationale projecten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "opgedaan",
   "rule": "transitief",
   "translationRu": "Организация ___ за последние годы накопила большой опыт международных проектов."
  },
  {
   "id": "l4-103",
   "level": 4,
   "text": "Nadat de samenwerking was beëindigd, ___ beide organisaties onafhankelijk verdergegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verdergegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как сотрудничество было прекращено, обе организации ___ продолжили работать самостоятельно."
  },
  {
   "id": "l4-104",
   "level": 4,
   "text": "De wetenschappers ___ verschillende mogelijke oorzaken onderzocht voordat ze een conclusie trokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Учёные ___ исследовали несколько возможных причин, прежде чем сделали вывод."
  },
  {
   "id": "l4-105",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de stijgende kosten blijven investeren in innovatie.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "blijven investeren",
   "rule": "groeps-inf",
   "translationRu": "Компания ___ несмотря на рост расходов продолжала инвестировать в инновации."
  },
  {
   "id": "l4-106",
   "level": 4,
   "text": "Zij ___ zich tijdens het debat zorgvuldig van persoonlijke aanvallen onthouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "onthouden",
   "rule": "reflexief",
   "translationRu": "Она ___ в ходе дебатов тщательно воздерживалась от личных выпадов."
  },
  {
   "id": "l4-107",
   "level": 4,
   "text": "De onderhandelingen ___ na maanden van onzekerheid eindelijk hervat.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "hervat",
   "rule": "passief",
   "translationRu": "Переговоры ___ после месяцев неопределённости наконец возобновились."
  },
  {
   "id": "l4-108",
   "level": 4,
   "text": "Wij ___ vooraf niet voldoende rekening gehouden met de mogelijke gevolgen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "rekening gehouden met",
   "rule": "transitief",
   "translationRu": "Мы ___ заранее недостаточно учли возможные последствия."
  },
  {
   "id": "l4-109",
   "level": 4,
   "text": "De voorzitter ___ de deelnemers verzocht hun opmerkingen schriftelijk in te dienen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verzocht",
   "rule": "transitief",
   "translationRu": "Председатель ___ попросил участников подать свои замечания в письменной форме."
  },
  {
   "id": "l4-110",
   "level": 4,
   "text": "De situatie ___ sinds de laatste vergadering aanzienlijk verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ с последнего заседания значительно улучшилась."
  },
  {
   "id": "l4-111",
   "level": 4,
   "text": "De werknemers ___ zich uiteindelijk bij het besluit neergelegd, hoewel ze het er niet mee eens waren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "neergelegd",
   "rule": "reflexief",
   "translationRu": "Сотрудники ___ в итоге смирились с решением, хотя были с ним не согласны."
  },
  {
   "id": "l4-112",
   "level": 4,
   "text": "De overheid ___ nieuwe regels ingevoerd om misbruik van het systeem tegen te gaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ingevoerd",
   "rule": "transitief",
   "translationRu": "Правительство ___ ввело новые правила для борьбы со злоупотреблениями системой."
  },
  {
   "id": "l4-113",
   "level": 4,
   "text": "Nadat het oorspronkelijke plan was afgewezen, ___ de projectgroep met een alternatief gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "После того как первоначальный план был отклонён, проектная группа ___ пришла с альтернативой."
  },
  {
   "id": "l4-114",
   "level": 4,
   "text": "Ik ___ de afgelopen weken voortdurend met dezelfde vraag bezig geweest.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bezig geweest",
   "rule": "zijn-blijven",
   "translationRu": "Я ___ последние недели постоянно был занят одним и тем же вопросом."
  },
  {
   "id": "l4-115",
   "level": 4,
   "text": "Het onderzoek ___ belangrijke nieuwe inzichten opgeleverd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "opgeleverd",
   "rule": "transitief",
   "translationRu": "Исследование ___ дало важные новые выводы."
  },
  {
   "id": "l4-116",
   "level": 4,
   "text": "De deelnemers ___ na afloop van de conferentie naar verschillende steden doorgereisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "doorgereisd",
   "rule": "default-hebben",
   "translationRu": "Участники ___ после конференции разъехались по разным городам."
  },
  {
   "id": "l4-117",
   "level": 4,
   "text": "De directeur ___ zijn standpunt tijdens de vergadering duidelijk toegelicht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "toegelicht",
   "rule": "transitief",
   "translationRu": "Директор ___ свою позицию на заседании чётко изложил."
  },
  {
   "id": "l4-118",
   "level": 4,
   "text": "De situatie ___ in korte tijd aanzienlijk verslechterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verslechterd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ за короткое время значительно ухудшилась."
  },
  {
   "id": "l4-119",
   "level": 4,
   "text": "Wij ___ meerdere keren geprobeerd om de betrokken partijen bij elkaar te brengen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Мы ___ несколько раз пытались собрать заинтересованные стороны вместе."
  },
  {
   "id": "l4-120",
   "level": 4,
   "text": "Zij ___ na het incident tijdelijk uit de publiciteit verdwenen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verdwenen",
   "rule": "verandering",
   "translationRu": "Она ___ после инцидента на время исчезла из поля зрения публики."
  },
  {
   "id": "l4-121",
   "level": 4,
   "text": "De commissie ___ een groot aantal documenten geanalyseerd voordat zij haar advies uitbracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geanalyseerd",
   "rule": "transitief",
   "translationRu": "Комиссия ___ проанализировала большое количество документов, прежде чем вынесла своё заключение."
  },
  {
   "id": "l4-122",
   "level": 4,
   "text": "Het bedrijf ___ in enkele jaren uitgegroeid tot een belangrijke speler op de Europese markt.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "uitgegroeid tot",
   "rule": "verandering",
   "translationRu": "Компания ___ за несколько лет выросла в важного игрока на европейском рынке."
  },
  {
   "id": "l4-123",
   "level": 4,
   "text": "Nadat de laatste spreker was vertrokken, ___ de zaal vrijwel onmiddellijk leeggelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "leeggelopen",
   "rule": "verandering",
   "translationRu": "После того как последний докладчик ушёл, зал ___ почти сразу опустел."
  },
  {
   "id": "l4-124",
   "level": 4,
   "text": "Ik ___ mijn mening over de kwestie inmiddels meerdere keren aangepast.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Я ___ своё мнение по этому вопросу за это время уже несколько раз менял."
  },
  {
   "id": "l4-125",
   "level": 4,
   "text": "De onderzoekers ___ tijdens hun veldwerk met verschillende praktische problemen te maken gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "te maken gehad",
   "rule": "transitief",
   "translationRu": "Исследователи ___ во время полевых работ столкнулись с рядом практических трудностей."
  },
  {
   "id": "l4-126",
   "level": 4,
   "text": "Zij ___ uiteindelijk tot een andere aanpak overgegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "overgegaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в итоге перешла к другому подходу."
  },
  {
   "id": "l4-127",
   "level": 4,
   "text": "De regering ___ de afgelopen periode onvoldoende geluisterd naar de kritiek uit de samenleving.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geluisterd naar",
   "rule": "default-hebben",
   "translationRu": "Правительство ___ в последний период недостаточно прислушивалось к критике общества."
  },
  {
   "id": "l4-128",
   "level": 4,
   "text": "Nadat de financiële situatie was verbeterd, ___ het vertrouwen bij investeerders teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "После того как финансовое положение улучшилось, доверие инвесторов ___ вернулось."
  },
  {
   "id": "l4-129",
   "level": 4,
   "text": "Wij ___ de resultaten zorgvuldig met eerdere onderzoeken vergeleken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vergeleken",
   "rule": "transitief",
   "translationRu": "Мы ___ результаты тщательно сравнили с данными прежних исследований."
  },
  {
   "id": "l4-130",
   "level": 4,
   "text": "Hij ___ na zijn ontslag langere tijd zonder werk gezeten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gezeten",
   "rule": "transitief",
   "translationRu": "Он ___ после увольнения долгое время сидел без работы."
  },
  {
   "id": "l4-131",
   "level": 4,
   "text": "De organisatie ___ zich de afgelopen jaren sterk geprofessionaliseerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geprofessionaliseerd",
   "rule": "reflexief",
   "translationRu": "Организация ___ за последние годы сильно профессионализировалась."
  },
  {
   "id": "l4-132",
   "level": 4,
   "text": "De deskundigen ___ verschillende mogelijke scenario's uitgewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "uitgewerkt",
   "rule": "transitief",
   "translationRu": "Эксперты ___ проработали несколько возможных сценариев."
  },
  {
   "id": "l4-133",
   "level": 4,
   "text": "Nadat de discussie was afgelopen, ___ de meeste deelnemers nog even in de zaal gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "После того как дискуссия закончилась, большинство участников ___ ещё ненадолго остались в зале."
  },
  {
   "id": "l4-134",
   "level": 4,
   "text": "Ik ___ tijdens mijn opleiding veel geleerd over interculturele communicatie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd over",
   "rule": "transitief",
   "translationRu": "Я ___ во время учёбы много узнал о межкультурной коммуникации."
  },
  {
   "id": "l4-135",
   "level": 4,
   "text": "De economische situatie ___ de afgelopen maanden minder stabiel geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Экономическая ситуация ___ за последние месяцы стала менее стабильной."
  },
  {
   "id": "l4-136",
   "level": 4,
   "text": "Zij ___ haar beslissing uitgebreid met haar familie besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Она ___ своё решение подробно обсудила с семьёй."
  },
  {
   "id": "l4-137",
   "level": 4,
   "text": "Het bestuur ___ uiteindelijk unaniem voor het voorstel gekozen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gekozen voor",
   "rule": "transitief",
   "translationRu": "Правление ___ в итоге единогласно высказалось за предложение."
  },
  {
   "id": "l4-138",
   "level": 4,
   "text": "Wij ___ de afgelopen weken verschillende keren met de gemeente overlegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "overlegd",
   "rule": "default-hebben",
   "translationRu": "Мы ___ за последние недели несколько раз советовались с муниципалитетом."
  },
  {
   "id": "l4-139",
   "level": 4,
   "text": "Nadat hij was verhuisd, ___ hij nauwelijks nog contact met zijn oude buren gehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gehouden",
   "rule": "default-hebben",
   "translationRu": "После того как он переехал, он ___ почти не поддерживал контактов со старыми соседями."
  },
  {
   "id": "l4-140",
   "level": 4,
   "text": "De onderzoekers ___ tot verrassende resultaten gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Исследователи ___ пришли к неожиданным результатам."
  },
  {
   "id": "l4-141",
   "level": 4,
   "text": "De overheid ___ verschillende maatregelen genomen om de gevolgen van de crisis te beperken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Правительство ___ приняло ряд мер для ограничения последствий кризиса."
  },
  {
   "id": "l4-142",
   "level": 4,
   "text": "De situatie ___ ondanks alle inspanningen niet wezenlijk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ несмотря на все усилия существенно не изменилась."
  },
  {
   "id": "l4-143",
   "level": 4,
   "text": "Ik ___ me de afgelopen maanden verdiept in de achtergrond van het probleem.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verdiept in",
   "rule": "reflexief",
   "translationRu": "Я ___ в последние месяцы углубился в изучение предыстории этой проблемы."
  },
  {
   "id": "l4-144",
   "level": 4,
   "text": "Zij ___ na het afronden van haar onderzoek naar Nederland teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Она ___ после завершения своего исследования вернулась в Нидерланды."
  },
  {
   "id": "l4-145",
   "level": 4,
   "text": "Het bedrijf ___ een groot deel van zijn productie naar het buitenland verplaatst.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "verplaatst",
   "rule": "transitief",
   "translationRu": "Компания ___ значительную часть производства перенесла за границу."
  },
  {
   "id": "l4-146",
   "level": 4,
   "text": "Wij ___ ons aanvankelijk vergist in de omvang van het probleem.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vergist in",
   "rule": "reflexief",
   "translationRu": "Мы ___ поначалу ошиблись в оценке масштабов проблемы."
  },
  {
   "id": "l4-147",
   "level": 4,
   "text": "Nadat de eerste resultaten waren binnengekomen, ___ de onderzoekers hun methode aangepast.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "После того как поступили первые результаты, исследователи ___ скорректировали свою методику."
  },
  {
   "id": "l4-148",
   "level": 4,
   "text": "Hij ___ gedurende zijn hele loopbaan voor dezelfde organisatie gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ в течение всей своей карьеры работал на одну и ту же организацию."
  },
  {
   "id": "l4-149",
   "level": 4,
   "text": "De spanning ___ tijdens het gesprek langzaam verdwenen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verdwenen",
   "rule": "verandering",
   "translationRu": "Напряжение ___ в ходе разговора постепенно спало."
  },
  {
   "id": "l4-150",
   "level": 4,
   "text": "De directie ___ verschillende alternatieven tegen elkaar afgewogen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "afgewogen",
   "rule": "transitief",
   "translationRu": "Правление ___ тщательно взвесило несколько альтернатив."
  },
  {
   "id": "l4-151",
   "level": 4,
   "text": "Zij ___ zich uiteindelijk teruggetrokken uit de onderhandelingen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "Она ___ в итоге вышла из переговоров."
  },
  {
   "id": "l4-152",
   "level": 4,
   "text": "Wij ___ de afgelopen jaren veel veranderingen meegemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "meegemaakt",
   "rule": "transitief",
   "translationRu": "Мы ___ за последние годы пережили много перемен."
  },
  {
   "id": "l4-153",
   "level": 4,
   "text": "De commissie ___ haar aanbevelingen gebaseerd op uitgebreid onderzoek.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gebaseerd op",
   "rule": "transitief",
   "translationRu": "Комиссия ___ свои рекомендации основывала на обширном исследовании."
  },
  {
   "id": "l4-154",
   "level": 4,
   "text": "Nadat het nieuws bekend was geworden, ___ veel mensen hun mening gaan herzien.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gaan herzien",
   "rule": "groeps-inf",
   "translationRu": "После того как новость стала известна, многие люди ___ стали пересматривать своё мнение."
  },
  {
   "id": "l4-155",
   "level": 4,
   "text": "Hij ___ tijdens het interview opvallend openhartig gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Он ___ во время интервью на удивление откровенно высказался."
  },
  {
   "id": "l4-156",
   "level": 4,
   "text": "De onderneming ___ haar positie op de internationale markt versterkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "versterkt",
   "rule": "transitief",
   "translationRu": "Предприятие ___ укрепило свои позиции на международном рынке."
  },
  {
   "id": "l4-157",
   "level": 4,
   "text": "Ik ___ nog nooit zo lang over een beslissing nagedacht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "nagedacht over",
   "rule": "transitief",
   "translationRu": "Я ___ никогда ещё так долго не раздумывал над каким-либо решением."
  },
  {
   "id": "l4-158",
   "level": 4,
   "text": "Zij ___ na het conflict tijdelijk naar het buitenland vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после конфликта на время уехала за границу."
  },
  {
   "id": "l4-159",
   "level": 4,
   "text": "De deelnemers ___ verschillende interessante vragen gesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gesteld",
   "rule": "transitief",
   "translationRu": "Участники ___ задали несколько интересных вопросов."
  },
  {
   "id": "l4-160",
   "level": 4,
   "text": "Wij ___ tijdens het project regelmatig van aanpak veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Мы ___ в ходе проекта регулярно меняли подход."
  },
  {
   "id": "l4-161",
   "level": 4,
   "text": "De omstandigheden ___ sinds de invoering van de nieuwe wet verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Обстоятельства ___ с момента введения нового закона улучшились."
  },
  {
   "id": "l4-162",
   "level": 4,
   "text": "De onderzoekers ___ onvoldoende aandacht besteed aan een belangrijk detail.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "besteed aan",
   "rule": "transitief",
   "translationRu": "Исследователи ___ уделили недостаточно внимания одной важной детали."
  },
  {
   "id": "l4-163",
   "level": 4,
   "text": "Nadat de overeenkomst was ondertekend, ___ beide partijen met de uitvoering begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "После того как соглашение было подписано, обе стороны ___ приступили к его исполнению."
  },
  {
   "id": "l4-164",
   "level": 4,
   "text": "Hij ___ zich altijd sterk gemaakt voor betere arbeidsvoorwaarden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "sterk gemaakt",
   "rule": "reflexief",
   "translationRu": "Он ___ всегда активно выступал за улучшение условий труда."
  },
  {
   "id": "l4-165",
   "level": 4,
   "text": "De regering ___ haar oorspronkelijke plannen uiteindelijk ingetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ingetrokken",
   "rule": "transitief",
   "translationRu": "Правительство ___ свои первоначальные планы в итоге отозвало."
  },
  {
   "id": "l4-166",
   "level": 4,
   "text": "Ik ___ de laatste tijd veel nagedacht over wat ik werkelijk wil.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "nagedacht over",
   "rule": "transitief",
   "translationRu": "Я ___ в последнее время много думал о том, чего действительно хочу."
  },
  {
   "id": "l4-167",
   "level": 4,
   "text": "De discussie ___ na enkele uren volledig vastgelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vastgelopen",
   "rule": "verandering",
   "translationRu": "Дискуссия ___ после нескольких часов полностью зашла в тупик."
  },
  {
   "id": "l4-168",
   "level": 4,
   "text": "Zij ___ verschillende argumenten aangevoerd om haar standpunt te verdedigen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangevoerd",
   "rule": "transitief",
   "translationRu": "Она ___ привела несколько аргументов в защиту своей позиции."
  },
  {
   "id": "l4-169",
   "level": 4,
   "text": "Wij ___ na de onverwachte gebeurtenis direct naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gegaan",
   "rule": "default-hebben",
   "translationRu": "Мы ___ после неожиданного происшествия сразу пошли домой."
  },
  {
   "id": "l4-170",
   "level": 4,
   "text": "Het bedrijf ___ in korte tijd veel nieuwe klanten aangetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangetrokken",
   "rule": "transitief",
   "translationRu": "Компания ___ за короткое время привлекла много новых клиентов."
  },
  {
   "id": "l4-171",
   "level": 4,
   "text": "De directeur ___ tijdens de vergadering zijn excuses aangeboden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangeboden",
   "rule": "transitief",
   "translationRu": "Директор ___ на заседании принёс свои извинения."
  },
  {
   "id": "l4-172",
   "level": 4,
   "text": "Nadat de situatie was geëscaleerd, ___ verschillende medewerkers opgestapt.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "opgestapt",
   "rule": "vaste-zijn",
   "translationRu": "После того как ситуация обострилась, несколько сотрудников ___ уволились."
  },
  {
   "id": "l4-173",
   "level": 4,
   "text": "Ik ___ mijn beslissing uiteindelijk niet betreurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "betrreurd",
   "rule": "transitief",
   "translationRu": "Я ___ о своём решении в итоге не пожалел."
  },
  {
   "id": "l4-174",
   "level": 4,
   "text": "Zij ___ gedurende haar verblijf in het buitenland veel zelfstandiger geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ за время пребывания за границей стала гораздо самостоятельнее."
  },
  {
   "id": "l4-175",
   "level": 4,
   "text": "De onderzoekers ___ hun gegevens meerdere keren gecontroleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gecontroleerd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ свои данные несколько раз проверили."
  },
  {
   "id": "l4-176",
   "level": 4,
   "text": "Wij ___ na afloop van het onderzoek een uitgebreid rapport opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "opgesteld",
   "rule": "transitief",
   "translationRu": "Мы ___ по окончании исследования составили обширный отчёт."
  },
  {
   "id": "l4-177",
   "level": 4,
   "text": "Het aantal deelnemers ___ sinds de start van het programma sterk gegroeid.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gegroeid",
   "rule": "verandering",
   "translationRu": "Число участников ___ с момента запуска программы сильно выросло."
  },
  {
   "id": "l4-178",
   "level": 4,
   "text": "Hij ___ zijn verantwoordelijkheid genomen, ondanks de kritiek.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Он ___ принял на себя ответственность, несмотря на критику."
  },
  {
   "id": "l4-179",
   "level": 4,
   "text": "De organisatie ___ zich in de afgelopen jaren steeds meer op duurzaamheid gericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gericht op",
   "rule": "reflexief",
   "translationRu": "Организация ___ в последние годы всё больше ориентировалась на устойчивое развитие."
  },
  {
   "id": "l4-180",
   "level": 4,
   "text": "Nadat de markt was ingestort, ___ verschillende kleine bedrijven verdwenen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verdwenen",
   "rule": "verandering",
   "translationRu": "После краха рынка ___ исчезло несколько мелких компаний."
  },
  {
   "id": "l4-181",
   "level": 4,
   "text": "Ik ___ de situatie aanvankelijk volledig verkeerd beoordeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "beoordeeld",
   "rule": "transitief",
   "translationRu": "Я ___ ситуацию поначалу оценил полностью неправильно."
  },
  {
   "id": "l4-182",
   "level": 4,
   "text": "Zij ___ na de presentatie veel positieve reacties gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ после презентации получила много положительных откликов."
  },
  {
   "id": "l4-183",
   "level": 4,
   "text": "Wij ___ verschillende deskundigen om advies gevraagd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Мы ___ попросили совета у нескольких экспертов."
  },
  {
   "id": "l4-184",
   "level": 4,
   "text": "Het probleem ___ groter geworden dan iemand had verwacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Проблема ___ оказалась больше, чем кто-либо ожидал."
  },
  {
   "id": "l4-185",
   "level": 4,
   "text": "Hij ___ na zijn pensionering naar een dorp in het noorden verhuisd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "verhuisd",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после выхода на пенсию переехал в деревню на севере."
  },
  {
   "id": "l4-186",
   "level": 4,
   "text": "De commissie ___ urenlang over het voorstel gediscussieerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gediscussieerd",
   "rule": "transitief",
   "translationRu": "Комиссия ___ часами обсуждала это предложение."
  },
  {
   "id": "l4-187",
   "level": 4,
   "text": "Nadat de vergadering was beëindigd, ___ de voorzitter onmiddellijk vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "После того как заседание завершилось, председатель ___ сразу же ушёл."
  },
  {
   "id": "l4-188",
   "level": 4,
   "text": "Ik ___ tijdens mijn verblijf in het buitenland veel nieuwe gewoonten ontwikkeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontwikkeld",
   "rule": "transitief",
   "translationRu": "Я ___ за время пребывания за границей приобрёл много новых привычек."
  },
  {
   "id": "l4-189",
   "level": 4,
   "text": "Zij ___ haar onderzoek uiteindelijk gepubliceerd in een internationaal tijdschrift.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gepubliceerd",
   "rule": "transitief",
   "translationRu": "Она ___ своё исследование в итоге опубликовала в международном журнале."
  },
  {
   "id": "l4-190",
   "level": 4,
   "text": "De organisatie ___ na de kritiek haar beleid aangepast.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Организация ___ после критики скорректировала свою политику."
  },
  {
   "id": "l4-191",
   "level": 4,
   "text": "Wij ___ ons gedurende het hele proces bewust geweest van de risico's.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bewust geweest van",
   "rule": "zijn-blijven",
   "translationRu": "Мы ___ в течение всего процесса осознавали риски."
  },
  {
   "id": "l4-192",
   "level": 4,
   "text": "De situatie ___ uiteindelijk volledig veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ в итоге полностью изменилась."
  },
  {
   "id": "l4-193",
   "level": 4,
   "text": "Hij ___ zich tijdens de onderhandelingen zeer professioneel opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgesteld",
   "rule": "reflexief",
   "translationRu": "Он ___ на переговорах вёл себя очень профессионально."
  },
  {
   "id": "l4-194",
   "level": 4,
   "text": "De overheid ___ de afgelopen jaren aanzienlijk meer geld geïnvesteerd in onderwijs.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geïnvesteerd in",
   "rule": "transitief",
   "translationRu": "Правительство ___ за последние годы вложило в образование значительно больше средств."
  },
  {
   "id": "l4-195",
   "level": 4,
   "text": "Nadat zij was afgestudeerd, ___ ze naar het buitenland vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "После того как она окончила университет, она ___ уехала за границу."
  },
  {
   "id": "l4-196",
   "level": 4,
   "text": "Ik ___ verschillende keren geprobeerd om hem telefonisch te bereiken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Я ___ несколько раз пытался связаться с ним по телефону."
  },
  {
   "id": "l4-197",
   "level": 4,
   "text": "De resultaten ___ veel beter geweest dan aanvankelijk werd verwacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "beter geweest",
   "rule": "zijn-blijven",
   "translationRu": "Результаты ___ оказались намного лучше, чем ожидалось поначалу."
  },
  {
   "id": "l4-198",
   "level": 4,
   "text": "Zij ___ tijdens de bijeenkomst verschillende voorstellen gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Она ___ в ходе собрания выдвинула несколько предложений."
  },
  {
   "id": "l4-199",
   "level": 4,
   "text": "Wij ___ na lang overleg tot een gezamenlijke verklaring gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после долгого обсуждения выработали совместное заявление."
  },
  {
   "id": "l4-200",
   "level": 4,
   "text": "Het bedrijf ___ zijn strategie aangepast aan de veranderende omstandigheden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangepast aan",
   "rule": "transitief",
   "translationRu": "Компания ___ свою стратегию адаптировала к изменившимся обстоятельствам."
  },
  {
   "id": "l4-201",
   "level": 4,
   "text": "Hoewel hij aanvankelijk weinig vertrouwen had, ___ hij uiteindelijk overtuigd geraakt van de noodzaak van de verandering.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "overtuigd geraakt",
   "rule": "verandering",
   "translationRu": "Хотя поначалу он мало доверял, он ___ в итоге убедился в необходимости перемен."
  },
  {
   "id": "l4-202",
   "level": 4,
   "text": "De onderzoekers ___ jarenlang onderzoek gedaan naar de gevolgen van klimaatverandering.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "onderzoek gedaan",
   "rule": "transitief",
   "translationRu": "Исследователи ___ на протяжении многих лет изучали последствия изменения климата."
  },
  {
   "id": "l4-203",
   "level": 4,
   "text": "Nadat de situatie was genormaliseerd, ___ de medewerkers geleidelijk teruggekeerd naar hun werk.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "teruggekeerd naar",
   "rule": "default-hebben",
   "translationRu": "После того как ситуация нормализовалась, сотрудники ___ постепенно вернулись к работе."
  },
  {
   "id": "l4-204",
   "level": 4,
   "text": "Wij ___ verschillende opties onderzocht voordat we een definitieve keuze maakten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Мы ___ рассмотрели несколько вариантов, прежде чем сделали окончательный выбор."
  },
  {
   "id": "l4-205",
   "level": 4,
   "text": "De directeur ___ tijdens het gesprek alle verantwoordelijkheid voor de situatie aanvaard.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aanvaard",
   "rule": "transitief",
   "translationRu": "Директор ___ в ходе разговора принял на себя всю ответственность за ситуацию."
  },
  {
   "id": "l4-206",
   "level": 4,
   "text": "Zij ___ na de onverwachte uitslag volledig van gedachten veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ после неожиданных результатов полностью изменила свои взгляды."
  },
  {
   "id": "l4-207",
   "level": 4,
   "text": "Het aantal aanvragen ___ sinds de nieuwe regeling ingevoerd werd aanzienlijk toegenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "toegenomen",
   "rule": "verandering",
   "translationRu": "Число заявок ___ с момента введения нового порядка значительно выросло."
  },
  {
   "id": "l4-208",
   "level": 4,
   "text": "Ik ___ me de afgelopen tijd steeds meer bewust geworden van mijn eigen beperkingen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bewust geworden van",
   "rule": "reflexief",
   "translationRu": "Я ___ в последнее время всё больше осознавал собственные ограничения."
  },
  {
   "id": "l4-209",
   "level": 4,
   "text": "De commissie ___ haar advies pas uitgebracht nadat alle betrokken partijen waren gehoord.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "uitgebracht",
   "rule": "transitief",
   "translationRu": "Комиссия ___ своё заключение вынесла только после того, как были заслушаны все заинтересованные стороны."
  },
  {
   "id": "l4-210",
   "level": 4,
   "text": "Nadat de onderhandelingen waren mislukt, ___ de partijen uit elkaar gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "uit elkaar gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как переговоры сорвались, стороны ___ разошлись."
  },
  {
   "id": "l4-211",
   "level": 4,
   "text": "Het bedrijf ___ de afgelopen jaren meerdere vestigingen in het buitenland geopend.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "geopend",
   "rule": "transitief",
   "translationRu": "Компания ___ за последние годы открыла несколько представительств за рубежом."
  },
  {
   "id": "l4-212",
   "level": 4,
   "text": "Hij ___ gedurende zijn carrière verschillende keren van werkgever veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Он ___ за время своей карьеры несколько раз менял работодателей."
  },
  {
   "id": "l4-213",
   "level": 4,
   "text": "Wij ___ ons niet voldoende voorbereid op de mogelijkheid dat het project vertraging zou oplopen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "voorbereid op",
   "rule": "reflexief",
   "translationRu": "Мы ___ недостаточно подготовились к возможности задержки проекта."
  },
  {
   "id": "l4-214",
   "level": 4,
   "text": "De situatie ___ in de loop van de avond steeds gespannener geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Ситуация ___ по ходу вечера становилась всё более напряжённой."
  },
  {
   "id": "l4-215",
   "level": 4,
   "text": "Zij ___ tijdens het interview nauwelijks op de kritiek ingegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "ingegaan op",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ во время интервью почти не отреагировала на критику."
  },
  {
   "id": "l4-216",
   "level": 4,
   "text": "De overheid ___ verschillende maatregelen genomen zonder eerst uitgebreid onderzoek te doen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Правительство ___ приняло ряд мер, не проведя предварительно обширного исследования."
  },
  {
   "id": "l4-217",
   "level": 4,
   "text": "Ik ___ gisteren tot de ontdekking gekomen dat er een fout in het rapport stond.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Я ___ вчера обнаружил, что в отчёте была ошибка."
  },
  {
   "id": "l4-218",
   "level": 4,
   "text": "De onderzoekers ___ hun oorspronkelijke hypothese uiteindelijk moeten aanpassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "moeten aanpassen",
   "rule": "groeps-inf",
   "translationRu": "Исследователи ___ свою первоначальную гипотезу в итоге вынуждены были скорректировать."
  },
  {
   "id": "l4-219",
   "level": 4,
   "text": "Nadat het contract was afgelopen, ___ de samenwerking automatisch beëindigd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "beëindigd",
   "rule": "transitief",
   "translationRu": "После того как контракт истёк, сотрудничество ___ автоматически прекратилось."
  },
  {
   "id": "l4-220",
   "level": 4,
   "text": "Wij ___ de afgelopen maanden intensief samengewerkt met buitenlandse partners.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "samengewerkt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ за последние месяцы интенсивно сотрудничали с зарубежными партнёрами."
  },
  {
   "id": "l4-221",
   "level": 4,
   "text": "Hij ___ na het ongeval enkele weken in het ziekenhuis gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после аварии несколько недель пролежал в больнице."
  },
  {
   "id": "l4-222",
   "level": 4,
   "text": "De organisatie ___ haar doelstellingen grotendeels bereikt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "bereikt",
   "rule": "transitief",
   "translationRu": "Организация ___ своих целей в основном достигла."
  },
  {
   "id": "l4-223",
   "level": 4,
   "text": "Zij ___ na de verhuizing snel aan haar nieuwe omgeving gewend geraakt.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewend geraakt",
   "rule": "verandering",
   "translationRu": "Она ___ после переезда быстро привыкла к новой обстановке."
  },
  {
   "id": "l4-224",
   "level": 4,
   "text": "Het bedrijf ___ de productie tijdelijk stilgelegd vanwege een tekort aan grondstoffen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "stilgelegd",
   "rule": "transitief",
   "translationRu": "Компания ___ производство временно остановила из-за нехватки сырья."
  },
  {
   "id": "l4-225",
   "level": 4,
   "text": "Ik ___ verschillende pogingen gedaan om het probleem op te lossen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Я ___ предпринял несколько попыток решить проблему."
  },
  {
   "id": "l4-226",
   "level": 4,
   "text": "Nadat de eerste cijfers bekend waren geworden, ___ de verwachtingen aanzienlijk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "После того как первые цифры стали известны, ожидания ___ существенно изменились."
  },
  {
   "id": "l4-227",
   "level": 4,
   "text": "De deelnemers ___ zich tijdens de discussie opvallend kritisch opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "opgesteld",
   "rule": "reflexief",
   "translationRu": "Участники ___ в ходе дискуссии на удивление критически настроились."
  },
  {
   "id": "l4-228",
   "level": 4,
   "text": "Wij ___ na afloop van het congres nog uitgebreid nagepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "nagepraat",
   "rule": "transitief",
   "translationRu": "Мы ___ после конгресса ещё долго обсуждали услышанное."
  },
  {
   "id": "l4-229",
   "level": 4,
   "text": "Hij ___ zijn mening pas veranderd nadat hij de nieuwe informatie had gelezen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Он ___ своё мнение изменил только после того, как прочитал новую информацию."
  },
  {
   "id": "l4-230",
   "level": 4,
   "text": "De regering ___ zich jarenlang ingezet voor een betere samenwerking tussen de landen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ingezet voor",
   "rule": "reflexief",
   "translationRu": "Правительство ___ на протяжении многих лет выступало за улучшение сотрудничества между странами."
  },
  {
   "id": "l4-231",
   "level": 4,
   "text": "De situatie ___ door een combinatie van verschillende factoren ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "Ситуация ___ возникла из-за сочетания разных факторов."
  },
  {
   "id": "l4-232",
   "level": 4,
   "text": "Ik ___ tijdens mijn studie geleerd om informatie kritisch te beoordelen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd om te beoordelen",
   "rule": "transitief",
   "translationRu": "Я ___ во время учёбы научился критически оценивать информацию."
  },
  {
   "id": "l4-233",
   "level": 4,
   "text": "Zij ___ na het gesprek met een geheel ander voorstel gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после разговора пришла с совершенно другим предложением."
  },
  {
   "id": "l4-234",
   "level": 4,
   "text": "De organisatie ___ de afgelopen periode veel nieuwe vrijwilligers aangetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangetrokken",
   "rule": "transitief",
   "translationRu": "Организация ___ за последний период привлекла много новых волонтёров."
  },
  {
   "id": "l4-235",
   "level": 4,
   "text": "Nadat hij was teruggekeerd, ___ hij zijn ervaringen met anderen gedeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gedeeld",
   "rule": "transitief",
   "translationRu": "После того как он вернулся, он ___ поделился своим опытом с другими."
  },
  {
   "id": "l4-236",
   "level": 4,
   "text": "Wij ___ verschillende keren met dezelfde problemen geconfronteerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geconfronteerd",
   "rule": "passief",
   "translationRu": "Мы ___ несколько раз сталкивались с одними и теми же проблемами."
  },
  {
   "id": "l4-237",
   "level": 4,
   "text": "Het project ___ door onverwachte financiële problemen vertraagd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "vertraagd",
   "rule": "verandering",
   "translationRu": "Проект ___ из-за непредвиденных финансовых проблем задержался."
  },
  {
   "id": "l4-238",
   "level": 4,
   "text": "Zij ___ na een lange discussie uiteindelijk met het voorstel akkoord gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "akkoord gegaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после долгого обсуждения в итоге согласилась с предложением."
  },
  {
   "id": "l4-239",
   "level": 4,
   "text": "De onderzoekers ___ alle gegevens zorgvuldig verzameld en geanalyseerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzameld en geanalyseerd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ все данные тщательно собрали и проанализировали."
  },
  {
   "id": "l4-240",
   "level": 4,
   "text": "Ik ___ gedurende de hele ochtend geprobeerd om een geschikte oplossing te vinden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Я ___ в течение всего утра пытался найти подходящее решение."
  },
  {
   "id": "l4-241",
   "level": 4,
   "text": "De directie ___ besloten de reorganisatie voorlopig niet door te voeren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Правление ___ решило реорганизацию пока не проводить."
  },
  {
   "id": "l4-242",
   "level": 4,
   "text": "Nadat de storm was gaan liggen, ___ de bewoners weer naar hun huizen teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "После того как шторм утих, жители ___ снова вернулись в свои дома."
  },
  {
   "id": "l4-243",
   "level": 4,
   "text": "Hij ___ zijn hele carrière in dezelfde sector gewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gewerkt",
   "rule": "transitief",
   "translationRu": "Он ___ всю свою карьеру проработал в одном и том же секторе."
  },
  {
   "id": "l4-244",
   "level": 4,
   "text": "Wij ___ ons standpunt meerdere keren duidelijk gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "duidelijk gemaakt",
   "rule": "reflexief",
   "translationRu": "Мы ___ свою позицию несколько раз чётко обозначили."
  },
  {
   "id": "l4-245",
   "level": 4,
   "text": "De situatie ___ uiteindelijk veel complexer gebleken dan verwacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gebleken",
   "rule": "zijn-blijven",
   "translationRu": "Ситуация ___ в итоге оказалась гораздо сложнее, чем ожидалось."
  },
  {
   "id": "l4-246",
   "level": 4,
   "text": "Zij ___ zich na het incident volledig uit het openbare leven teruggetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "Она ___ после инцидента полностью ушла из общественной жизни."
  },
  {
   "id": "l4-247",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de crisis nieuwe werknemers aangenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangenomen",
   "rule": "transitief",
   "translationRu": "Компания ___ несмотря на кризис наняла новых сотрудников."
  },
  {
   "id": "l4-248",
   "level": 4,
   "text": "Ik ___ de afgelopen jaren veel verschillende culturen leren kennen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "leren kennen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ за последние годы узнал много разных культур."
  },
  {
   "id": "l4-249",
   "level": 4,
   "text": "De commissie ___ na uitgebreid overleg een aantal aanbevelingen opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "opgesteld",
   "rule": "transitief",
   "translationRu": "Комиссия ___ после обширных консультаций выработала ряд рекомендаций."
  },
  {
   "id": "l4-250",
   "level": 4,
   "text": "Nadat de uitslag bekend was geworden, ___ er veel onzekerheid ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "После того как результаты стали известны, ___ возникла большая неопределённость."
  },
  {
   "id": "l4-251",
   "level": 4,
   "text": "Hij ___ tijdens het debat verschillende sterke argumenten naar voren gebracht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "naar voren gebracht",
   "rule": "transitief",
   "translationRu": "Он ___ в ходе дебатов выдвинул несколько сильных аргументов."
  },
  {
   "id": "l4-252",
   "level": 4,
   "text": "Wij ___ gedurende het onderzoek geen bewijs gevonden voor die bewering.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ в ходе исследования не нашли доказательств этому утверждению."
  },
  {
   "id": "l4-253",
   "level": 4,
   "text": "Zij ___ na haar vertrek jarenlang in het buitenland gewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewoond",
   "rule": "transitief",
   "translationRu": "Она ___ после отъезда долгие годы жила за границей."
  },
  {
   "id": "l4-254",
   "level": 4,
   "text": "De organisatie ___ haar activiteiten de afgelopen jaren aanzienlijk uitgebreid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "uitgebreid",
   "rule": "transitief",
   "translationRu": "Организация ___ свою деятельность за последние годы значительно расширила."
  },
  {
   "id": "l4-255",
   "level": 4,
   "text": "Ik ___ mijn oorspronkelijke plan inmiddels volledig losgelaten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "losgelaten",
   "rule": "transitief",
   "translationRu": "Я ___ от своего первоначального плана тем временем полностью отказался."
  },
  {
   "id": "l4-256",
   "level": 4,
   "text": "Nadat de laatste deelnemer was vertrokken, ___ de zaal vrijwel onmiddellijk leeggelopen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "leeggelopen",
   "rule": "verandering",
   "translationRu": "После того как последний участник ушёл, зал ___ почти сразу опустел."
  },
  {
   "id": "l4-257",
   "level": 4,
   "text": "De onderzoekers ___ zich vooral gericht op de langetermijneffecten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gericht op",
   "rule": "reflexief",
   "translationRu": "Исследователи ___ сосредоточились в основном на долгосрочных последствиях."
  },
  {
   "id": "l4-258",
   "level": 4,
   "text": "Hij ___ na de gebeurtenissen een andere kijk op de situatie gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Он ___ после этих событий стал по-другому смотреть на ситуацию."
  },
  {
   "id": "l4-259",
   "level": 4,
   "text": "Wij ___ vooraf onvoldoende stilgestaan bij de praktische gevolgen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "stilgestaan bij",
   "rule": "transitief",
   "translationRu": "Мы ___ заранее недостаточно остановились на практических последствиях."
  },
  {
   "id": "l4-260",
   "level": 4,
   "text": "De regering ___ uiteindelijk toch besloten de maatregel in te trekken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Правительство ___ в итоге всё же решило отозвать эту меру."
  },
  {
   "id": "l4-261",
   "level": 4,
   "text": "Zij ___ tijdens de onderhandelingen steeds naar een compromis gezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezocht naar",
   "rule": "transitief",
   "translationRu": "Она ___ на переговорах постоянно искала компромисс."
  },
  {
   "id": "l4-262",
   "level": 4,
   "text": "Ik ___ me nooit eerder zo intensief met dit onderwerp beziggehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "beziggehouden",
   "rule": "reflexief",
   "translationRu": "Я ___ никогда раньше так интенсивно не занимался этой темой."
  },
  {
   "id": "l4-263",
   "level": 4,
   "text": "De markt ___ in korte tijd volledig veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Рынок ___ за короткое время полностью изменился."
  },
  {
   "id": "l4-264",
   "level": 4,
   "text": "Nadat de financiering rond was, ___ het project daadwerkelijk van start gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "van start gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как финансирование было обеспечено, проект ___ действительно стартовал."
  },
  {
   "id": "l4-265",
   "level": 4,
   "text": "Hij ___ zich tijdens zijn verblijf in het buitenland sterk ontwikkeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ontwikkeld",
   "rule": "reflexief",
   "translationRu": "Он ___ за время пребывания за границей сильно развился."
  },
  {
   "id": "l4-266",
   "level": 4,
   "text": "Wij ___ de verschillende voorstellen uitvoerig met elkaar vergeleken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "vergeleken",
   "rule": "transitief",
   "translationRu": "Мы ___ разные предложения подробно сравнили друг с другом."
  },
  {
   "id": "l4-267",
   "level": 4,
   "text": "Zij ___ uiteindelijk naar een andere oplossing overgestapt.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "overgestapt naar",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в итоге перешла к другому решению."
  },
  {
   "id": "l4-268",
   "level": 4,
   "text": "Het bedrijf ___ de afgelopen vijf jaar aanzienlijk meer omzet gegenereerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gegenereerd",
   "rule": "transitief",
   "translationRu": "Компания ___ за последние пять лет значительно увеличила оборот."
  },
  {
   "id": "l4-269",
   "level": 4,
   "text": "Ik ___ gisteren urenlang met mijn advocaat over de kwestie gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken over",
   "rule": "transitief",
   "translationRu": "Я ___ вчера часами обсуждал этот вопрос со своим адвокатом."
  },
  {
   "id": "l4-270",
   "level": 4,
   "text": "De situatie ___ na enkele dagen langzaam verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ через несколько дней стала медленно улучшаться."
  },
  {
   "id": "l4-271",
   "level": 4,
   "text": "Nadat de onderhandelingen waren hervat, ___ beide partijen opnieuw vertrouwen in elkaar gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "После того как переговоры возобновились, обе стороны ___ вновь обрели доверие друг к другу."
  },
  {
   "id": "l4-272",
   "level": 4,
   "text": "Wij ___ verschillende deskundigen uitgenodigd om hun mening te geven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "uitgenodigd",
   "rule": "transitief",
   "translationRu": "Мы ___ пригласили нескольких экспертов, чтобы они высказали своё мнение."
  },
  {
   "id": "l4-273",
   "level": 4,
   "text": "Hij ___ zijn verantwoordelijkheid voor het incident niet ontkend.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ontkend",
   "rule": "transitief",
   "translationRu": "Он ___ своей ответственности за инцидент не отрицал."
  },
  {
   "id": "l4-274",
   "level": 4,
   "text": "Zij ___ na de kritiek tijdelijk teruggetreden uit haar functie.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggetreden",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после критики временно ушла со своей должности."
  },
  {
   "id": "l4-275",
   "level": 4,
   "text": "De organisatie ___ de afgelopen periode verschillende belangrijke veranderingen doorgevoerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "doorgevoerd",
   "rule": "transitief",
   "translationRu": "Организация ___ за последний период провела ряд важных изменений."
  },
  {
   "id": "l4-276",
   "level": 4,
   "text": "Ik ___ uiteindelijk besloten om het aanbod toch te accepteren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Я ___ в итоге решил всё-таки принять предложение."
  },
  {
   "id": "l4-277",
   "level": 4,
   "text": "De onderzoekers ___ tijdens het experiment op onverwachte resultaten gestuit.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gestuit",
   "rule": "passief",
   "translationRu": "Исследователи ___ во время эксперимента наткнулись на неожиданные результаты."
  },
  {
   "id": "l4-278",
   "level": 4,
   "text": "Nadat het probleem was opgelost, ___ iedereen weer opgelucht geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "После того как проблема была решена, все ___ снова вздохнули с облегчением."
  },
  {
   "id": "l4-279",
   "level": 4,
   "text": "Wij ___ gedurende de hele dag met verschillende vertegenwoordigers gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gesproken",
   "rule": "transitief",
   "translationRu": "Мы ___ в течение всего дня разговаривали с разными представителями."
  },
  {
   "id": "l4-280",
   "level": 4,
   "text": "Hij ___ zijn oorspronkelijke standpunt na het debat genuanceerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "genuanceerd",
   "rule": "transitief",
   "translationRu": "Он ___ свою первоначальную позицию после дебатов скорректировал."
  },
  {
   "id": "l4-281",
   "level": 4,
   "text": "Zij ___ in korte tijd een indrukwekkend netwerk opgebouwd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "opgebouwd",
   "rule": "transitief",
   "translationRu": "Она ___ за короткое время создала впечатляющую сеть контактов."
  },
  {
   "id": "l4-282",
   "level": 4,
   "text": "Het aantal klachten ___ de afgelopen maanden duidelijk afgenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "afgenomen",
   "rule": "verandering",
   "translationRu": "Число жалоб ___ за последние месяцы заметно снизилось."
  },
  {
   "id": "l4-283",
   "level": 4,
   "text": "Ik ___ tijdens het gesprek bewust niets over het conflict gezegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezegd",
   "rule": "transitief",
   "translationRu": "Я ___ во время разговора сознательно ничего не сказал о конфликте."
  },
  {
   "id": "l4-284",
   "level": 4,
   "text": "Nadat de situatie was geëvalueerd, ___ de commissie tot een andere conclusie gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "После оценки ситуации комиссия ___ пришла к другому выводу."
  },
  {
   "id": "l4-285",
   "level": 4,
   "text": "Wij ___ ons de afgelopen weken intensief op de presentatie voorbereid.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "voorbereid op",
   "rule": "reflexief",
   "translationRu": "Мы ___ в последние недели усердно готовились к презентации."
  },
  {
   "id": "l4-286",
   "level": 4,
   "text": "Hij ___ na zijn pensionering een heel ander leven begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после выхода на пенсию начал совсем другую жизнь."
  },
  {
   "id": "l4-287",
   "level": 4,
   "text": "De regering ___ onvoldoende rekening gehouden met de gevolgen voor kleine bedrijven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "rekening gehouden met",
   "rule": "transitief",
   "translationRu": "Правительство ___ недостаточно учло последствия для малых предприятий."
  },
  {
   "id": "l4-288",
   "level": 4,
   "text": "Zij ___ tijdens haar verblijf in het buitenland veel zelfstandiger geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ за время пребывания за границей стала гораздо самостоятельнее."
  },
  {
   "id": "l4-289",
   "level": 4,
   "text": "Het onderzoek ___ nieuwe vragen opgeroepen die nog niet beantwoord kunnen worden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "opgeroepen",
   "rule": "transitief",
   "translationRu": "Исследование ___ подняло новые вопросы, на которые пока нельзя ответить."
  },
  {
   "id": "l4-290",
   "level": 4,
   "text": "Ik ___ verschillende keren bij dezelfde organisatie gesolliciteerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesolliciteerd",
   "rule": "default-hebben",
   "translationRu": "Я ___ несколько раз пытался устроиться в ту же организацию."
  },
  {
   "id": "l4-291",
   "level": 4,
   "text": "Nadat de laatste afspraken waren gemaakt, ___ de samenwerking officieel begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "После того как были достигнуты последние договорённости, сотрудничество ___ официально началось."
  },
  {
   "id": "l4-292",
   "level": 4,
   "text": "Wij ___ gedurende meerdere jaren nauw met deze organisatie samengewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "samengewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ на протяжении многих лет тесно сотрудничали с этой организацией."
  },
  {
   "id": "l4-293",
   "level": 4,
   "text": "Hij ___ zich uiteindelijk uit de discussie teruggetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "Он ___ в итоге вышел из дискуссии."
  },
  {
   "id": "l4-294",
   "level": 4,
   "text": "De situatie ___ door een misverstand ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "Ситуация ___ возникла из-за недоразумения."
  },
  {
   "id": "l4-295",
   "level": 4,
   "text": "Zij ___ haar ervaringen uitgebreid beschreven in haar autobiografie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "beschreven",
   "rule": "transitief",
   "translationRu": "Она ___ свой опыт подробно описала в автобиографии."
  },
  {
   "id": "l4-296",
   "level": 4,
   "text": "Ik ___ mijn oordeel gebaseerd op de informatie die toen beschikbaar was.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gebaseerd op",
   "rule": "transitief",
   "translationRu": "Я ___ своё суждение основывал на информации, которая тогда была доступна."
  },
  {
   "id": "l4-297",
   "level": 4,
   "text": "Nadat de uitslag bekend werd, ___ de politieke situatie snel veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "После того как результаты стали известны, политическая ситуация ___ быстро изменилась."
  },
  {
   "id": "l4-298",
   "level": 4,
   "text": "Wij ___ de afgelopen maanden meerdere interviews afgenomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "afgenomen",
   "rule": "transitief",
   "translationRu": "Мы ___ за последние месяцы провели несколько интервью."
  },
  {
   "id": "l4-299",
   "level": 4,
   "text": "Hij ___ na het incident nooit meer naar zijn oude werkplek teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Он ___ после инцидента больше никогда не возвращался на старое место работы."
  },
  {
   "id": "l4-300",
   "level": 4,
   "text": "De organisatie ___ haar positie in de regio aanzienlijk versterkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "versterkt",
   "rule": "transitief",
   "translationRu": "Организация ___ свои позиции в регионе значительно укрепила."
  },
  {
   "id": "l4-301",
   "level": 4,
   "text": "Ik ___ pas later gaan begrijpen waarom hij zo had gereageerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gaan begrijpen",
   "rule": "groeps-inf",
   "translationRu": "Я ___ только потом начал понимать, почему он так отреагировал."
  },
  {
   "id": "l4-302",
   "level": 4,
   "text": "Zij ___ gedurende haar onderzoek verschillende onverwachte problemen tegengekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "tegengekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в ходе исследования столкнулась с несколькими неожиданными проблемами."
  },
  {
   "id": "l4-303",
   "level": 4,
   "text": "Nadat het nieuwe beleid was ingevoerd, ___ het aantal klachten aanvankelijk toegenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "toegenomen",
   "rule": "verandering",
   "translationRu": "После введения новой политики число жалоб ___ поначалу выросло."
  },
  {
   "id": "l4-304",
   "level": 4,
   "text": "Wij ___ vooraf zorgvuldig onderzocht welke gevolgen de beslissing kon hebben.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Мы ___ заранее тщательно изучили, какие последствия может иметь это решение."
  },
  {
   "id": "l4-305",
   "level": 4,
   "text": "Hij ___ na jaren van discussie eindelijk tot een besluit gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после многих лет обсуждений наконец принял решение."
  },
  {
   "id": "l4-306",
   "level": 4,
   "text": "De overheid ___ verschillende rapporten gepubliceerd over de ontwikkeling van de economie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gepubliceerd",
   "rule": "transitief",
   "translationRu": "Правительство ___ опубликовало несколько докладов о развитии экономики."
  },
  {
   "id": "l4-307",
   "level": 4,
   "text": "Ik ___ me de afgelopen maanden verdiept in de geschiedenis van het conflict.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "verdiept in",
   "rule": "reflexief",
   "translationRu": "Я ___ в последние месяцы углубился в изучение истории этого конфликта."
  },
  {
   "id": "l4-308",
   "level": 4,
   "text": "Zij ___ na haar vertrek lange tijd buiten Nederland gebleven.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gebleven",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после отъезда долгое время жила за пределами Нидерландов."
  },
  {
   "id": "l4-309",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de kritiek vastgehouden aan zijn oorspronkelijke strategie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "vastgehouden aan",
   "rule": "transitief",
   "translationRu": "Компания ___ несмотря на критику держалась за свою первоначальную стратегию."
  },
  {
   "id": "l4-310",
   "level": 4,
   "text": "Wij ___ tijdens de bijeenkomst uitgebreid gesproken over mogelijke alternatieven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gesproken over",
   "rule": "transitief",
   "translationRu": "Мы ___ на собрании подробно говорили о возможных альтернативах."
  },
  {
   "id": "l4-311",
   "level": 4,
   "text": "Hij ___ zich uiteindelijk bereid verklaard om mee te werken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bereid verklaard",
   "rule": "reflexief",
   "translationRu": "Он ___ в итоге заявил о своей готовности сотрудничать."
  },
  {
   "id": "l4-312",
   "level": 4,
   "text": "De onderzoekers ___ hun resultaten met die van eerdere studies vergeleken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "vergeleken",
   "rule": "transitief",
   "translationRu": "Исследователи ___ свои результаты сравнили с результатами прежних исследований."
  },
  {
   "id": "l4-313",
   "level": 4,
   "text": "Nadat de storm voorbij was, ___ de situatie langzaam weer genormaliseerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genormaliseerd",
   "rule": "verandering",
   "translationRu": "После того как шторм прошёл, ситуация ___ постепенно нормализовалась."
  },
  {
   "id": "l4-314",
   "level": 4,
   "text": "Ik ___ mijn standpunt aangepast nadat ik de argumenten van mijn collega had gehoord.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Я ___ свою позицию изменил после того, как услышал аргументы коллеги."
  },
  {
   "id": "l4-315",
   "level": 4,
   "text": "Zij ___ gedurende meerdere jaren verantwoordelijk geweest voor de internationale afdeling.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verantwoordelijk geweest voor",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ на протяжении нескольких лет отвечала за международный отдел."
  },
  {
   "id": "l4-316",
   "level": 4,
   "text": "De organisatie ___ de afgelopen periode aanzienlijke vooruitgang geboekt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "geboekt",
   "rule": "transitief",
   "translationRu": "Организация ___ за последний период добилась значительного прогресса."
  },
  {
   "id": "l4-317",
   "level": 4,
   "text": "Wij ___ na lang overleg besloten om het voorstel toch te accepteren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Мы ___ после долгого обсуждения решили всё-таки принять это предложение."
  },
  {
   "id": "l4-318",
   "level": 4,
   "text": "Hij ___ tijdens het onderzoek verschillende fouten gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "Он ___ в ходе исследования допустил несколько ошибок."
  },
  {
   "id": "l4-319",
   "level": 4,
   "text": "De situatie ___ onverwacht snel veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ неожиданно быстро изменилась."
  },
  {
   "id": "l4-320",
   "level": 4,
   "text": "Ik ___ gisteren met verschillende deskundigen over de kwestie gesproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesproken over",
   "rule": "transitief",
   "translationRu": "Я ___ вчера разговаривал с несколькими экспертами по этому вопросу."
  },
  {
   "id": "l4-321",
   "level": 4,
   "text": "Zij ___ na de reorganisatie een andere functie binnen het bedrijf gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Она ___ после реорганизации получила другую должность в компании."
  },
  {
   "id": "l4-322",
   "level": 4,
   "text": "Het project ___ door een gebrek aan personeel ernstig vertraagd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "vertraagd",
   "rule": "verandering",
   "translationRu": "Проект ___ из-за нехватки персонала серьёзно задержался."
  },
  {
   "id": "l4-323",
   "level": 4,
   "text": "Wij ___ ons gedurende het hele traject aan de gemaakte afspraken gehouden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gehouden aan",
   "rule": "reflexief",
   "translationRu": "Мы ___ на протяжении всего процесса придерживались достигнутых договорённостей."
  },
  {
   "id": "l4-324",
   "level": 4,
   "text": "Nadat de eerste poging was mislukt, ___ hij opnieuw begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "После того как первая попытка не удалась, он ___ начал заново."
  },
  {
   "id": "l4-325",
   "level": 4,
   "text": "De regering ___ de kritiek uit de oppositie grotendeels genegeerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genegeerd",
   "rule": "transitief",
   "translationRu": "Правительство ___ критику со стороны оппозиции по большей части проигнорировало."
  },
  {
   "id": "l4-326",
   "level": 4,
   "text": "Ik ___ tijdens mijn carrière veel geleerd van moeilijke situaties.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geleerd",
   "rule": "transitief",
   "translationRu": "Я ___ за время своей карьеры многому научился на сложных ситуациях."
  },
  {
   "id": "l4-327",
   "level": 4,
   "text": "Zij ___ uiteindelijk tot de conclusie gekomen dat verdere onderhandelingen zinloos waren.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в итоге пришла к выводу, что дальнейшие переговоры бессмысленны."
  },
  {
   "id": "l4-328",
   "level": 4,
   "text": "De organisatie ___ zich de afgelopen jaren steeds meer internationaal georiënteerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "georiënteerd",
   "rule": "reflexief",
   "translationRu": "Организация ___ в последние годы всё больше ориентировалась на международную деятельность."
  },
  {
   "id": "l4-329",
   "level": 4,
   "text": "Wij ___ verschillende scenario's uitgewerkt voordat we een beslissing namen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "uitgewerkt",
   "rule": "transitief",
   "translationRu": "Мы ___ проработали несколько сценариев, прежде чем приняли решение."
  },
  {
   "id": "l4-330",
   "level": 4,
   "text": "Hij ___ na de discussie opvallend stil geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после дискуссии на удивление замолчал."
  },
  {
   "id": "l4-331",
   "level": 4,
   "text": "De onderzoekers ___ gedurende lange tijd gegevens uit verschillende bronnen verzameld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzameld",
   "rule": "transitief",
   "translationRu": "Исследователи ___ в течение долгого времени собирали данные из разных источников."
  },
  {
   "id": "l4-332",
   "level": 4,
   "text": "Nadat de overeenkomst was gesloten, ___ de partijen met de uitvoering begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "После того как соглашение было заключено, стороны ___ приступили к его исполнению."
  },
  {
   "id": "l4-333",
   "level": 4,
   "text": "Ik ___ mijn eerdere beslissing later betreurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "betrreurd",
   "rule": "transitief",
   "translationRu": "Я ___ о своём прежнем решении впоследствии пожалел."
  },
  {
   "id": "l4-334",
   "level": 4,
   "text": "Zij ___ na haar studie teruggekeerd naar haar geboortestad.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Она ___ после учёбы вернулась в свой родной город."
  },
  {
   "id": "l4-335",
   "level": 4,
   "text": "Het bedrijf ___ de afgelopen jaren flink geïnvesteerd in automatisering.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "geïnvesteerd in",
   "rule": "transitief",
   "translationRu": "Компания ___ за последние годы много инвестировала в автоматизацию."
  },
  {
   "id": "l4-336",
   "level": 4,
   "text": "Wij ___ tijdens de onderhandelingen verschillende concessies gedaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gedaan",
   "rule": "transitief",
   "translationRu": "Мы ___ в ходе переговоров пошли на несколько уступок."
  },
  {
   "id": "l4-337",
   "level": 4,
   "text": "Hij ___ zich tijdens het hele proces professioneel opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgesteld",
   "rule": "reflexief",
   "translationRu": "Он ___ на протяжении всего процесса вёл себя профессионально."
  },
  {
   "id": "l4-338",
   "level": 4,
   "text": "De situatie ___ door verschillende kleine fouten ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "Ситуация ___ возникла из-за нескольких мелких ошибок."
  },
  {
   "id": "l4-339",
   "level": 4,
   "text": "Ik ___ gisteren een uitgebreid gesprek met mijn leidinggevende gehad.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gehad",
   "rule": "transitief",
   "translationRu": "Я ___ вчера провёл обстоятельную беседу со своим руководителем."
  },
  {
   "id": "l4-340",
   "level": 4,
   "text": "Zij ___ na de kritiek haar excuses aangeboden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangeboden",
   "rule": "transitief",
   "translationRu": "Она ___ после критики принесла свои извинения."
  },
  {
   "id": "l4-341",
   "level": 4,
   "text": "De commissie ___ uiteindelijk een onafhankelijk onderzoek ingesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ingesteld",
   "rule": "transitief",
   "translationRu": "Комиссия ___ в итоге назначила независимое расследование."
  },
  {
   "id": "l4-342",
   "level": 4,
   "text": "Nadat de resultaten waren gepubliceerd, ___ veel onderzoekers kritisch geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "После публикации результатов ___ многие исследователи стали критически настроены."
  },
  {
   "id": "l4-343",
   "level": 4,
   "text": "Wij ___ de beschikbare informatie zorgvuldig beoordeeld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "beoordeeld",
   "rule": "transitief",
   "translationRu": "Мы ___ доступную информацию тщательно оценили."
  },
  {
   "id": "l4-344",
   "level": 4,
   "text": "Hij ___ jarenlang geprobeerd om zijn eigen bedrijf op te bouwen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Он ___ на протяжении многих лет пытался создать собственное дело."
  },
  {
   "id": "l4-345",
   "level": 4,
   "text": "Zij ___ na een lange periode van onzekerheid eindelijk teruggekeerd naar haar oude functie.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekeerd naar",
   "rule": "default-hebben",
   "translationRu": "Она ___ после долгого периода неопределённости наконец вернулась на прежнюю должность."
  },
  {
   "id": "l4-346",
   "level": 4,
   "text": "De overheid ___ de afgelopen jaren steeds meer aandacht besteed aan digitale veiligheid.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "besteed aan",
   "rule": "transitief",
   "translationRu": "Правительство ___ в последние годы уделяло всё больше внимания цифровой безопасности."
  },
  {
   "id": "l4-347",
   "level": 4,
   "text": "Ik ___ gedurende mijn opleiding verschillende stages gelopen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gelopen",
   "rule": "transitief",
   "translationRu": "Я ___ за время учёбы прошёл несколько стажировок."
  },
  {
   "id": "l4-348",
   "level": 4,
   "text": "Het bedrijf ___ zich na de overname volledig op de internationale markt gericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gericht op",
   "rule": "reflexief",
   "translationRu": "Компания ___ после поглощения полностью сосредоточилась на международном рынке."
  },
  {
   "id": "l4-349",
   "level": 4,
   "text": "Wij ___ na de vergadering nog lang over de mogelijke gevolgen nagepraat.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "nagepraat over",
   "rule": "transitief",
   "translationRu": "Мы ___ после заседания ещё долго обсуждали возможные последствия."
  },
  {
   "id": "l4-350",
   "level": 4,
   "text": "Hij ___ uiteindelijk besloten zijn functie neer te leggen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Он ___ в итоге решил сложить с себя полномочия."
  },
  {
   "id": "l4-351",
   "level": 4,
   "text": "Zij ___ haar hele leven in dezelfde regio gewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewoond",
   "rule": "transitief",
   "translationRu": "Она ___ всю жизнь прожила в одном и том же регионе."
  },
  {
   "id": "l4-352",
   "level": 4,
   "text": "De situatie ___ in de afgelopen weken aanzienlijk verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ за последние недели значительно улучшилась."
  },
  {
   "id": "l4-353",
   "level": 4,
   "text": "Ik ___ mijn collega's gevraagd om hun mening over het voorstel.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevraagd",
   "rule": "transitief",
   "translationRu": "Я ___ попросил коллег высказать своё мнение о предложении."
  },
  {
   "id": "l4-354",
   "level": 4,
   "text": "Nadat hij was verhuisd, ___ hij snel nieuwe vrienden gemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gemaakt",
   "rule": "transitief",
   "translationRu": "После того как он переехал, он ___ быстро завёл новых друзей."
  },
  {
   "id": "l4-355",
   "level": 4,
   "text": "De onderzoekers ___ verschillende verklaringen uitgesloten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "uitgesloten",
   "rule": "transitief",
   "translationRu": "Исследователи ___ исключили несколько объяснений."
  },
  {
   "id": "l4-356",
   "level": 4,
   "text": "Wij ___ tijdens het project voortdurend onze planning moeten aanpassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "moeten aanpassen",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ в ходе проекта постоянно были вынуждены корректировать планы."
  },
  {
   "id": "l4-357",
   "level": 4,
   "text": "Zij ___ na het incident tijdelijk naar haar ouders teruggegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggegaan",
   "rule": "default-hebben",
   "translationRu": "Она ___ после инцидента временно вернулась к родителям."
  },
  {
   "id": "l4-358",
   "level": 4,
   "text": "Het bestuur ___ verschillende belangrijke beslissingen genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Правление ___ приняло несколько важных решений."
  },
  {
   "id": "l4-359",
   "level": 4,
   "text": "Ik ___ de afgelopen tijd veel nagedacht over de vraag of ik moet doorgaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "nagedacht over",
   "rule": "default-hebben",
   "translationRu": "Я ___ в последнее время много думал над вопросом, стоит ли мне продолжать."
  },
  {
   "id": "l4-360",
   "level": 4,
   "text": "Hij ___ na het gesprek duidelijk opgelucht geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Он ___ после разговора заметно вздохнул с облегчением."
  },
  {
   "id": "l4-361",
   "level": 4,
   "text": "De organisatie ___ een groot aantal aanvragen ontvangen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontvangen",
   "rule": "transitief",
   "translationRu": "Организация ___ получила большое количество заявок."
  },
  {
   "id": "l4-362",
   "level": 4,
   "text": "Wij ___ ons niet gerealiseerd hoe ingewikkeld de situatie zou worden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gerealiseerd",
   "rule": "reflexief",
   "translationRu": "Мы ___ не осознали, насколько сложной окажется ситуация."
  },
  {
   "id": "l4-363",
   "level": 4,
   "text": "Zij ___ tijdens de onderhandelingen steeds naar een middenweg gezocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gezocht naar",
   "rule": "transitief",
   "translationRu": "Она ___ на переговорах постоянно искала средний путь."
  },
  {
   "id": "l4-364",
   "level": 4,
   "text": "Nadat de financiële problemen waren opgelost, ___ het vertrouwen langzaam teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "После того как финансовые проблемы были решены, доверие ___ постепенно вернулось."
  },
  {
   "id": "l4-365",
   "level": 4,
   "text": "Ik ___ mijn verwachtingen inmiddels naar beneden bijgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bijgesteld",
   "rule": "transitief",
   "translationRu": "Я ___ свои ожидания тем временем снизил."
  },
  {
   "id": "l4-366",
   "level": 4,
   "text": "Hij ___ zich jarenlang voor gelijke kansen ingezet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ingezet voor",
   "rule": "reflexief",
   "translationRu": "Он ___ на протяжении многих лет выступал за равные возможности."
  },
  {
   "id": "l4-367",
   "level": 4,
   "text": "De commissie ___ haar eindrapport na maanden van onderzoek gepubliceerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gepubliceerd",
   "rule": "transitief",
   "translationRu": "Комиссия ___ свой итоговый доклад опубликовала после месяцев исследования."
  },
  {
   "id": "l4-368",
   "level": 4,
   "text": "Wij ___ verschillende maatregelen getroffen om verdere problemen te voorkomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "getroffen",
   "rule": "transitief",
   "translationRu": "Мы ___ приняли ряд мер, чтобы предотвратить дальнейшие проблемы."
  },
  {
   "id": "l4-369",
   "level": 4,
   "text": "Zij ___ uiteindelijk van plan veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ в итоге передумала."
  },
  {
   "id": "l4-370",
   "level": 4,
   "text": "Het aantal deelnemers ___ sinds de start van het programma verdubbeld.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "verdubbeld",
   "rule": "verandering",
   "translationRu": "Число участников ___ с момента запуска программы удвоилось."
  },
  {
   "id": "l4-371",
   "level": 4,
   "text": "Ik ___ tijdens de bijeenkomst een aantal kritische vragen gesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gesteld",
   "rule": "transitief",
   "translationRu": "Я ___ на собрании задал ряд критических вопросов."
  },
  {
   "id": "l4-372",
   "level": 4,
   "text": "Hij ___ na zijn ontslag naar het buitenland vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после увольнения уехал за границу."
  },
  {
   "id": "l4-373",
   "level": 4,
   "text": "Wij ___ het hele probleem vanuit verschillende perspectieven bekeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "bekeken",
   "rule": "transitief",
   "translationRu": "Мы ___ на всю проблему посмотрели с разных точек зрения."
  },
  {
   "id": "l4-374",
   "level": 4,
   "text": "Zij ___ zich uiteindelijk bij de beslissing neergelegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "neergelegd bij",
   "rule": "reflexief",
   "translationRu": "Она ___ в итоге смирилась с решением."
  },
  {
   "id": "l4-375",
   "level": 4,
   "text": "De regering ___ een nieuwe strategie ontwikkeld om de economie te stimuleren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontwikkeld",
   "rule": "transitief",
   "translationRu": "Правительство ___ разработало новую стратегию для стимулирования экономики."
  },
  {
   "id": "l4-376",
   "level": 4,
   "text": "Ik ___ na lang twijfelen toch voor deze opleiding gekozen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekozen",
   "rule": "transitief",
   "translationRu": "Я ___ после долгих колебаний всё-таки выбрал эту программу обучения."
  },
  {
   "id": "l4-377",
   "level": 4,
   "text": "Hij ___ zich tijdens het interview zeer terughoudend opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "opgesteld",
   "rule": "reflexief",
   "translationRu": "Он ___ во время интервью вёл себя очень сдержанно."
  },
  {
   "id": "l4-378",
   "level": 4,
   "text": "De organisatie ___ in korte tijd sterk gegroeid.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gegroeid",
   "rule": "verandering",
   "translationRu": "Организация ___ за короткое время сильно выросла."
  },
  {
   "id": "l4-379",
   "level": 4,
   "text": "Wij ___ vooraf niet verwacht dat de onderhandelingen zo lang zouden duren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "verwacht",
   "rule": "transitief",
   "translationRu": "Мы ___ заранее не ожидали, что переговоры затянутся так надолго."
  },
  {
   "id": "l4-380",
   "level": 4,
   "text": "Zij ___ na het afronden van haar onderzoek een boek gepubliceerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gepubliceerd",
   "rule": "transitief",
   "translationRu": "Она ___ после завершения исследования опубликовала книгу."
  },
  {
   "id": "l4-381",
   "level": 4,
   "text": "Ik ___ gedurende mijn verblijf veel interessante mensen ontmoet.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "ontmoet",
   "rule": "transitief",
   "translationRu": "Я ___ за время пребывания познакомился со многими интересными людьми."
  },
  {
   "id": "l4-382",
   "level": 4,
   "text": "Hij ___ na het slechte nieuws onmiddellijk naar huis gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gegaan",
   "rule": "default-hebben",
   "translationRu": "Он ___ после плохой новости сразу же пошёл домой."
  },
  {
   "id": "l4-383",
   "level": 4,
   "text": "De onderzoekers ___ de resultaten van verschillende onderzoeken gecombineerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gecombineerd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ результаты нескольких исследований объединили."
  },
  {
   "id": "l4-384",
   "level": 4,
   "text": "Wij ___ uiteindelijk een manier gevonden om beide belangen te combineren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gevonden",
   "rule": "transitief",
   "translationRu": "Мы ___ в итоге нашли способ совместить оба интереса."
  },
  {
   "id": "l4-385",
   "level": 4,
   "text": "Zij ___ na haar vertrek regelmatig contact gehouden met haar collega's.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gehouden met",
   "rule": "transitief",
   "translationRu": "Она ___ после отъезда регулярно поддерживала контакт с коллегами."
  },
  {
   "id": "l4-386",
   "level": 4,
   "text": "De situatie ___ door de nieuwe informatie plotseling veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ из-за новой информации внезапно изменилась."
  },
  {
   "id": "l4-387",
   "level": 4,
   "text": "Ik ___ mijn mening tijdens het debat niet veranderd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "veranderd",
   "rule": "transitief",
   "translationRu": "Я ___ своё мнение во время дебатов не изменил."
  },
  {
   "id": "l4-388",
   "level": 4,
   "text": "Hij ___ na een lange periode van ziekte weer volledig hersteld.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "hersteld",
   "rule": "verandering",
   "translationRu": "Он ___ после долгой болезни полностью поправился."
  },
  {
   "id": "l4-389",
   "level": 4,
   "text": "Wij ___ de afgelopen maanden veel tijd besteed aan de voorbereiding.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besteed aan",
   "rule": "transitief",
   "translationRu": "Мы ___ за последние месяцы потратили много времени на подготовку."
  },
  {
   "id": "l4-390",
   "level": 4,
   "text": "Zij ___ verschillende keren van strategie veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Она ___ несколько раз меняла стратегию."
  },
  {
   "id": "l4-391",
   "level": 4,
   "text": "De organisatie ___ ondanks de financiële problemen blijven bestaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "blijven bestaan",
   "rule": "groeps-inf",
   "translationRu": "Организация ___ несмотря на финансовые трудности продолжила существовать."
  },
  {
   "id": "l4-392",
   "level": 4,
   "text": "Ik ___ na het lezen van het rapport een heel andere indruk gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ после прочтения отчёта получил совершенно другое впечатление."
  },
  {
   "id": "l4-393",
   "level": 4,
   "text": "Hij ___ zijn excuses aangeboden voor de verwarring.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangeboden",
   "rule": "transitief",
   "translationRu": "Он ___ принёс свои извинения за путаницу."
  },
  {
   "id": "l4-394",
   "level": 4,
   "text": "Wij ___ na de vergadering tot een gezamenlijk standpunt gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после заседания пришли к общей позиции."
  },
  {
   "id": "l4-395",
   "level": 4,
   "text": "Zij ___ tijdens haar carrière verschillende internationale prijzen gewonnen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewonnen",
   "rule": "transitief",
   "translationRu": "Она ___ за время своей карьеры получила несколько международных премий."
  },
  {
   "id": "l4-396",
   "level": 4,
   "text": "De markt ___ de afgelopen jaren aanzienlijk veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Рынок ___ за последние годы существенно изменился."
  },
  {
   "id": "l4-397",
   "level": 4,
   "text": "Ik ___ me bewust geworden van de gevolgen van mijn beslissing.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bewust geworden van",
   "rule": "reflexief",
   "translationRu": "Я ___ осознал последствия своего решения."
  },
  {
   "id": "l4-398",
   "level": 4,
   "text": "Hij ___ zich na het conflict volledig teruggetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "Он ___ после конфликта полностью ушёл в тень."
  },
  {
   "id": "l4-399",
   "level": 4,
   "text": "Wij ___ alle mogelijke alternatieven zorgvuldig onderzocht.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "onderzocht",
   "rule": "transitief",
   "translationRu": "Мы ___ все возможные альтернативы тщательно изучили."
  },
  {
   "id": "l4-400",
   "level": 4,
   "text": "De situatie ___ uiteindelijk minder ernstig gebleken dan aanvankelijk werd gedacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gebleken",
   "rule": "zijn-blijven",
   "translationRu": "Ситуация ___ в итоге оказалась менее серьёзной, чем думали поначалу."
  },
  {
   "id": "l4-401",
   "level": 4,
   "text": "Hoewel de onderhandelingen moeizaam verliepen, ___ beide partijen uiteindelijk tot een overeenkomst gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Хотя переговоры шли тяжело, обе стороны ___ в итоге пришли к соглашению."
  },
  {
   "id": "l4-402",
   "level": 4,
   "text": "De onderzoekers ___ jarenlang geprobeerd om een verklaring voor dit verschijnsel te vinden.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ на протяжении многих лет пытались найти объяснение этому явлению."
  },
  {
   "id": "l4-403",
   "level": 4,
   "text": "Nadat het rapport was verschenen, ___ er een brede maatschappelijke discussie ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "После выхода доклада ___ развернулась широкая общественная дискуссия."
  },
  {
   "id": "l4-404",
   "level": 4,
   "text": "Zij ___ haar oorspronkelijke plan aangepast nadat verschillende deskundigen kritiek hadden geuit.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangepast",
   "rule": "transitief",
   "translationRu": "Она ___ свой первоначальный план скорректировала после того, как ряд экспертов высказал критику."
  },
  {
   "id": "l4-405",
   "level": 4,
   "text": "Het bedrijf ___ zich de afgelopen jaren ontwikkeld tot een belangrijke internationale speler.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "ontwikkeld tot",
   "rule": "reflexief",
   "translationRu": "Компания ___ за последние годы превратилась в важного международного игрока."
  },
  {
   "id": "l4-406",
   "level": 4,
   "text": "Wij ___ verschillende keren met dezelfde problemen geconfronteerd, ondanks alle voorzorgsmaatregelen.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geconfronteerd",
   "rule": "passief",
   "translationRu": "Мы ___ несколько раз сталкивались с одними и теми же проблемами, несмотря на все меры предосторожности."
  },
  {
   "id": "l4-407",
   "level": 4,
   "text": "Hij ___ na de onverwachte gebeurtenis tijdelijk naar het buitenland vertrokken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "vertrokken",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после неожиданного происшествия временно уехал за границу."
  },
  {
   "id": "l4-408",
   "level": 4,
   "text": "Ik ___ tijdens mijn onderzoek steeds meer twijfels gekregen over de betrouwbaarheid van de gegevens.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ в ходе исследования всё больше сомневался в достоверности данных."
  },
  {
   "id": "l4-409",
   "level": 4,
   "text": "De regering ___ verschillende maatregelen aangekondigd, maar nog weinig concrete resultaten geboekt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "aangekondigd",
   "rule": "transitief",
   "translationRu": "Правительство ___ объявило о ряде мер, но конкретных результатов пока немного."
  },
  {
   "id": "l4-410",
   "level": 4,
   "text": "Nadat de situatie was geëvalueerd, ___ de commissie tot de conclusie gekomen dat verdere actie noodzakelijk was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "После оценки ситуации комиссия ___ пришла к выводу, что необходимы дальнейшие действия."
  },
  {
   "id": "l4-411",
   "level": 4,
   "text": "Zij ___ zich jarenlang sterk gemaakt voor meer transparantie binnen de organisatie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "sterk gemaakt voor",
   "rule": "reflexief",
   "translationRu": "Она ___ на протяжении многих лет активно выступала за большую прозрачность в организации."
  },
  {
   "id": "l4-412",
   "level": 4,
   "text": "Het aantal werknemers ___ sinds de reorganisatie aanzienlijk afgenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "afgenomen",
   "rule": "verandering",
   "translationRu": "Число сотрудников ___ с момента реорганизации значительно сократилось."
  },
  {
   "id": "l4-413",
   "level": 4,
   "text": "Wij ___ de afgelopen maanden intensief samengewerkt om het probleem op te lossen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "samengewerkt",
   "rule": "default-hebben",
   "translationRu": "Мы ___ за последние месяцы интенсивно сотрудничали, чтобы решить проблему."
  },
  {
   "id": "l4-414",
   "level": 4,
   "text": "Hij ___ uiteindelijk ingezien dat hij zijn verwachtingen moest aanpassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ingezien",
   "rule": "transitief",
   "translationRu": "Он ___ в итоге осознал, что нужно скорректировать свои ожидания."
  },
  {
   "id": "l4-415",
   "level": 4,
   "text": "De organisatie ___ haar beleid meerdere keren gewijzigd naar aanleiding van nieuwe wetgeving.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gewijzigd",
   "rule": "transitief",
   "translationRu": "Организация ___ свою политику несколько раз меняла в связи с новым законодательством."
  },
  {
   "id": "l4-416",
   "level": 4,
   "text": "Nadat de crisis was uitgebroken, ___ veel investeerders zich teruggetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "После того как разразился кризис, многие инвесторы ___ отказались от своих планов."
  },
  {
   "id": "l4-417",
   "level": 4,
   "text": "Ik ___ de afgelopen jaren verschillende manieren geprobeerd om efficiënter te werken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Я ___ за последние годы перепробовал разные способы работать эффективнее."
  },
  {
   "id": "l4-418",
   "level": 4,
   "text": "Zij ___ na het gesprek zichtbaar opgelucht geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Она ___ после разговора явно вздохнула с облегчением."
  },
  {
   "id": "l4-419",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de moeilijke omstandigheden nieuwe markten aangeboord.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangeboord",
   "rule": "transitief",
   "translationRu": "Компания ___ несмотря на сложные обстоятельства освоила новые рынки."
  },
  {
   "id": "l4-420",
   "level": 4,
   "text": "Wij ___ tijdens het onderzoek op een aantal onverwachte verbanden gestuit.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gestuit",
   "rule": "passief",
   "translationRu": "Мы ___ в ходе исследования наткнулись на ряд неожиданных связей."
  },
  {
   "id": "l4-421",
   "level": 4,
   "text": "Hij ___ zich na zijn terugkeer opnieuw bij de organisatie aangesloten.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "aangesloten",
   "rule": "reflexief",
   "translationRu": "Он ___ после возвращения вновь присоединился к организации."
  },
  {
   "id": "l4-422",
   "level": 4,
   "text": "De overheid ___ onvoldoende rekening gehouden met de praktische uitvoerbaarheid van de maatregel.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "rekening gehouden met",
   "rule": "transitief",
   "translationRu": "Правительство ___ недостаточно учло практическую выполнимость этой меры."
  },
  {
   "id": "l4-423",
   "level": 4,
   "text": "Nadat de laatste bezwaren waren besproken, ___ iedereen uiteindelijk akkoord gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "akkoord gegaan",
   "rule": "vaste-zijn",
   "translationRu": "После того как были обсуждены последние возражения, все ___ в итоге согласились."
  },
  {
   "id": "l4-424",
   "level": 4,
   "text": "Ik ___ me lange tijd afgevraagd waarom de resultaten zo sterk afweken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "afgevraagd",
   "rule": "reflexief",
   "translationRu": "Я ___ долгое время задавался вопросом, почему результаты так сильно разошлись."
  },
  {
   "id": "l4-425",
   "level": 4,
   "text": "Zij ___ haar ervaringen tijdens het project uitgebreid beschreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "beschreven",
   "rule": "transitief",
   "translationRu": "Она ___ свой опыт во время проекта подробно описала."
  },
  {
   "id": "l4-426",
   "level": 4,
   "text": "De situatie ___ in enkele maanden tijd volledig veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ за несколько месяцев полностью изменилась."
  },
  {
   "id": "l4-427",
   "level": 4,
   "text": "Wij ___ verschillende deskundigen ingeschakeld om het probleem nader te onderzoeken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ingeschakeld",
   "rule": "transitief",
   "translationRu": "Мы ___ привлекли нескольких экспертов, чтобы подробнее изучить проблему."
  },
  {
   "id": "l4-428",
   "level": 4,
   "text": "Hij ___ na zijn pensionering een nieuwe carrière begonnen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "begonnen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после выхода на пенсию начал новую карьеру."
  },
  {
   "id": "l4-429",
   "level": 4,
   "text": "De onderzoekers ___ gedurende meerdere jaren gegevens verzameld voordat zij conclusies trokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verzameld",
   "rule": "transitief",
   "translationRu": "Исследователи ___ на протяжении многих лет собирали данные, прежде чем сделали выводы."
  },
  {
   "id": "l4-430",
   "level": 4,
   "text": "Zij ___ zich tijdens de onderhandelingen niet laten beïnvloeden door de druk van buitenaf.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "laten beïnvloeden",
   "rule": "groeps-inf",
   "translationRu": "Она ___ на переговорах не позволила на себя повлиять давлению извне."
  },
  {
   "id": "l4-431",
   "level": 4,
   "text": "Het bedrijf ___ de afgelopen jaren veel geïnvesteerd in duurzame technologie.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "geïnvesteerd in",
   "rule": "transitief",
   "translationRu": "Компания ___ в последние годы много вложила в устойчивые технологии."
  },
  {
   "id": "l4-432",
   "level": 4,
   "text": "Ik ___ na het gesprek mijn oorspronkelijke oordeel herzien.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "herzien",
   "rule": "transitief",
   "translationRu": "Я ___ после разговора пересмотрел своё первоначальное суждение."
  },
  {
   "id": "l4-433",
   "level": 4,
   "text": "Nadat de overeenkomst was afgelopen, ___ beide partijen hun eigen weg gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "weggegaan",
   "rule": "default-hebben",
   "translationRu": "После того как соглашение истекло, обе стороны ___ пошли каждая своим путём."
  },
  {
   "id": "l4-434",
   "level": 4,
   "text": "Wij ___ verschillende voorstellen ingediend voordat het bestuur een keuze maakte.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "ingediend",
   "rule": "transitief",
   "translationRu": "Мы ___ внесли несколько предложений, прежде чем правление сделало выбор."
  },
  {
   "id": "l4-435",
   "level": 4,
   "text": "Zij ___ uiteindelijk besloten de samenwerking met de leverancier te beëindigen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Она ___ в итоге решила прекратить сотрудничество с поставщиком."
  },
  {
   "id": "l4-436",
   "level": 4,
   "text": "De economische situatie ___ sinds het begin van het jaar geleidelijk verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Экономическая ситуация ___ с начала года постепенно улучшалась."
  },
  {
   "id": "l4-437",
   "level": 4,
   "text": "Hij ___ gedurende zijn hele loopbaan nauw met internationale organisaties samengewerkt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "samengewerkt met",
   "rule": "transitief",
   "translationRu": "Он ___ на протяжении всей карьеры тесно сотрудничал с международными организациями."
  },
  {
   "id": "l4-438",
   "level": 4,
   "text": "Ik ___ gisteren een uitgebreid gesprek met de directeur gevoerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gevoerd",
   "rule": "transitief",
   "translationRu": "Я ___ вчера провёл обстоятельную беседу с директором."
  },
  {
   "id": "l4-439",
   "level": 4,
   "text": "De commissie ___ na maanden van onderzoek een aantal ernstige tekortkomingen vastgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "vastgesteld",
   "rule": "transitief",
   "translationRu": "Комиссия ___ после месяцев исследования выявила ряд серьёзных недостатков."
  },
  {
   "id": "l4-440",
   "level": 4,
   "text": "Nadat de resultaten waren bekendgemaakt, ___ de belangstelling voor het onderzoek sterk toegenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "toegenomen",
   "rule": "verandering",
   "translationRu": "После того как результаты были обнародованы, интерес к исследованию ___ сильно вырос."
  },
  {
   "id": "l4-441",
   "level": 4,
   "text": "Wij ___ ons vooraf onvoldoende gerealiseerd hoeveel tijd het project zou kosten.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gerealiseerd",
   "rule": "reflexief",
   "translationRu": "Мы ___ заранее недостаточно представляли, сколько времени займёт проект."
  },
  {
   "id": "l4-442",
   "level": 4,
   "text": "Zij ___ na haar studie jarenlang in verschillende landen gewoond.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gewoond",
   "rule": "transitief",
   "translationRu": "Она ___ после учёбы долгие годы жила в разных странах."
  },
  {
   "id": "l4-443",
   "level": 4,
   "text": "Het bestuur ___ uiteindelijk een compromis voorgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "voorgesteld",
   "rule": "transitief",
   "translationRu": "Правление ___ в итоге предложило компромисс."
  },
  {
   "id": "l4-444",
   "level": 4,
   "text": "Hij ___ zich na het incident volledig uit de discussie teruggetrokken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggetrokken",
   "rule": "reflexief",
   "translationRu": "Он ___ после инцидента полностью вышел из дискуссии."
  },
  {
   "id": "l4-445",
   "level": 4,
   "text": "Ik ___ de afgelopen maanden veel meer verantwoordelijkheid gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Я ___ за последние месяцы получил гораздо больше ответственности."
  },
  {
   "id": "l4-446",
   "level": 4,
   "text": "De onderzoekers ___ verschillende nieuwe technieken toegepast om de gegevens te analyseren.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "toegepast",
   "rule": "transitief",
   "translationRu": "Исследователи ___ применили несколько новых методик для анализа данных."
  },
  {
   "id": "l4-447",
   "level": 4,
   "text": "Nadat de onderhandelingen waren hervat, ___ het vertrouwen tussen beide partijen langzaam teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "После того как переговоры возобновились, доверие между сторонами ___ постепенно вернулось."
  },
  {
   "id": "l4-448",
   "level": 4,
   "text": "Wij ___ gedurende het project regelmatig onze prioriteiten moeten aanpassen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "moeten aanpassen",
   "rule": "groeps-inf",
   "translationRu": "Мы ___ в ходе проекта регулярно были вынуждены корректировать приоритеты."
  },
  {
   "id": "l4-449",
   "level": 4,
   "text": "Zij ___ haar standpunt tijdens het debat overtuigend verdedigd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verdedigd",
   "rule": "transitief",
   "translationRu": "Она ___ свою позицию на дебатах убедительно отстояла."
  },
  {
   "id": "l4-450",
   "level": 4,
   "text": "Het bedrijf ___ na de overname aanzienlijk groter geworden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "geworden",
   "rule": "zijn-blijven",
   "translationRu": "Компания ___ после поглощения значительно выросла."
  },
  {
   "id": "l4-451",
   "level": 4,
   "text": "Ik ___ uiteindelijk besloten om niet op het aanbod in te gaan.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "besloten",
   "rule": "transitief",
   "translationRu": "Я ___ в итоге решил не принимать это предложение."
  },
  {
   "id": "l4-452",
   "level": 4,
   "text": "Hij ___ zijn hele leven geprobeerd om een evenwicht tussen werk en privéleven te vinden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Он ___ всю жизнь пытался найти баланс между работой и личной жизнью."
  },
  {
   "id": "l4-453",
   "level": 4,
   "text": "De organisatie ___ zich de afgelopen jaren steeds meer op internationale samenwerking gericht.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gericht op",
   "rule": "reflexief",
   "translationRu": "Организация ___ в последние годы всё больше ориентировалась на международное сотрудничество."
  },
  {
   "id": "l4-454",
   "level": 4,
   "text": "Nadat de eerste resultaten waren gepubliceerd, ___ verschillende onderzoekers hun eerdere conclusies herzien.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "herzien",
   "rule": "transitief",
   "translationRu": "После публикации первых результатов ___ несколько исследователей пересмотрели свои прежние выводы."
  },
  {
   "id": "l4-455",
   "level": 4,
   "text": "Wij ___ na lang overleg een gezamenlijke verklaring opgesteld.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "opgesteld",
   "rule": "transitief",
   "translationRu": "Мы ___ после долгого обсуждения подготовили совместное заявление."
  },
  {
   "id": "l4-456",
   "level": 4,
   "text": "Zij ___ na de onverwachte uitslag tijdelijk uit haar functie teruggetreden.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggetreden uit",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после неожиданных результатов временно ушла со своей должности."
  },
  {
   "id": "l4-457",
   "level": 4,
   "text": "Het aantal mensen dat gebruikmaakt van de dienst ___ de afgelopen jaren sterk gestegen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gestegen",
   "rule": "verandering",
   "translationRu": "Число людей, пользующихся этой услугой, ___ за последние годы сильно выросло."
  },
  {
   "id": "l4-458",
   "level": 4,
   "text": "Ik ___ verschillende argumenten aangevoerd om mijn beslissing te verdedigen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "aangevoerd",
   "rule": "transitief",
   "translationRu": "Я ___ привёл несколько аргументов в защиту своего решения."
  },
  {
   "id": "l4-459",
   "level": 4,
   "text": "Hij ___ zich tijdens het gesprek bereid getoond om naar kritiek te luisteren.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bereid getoond",
   "rule": "reflexief",
   "translationRu": "Он ___ в ходе разговора проявил готовность прислушаться к критике."
  },
  {
   "id": "l4-460",
   "level": 4,
   "text": "De regering ___ na maanden van discussie eindelijk een besluit genomen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "genomen",
   "rule": "transitief",
   "translationRu": "Правительство ___ после месяцев дискуссий наконец приняло решение."
  },
  {
   "id": "l4-461",
   "level": 4,
   "text": "Wij ___ tijdens de conferentie veel nieuwe contacten gelegd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gelegd",
   "rule": "transitief",
   "translationRu": "Мы ___ на конференции завели много новых контактов."
  },
  {
   "id": "l4-462",
   "level": 4,
   "text": "Zij ___ na het beëindigen van haar studie naar haar geboorteland teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekeerd naar",
   "rule": "default-hebben",
   "translationRu": "Она ___ после окончания учёбы вернулась на родину."
  },
  {
   "id": "l4-463",
   "level": 4,
   "text": "Het probleem ___ veel groter gebleken dan de betrokken partijen aanvankelijk hadden gedacht.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "gebleken",
   "rule": "zijn-blijven",
   "translationRu": "Проблема ___ оказалась гораздо больше, чем заинтересованные стороны думали поначалу."
  },
  {
   "id": "l4-464",
   "level": 4,
   "text": "Ik ___ me de afgelopen tijd steeds meer gaan interesseren voor dit onderwerp.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gaan interesseren",
   "rule": "groeps-inf",
   "translationRu": "Я ___ в последнее время стал всё больше интересоваться этой темой."
  },
  {
   "id": "l4-465",
   "level": 4,
   "text": "Hij ___ zijn oorspronkelijke doel uiteindelijk bereikt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "bereikt",
   "rule": "transitief",
   "translationRu": "Он ___ своей первоначальной цели в итоге достиг."
  },
  {
   "id": "l4-466",
   "level": 4,
   "text": "De organisatie ___ na de fusie volledig veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Организация ___ после слияния полностью изменилась."
  },
  {
   "id": "l4-467",
   "level": 4,
   "text": "Wij ___ de mogelijke gevolgen van tevoren uitgebreid besproken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "besproken",
   "rule": "transitief",
   "translationRu": "Мы ___ возможные последствия заранее подробно обсудили."
  },
  {
   "id": "l4-468",
   "level": 4,
   "text": "Zij ___ ondanks alle bezwaren met de voorgestelde aanpak akkoord gegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "akkoord gegaan",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ несмотря на все возражения согласилась с предложенным подходом."
  },
  {
   "id": "l4-469",
   "level": 4,
   "text": "De onderzoekers ___ een groot aantal documenten bestudeerd voordat ze hun rapport schreven.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "bestudeerd",
   "rule": "transitief",
   "translationRu": "Исследователи ___ изучили большое количество документов, прежде чем написали свой доклад."
  },
  {
   "id": "l4-470",
   "level": 4,
   "text": "Ik ___ na het lezen van de brief anders over de kwestie gaan denken.",
   "answer": "zijn",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gaan denken",
   "rule": "groeps-inf",
   "translationRu": "Я ___ после прочтения письма стал по-другому думать об этом вопросе."
  },
  {
   "id": "l4-471",
   "level": 4,
   "text": "Hij ___ zich jarenlang ingezet voor de verbetering van de arbeidsomstandigheden.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "ingezet voor",
   "rule": "reflexief",
   "translationRu": "Он ___ на протяжении многих лет выступал за улучшение условий труда."
  },
  {
   "id": "l4-472",
   "level": 4,
   "text": "De situatie ___ na de interventie van de overheid aanzienlijk verbeterd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "verbeterd",
   "rule": "verandering",
   "translationRu": "Ситуация ___ после вмешательства правительства значительно улучшилась."
  },
  {
   "id": "l4-473",
   "level": 4,
   "text": "Wij ___ verschillende keren geprobeerd de schade te beperken.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geprobeerd",
   "rule": "transitief",
   "translationRu": "Мы ___ несколько раз пытались ограничить ущерб."
  },
  {
   "id": "l4-474",
   "level": 4,
   "text": "Zij ___ uiteindelijk tot een oplossing gekomen die voor alle betrokkenen aanvaardbaar was.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ в итоге нашла решение, приемлемое для всех заинтересованных."
  },
  {
   "id": "l4-475",
   "level": 4,
   "text": "Het bedrijf ___ zijn strategie aangepast aan de veranderende behoeften van de markt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "aangepast aan",
   "rule": "transitief",
   "translationRu": "Компания ___ свою стратегию адаптировала к меняющимся потребностям рынка."
  },
  {
   "id": "l4-476",
   "level": 4,
   "text": "Ik ___ tijdens de vergadering bewust gezwegen omdat ik eerst meer informatie wilde.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gezwegen",
   "rule": "transitief",
   "translationRu": "Я ___ на заседании сознательно молчал, потому что хотел сначала получить больше информации."
  },
  {
   "id": "l4-477",
   "level": 4,
   "text": "Hij ___ na een lange periode van onzekerheid eindelijk weer vertrouwen gekregen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekregen",
   "rule": "transitief",
   "translationRu": "Он ___ после долгого периода неопределённости наконец снова обрёл уверенность."
  },
  {
   "id": "l4-478",
   "level": 4,
   "text": "De organisatie ___ de afgelopen jaren een indrukwekkende groei doorgemaakt.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "doorgemaakt",
   "rule": "transitief",
   "translationRu": "Организация ___ за последние годы продемонстрировала впечатляющий рост."
  },
  {
   "id": "l4-479",
   "level": 4,
   "text": "Wij ___ na afloop van het onderzoek verschillende aanbevelingen geformuleerd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "geformuleerd",
   "rule": "transitief",
   "translationRu": "Мы ___ по окончании исследования сформулировали ряд рекомендаций."
  },
  {
   "id": "l4-480",
   "level": 4,
   "text": "Zij ___ zich na de kritiek publiekelijk verdedigd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verdedigd",
   "rule": "reflexief",
   "translationRu": "Она ___ после критики публично защищалась."
  },
  {
   "id": "l4-481",
   "level": 4,
   "text": "Het aantal bezoekers ___ sinds de opening van het nieuwe museum sterk toegenomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "toegenomen",
   "rule": "verandering",
   "translationRu": "Число посетителей ___ с момента открытия нового музея сильно выросло."
  },
  {
   "id": "l4-482",
   "level": 4,
   "text": "Ik ___ mijn oorspronkelijke beslissing later toch betreurd.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "betrreurd",
   "rule": "transitief",
   "translationRu": "Я ___ о своём первоначальном решении впоследствии всё же пожалел."
  },
  {
   "id": "l4-483",
   "level": 4,
   "text": "Hij ___ na het afronden van zijn studie naar Nederland teruggekeerd.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "teruggekeerd",
   "rule": "default-hebben",
   "translationRu": "Он ___ после окончания учёбы вернулся в Нидерланды."
  },
  {
   "id": "l4-484",
   "level": 4,
   "text": "De commissie ___ alle beschikbare informatie zorgvuldig tegen elkaar afgewogen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "afgewogen",
   "rule": "transitief",
   "translationRu": "Комиссия ___ всю доступную информацию тщательно сопоставила."
  },
  {
   "id": "l4-485",
   "level": 4,
   "text": "Wij ___ gedurende het hele proces regelmatig van strategie veranderd.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "veranderd",
   "rule": "verandering",
   "translationRu": "Мы ___ на протяжении всего процесса регулярно меняли стратегию."
  },
  {
   "id": "l4-486",
   "level": 4,
   "text": "Zij ___ na de laatste vergadering niet meer op het onderwerp teruggekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "teruggekomen op",
   "rule": "vaste-zijn",
   "translationRu": "Она ___ после последнего заседания больше не возвращалась к этой теме."
  },
  {
   "id": "l4-487",
   "level": 4,
   "text": "Het bedrijf ___ ondanks de onzekerheid verder blijven investeren.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "blijven investeren",
   "rule": "groeps-inf",
   "translationRu": "Компания ___ несмотря на неопределённость продолжала инвестировать."
  },
  {
   "id": "l4-488",
   "level": 4,
   "text": "Ik ___ me tijdens het onderzoek bewust geworden van een belangrijk probleem.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "bewust geworden van",
   "rule": "reflexief",
   "translationRu": "Я ___ в ходе исследования осознал одну важную проблему."
  },
  {
   "id": "l4-489",
   "level": 4,
   "text": "Hij ___ na de onderhandelingen met een concreet voorstel gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Он ___ после переговоров пришёл с конкретным предложением."
  },
  {
   "id": "l4-490",
   "level": 4,
   "text": "De onderzoekers ___ hun oorspronkelijke hypothese uiteindelijk verworpen.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "np-pl",
   "participle": "verworpen",
   "rule": "transitief",
   "translationRu": "Исследователи ___ свою первоначальную гипотезу в итоге отвергли."
  },
  {
   "id": "l4-491",
   "level": 4,
   "text": "Wij ___ na jaren van samenwerking een sterke professionele relatie opgebouwd.",
   "answer": "hebben",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "opgebouwd",
   "rule": "transitief",
   "translationRu": "Мы ___ за годы сотрудничества выстроили крепкие профессиональные отношения."
  },
  {
   "id": "l4-492",
   "level": 4,
   "text": "Zij ___ na het incident enkele weken niet op kantoor verschenen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "verschenen",
   "rule": "verandering",
   "translationRu": "Она ___ после инцидента несколько недель не появлялась в офисе."
  },
  {
   "id": "l4-493",
   "level": 4,
   "text": "De situatie ___ door een combinatie van economische en politieke factoren ontstaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "ontstaan",
   "rule": "verandering",
   "translationRu": "Ситуация ___ возникла из-за сочетания экономических и политических факторов."
  },
  {
   "id": "l4-494",
   "level": 4,
   "text": "Ik ___ mijn mening pas gewijzigd nadat ik alle beschikbare informatie had gelezen.",
   "answer": "hebben",
   "forms": {
    "hebben": "heb",
    "zijn": "ben"
   },
   "subject": "ik",
   "participle": "gewijzigd",
   "rule": "transitief",
   "translationRu": "Я ___ своё мнение изменил только после того, как прочитал всю доступную информацию."
  },
  {
   "id": "l4-495",
   "level": 4,
   "text": "Hij ___ zich uiteindelijk neergelegd bij de beslissing van de rechtbank.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "hij",
   "participle": "neergelegd bij",
   "rule": "reflexief",
   "translationRu": "Он ___ в итоге смирился с решением суда."
  },
  {
   "id": "l4-496",
   "level": 4,
   "text": "De organisatie ___ verschillende initiatieven gestart om jongeren bij het project te betrekken.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gestart",
   "rule": "transitief",
   "translationRu": "Организация ___ запустила несколько инициатив, чтобы привлечь молодёжь к проекту."
  },
  {
   "id": "l4-497",
   "level": 4,
   "text": "Wij ___ na een lange discussie tot de conclusie gekomen dat uitstel onvermijdelijk was.",
   "answer": "zijn",
   "forms": {
    "hebben": "hebben",
    "zijn": "zijn"
   },
   "subject": "wij",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "Мы ___ после долгого обсуждения пришли к выводу, что отсрочка неизбежна."
  },
  {
   "id": "l4-498",
   "level": 4,
   "text": "Zij ___ gedurende haar carrière steeds nieuwe uitdagingen aangegaan.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "zij-sg",
   "participle": "aangegaan",
   "rule": "default-hebben",
   "translationRu": "Она ___ на протяжении своей карьеры постоянно бралась за новые вызовы."
  },
  {
   "id": "l4-499",
   "level": 4,
   "text": "Het bedrijf ___ zich ondanks de moeilijke omstandigheden weten te handhaven.",
   "answer": "hebben",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "het",
   "participle": "weten te handhaven",
   "rule": "groeps-inf",
   "translationRu": "Компания ___ несмотря на сложные обстоятельства сумела удержаться на плаву."
  },
  {
   "id": "l4-500",
   "level": 4,
   "text": "Nadat alle betrokken partijen hun standpunt hadden toegelicht, ___ de commissie uiteindelijk tot een breed gedragen besluit gekomen.",
   "answer": "zijn",
   "forms": {
    "hebben": "heeft",
    "zijn": "is"
   },
   "subject": "np-sg",
   "participle": "gekomen",
   "rule": "vaste-zijn",
   "translationRu": "После того как все заинтересованные стороны изложили свои позиции, комиссия ___ в итоге пришла к решению, получившему широкую поддержку."
  }
 ]
}